/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface IrDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback","statelessVolumeButtonWithRepetition.volumeUp":4,"statelessVolumeButtonWithRepetition.volumeDown":5}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDevice[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
  /**
   * Room that the device is in
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * If this is an Air Conditioner, the minimum temperature allowed
   * @example 0
   */
  minValue?: number;
  /**
   * If this is an Air Conditioner, the maximum temperature allowed
   * @example 30
   */
  maxValue?: number;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrChildDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

/** A paginated array of devices. */
export interface PagedIRDevices {
  items?: IrDevice[];
  _links?: Links;
}

/** A paginated array of devices. */
export interface PagedIRChildDevices {
  items?: IrChildDevice[];
  _links?: Links;
}

/** Creating an IR device. Note - Either (ocfDeviceType) OR (mnId and onboardingId) must be provided. */
export interface CreateIrDevice {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F"
   */
  mnId?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * @example {"statelessPowerToggleButton.powerToggle":{"power":"toggle"},"statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   * @example {"mac":"00000110","did":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","pid":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","cookie":"base64(cookie)"}
   */
  metadata?: Record<string, object>;
  /** The desired state of an Air Conditioner */
  acState?: AcState;
  /**
   * The Room id that the device should be associated with
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrUpdateRequest {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs.
   * These sholud be comprised of all capabilities of the ir device.
   * All existing values will be overwritten.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * All existing values will be overwritten
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export type DevTypes = {
  /**
   * The id of the device type
   * @example "15"
   */
  devTypeId?: string;
  /**
   * The name of the device type
   * @example "DVD播放机"
   */
  devTypeName?: string;
}[];

export type Brands = {
  /**
   * The name of the brand
   * @example "长虹电视"
   */
  brand?: string;
  /**
   * Id for the brand
   * @example "6"
   */
  brandId?: string;
  /**
   * English translation of the brand (This appears to be empty in all examples provided)
   * @example ""
   */
  enBrand?: string;
  /**
   * TODO
   * @example "0"
   */
  famousStatus?: string;
}[];

export type Channels = {
  /**
   * Channel name
   * @example "中央一套"
   */
  name?: string;
  /**
   * Channel serial number
   * @example 1
   */
  serialNum?: number;
}[];

/** The function you are executing. Note - either (irCodeId & function) OR (ircode) are required. irCodeId & function are for preset function, irCode for custom function */
export interface Function {
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
  /**
   * The IR code ID of a preset function
   * @example "5681"
   */
  irCodeId?: string;
  /**
   * The preset function (object or string)
   * @example {"function":"ok"}
   */
  function?: object;
  /**
   * The learned custom IR code
   * @example "26009...00029"
   */
  irCode?: string;
  /**
   * The ocf device type of the child device
   * @example "oic.d.airconditioner"
   */
  ocfDeviceType?: string;
  /** The initial state of an AC device */
  initialAcState?: {
    /**
     * Power status of the device
     * @example "ON"
     */
    powerState?: string;
    /**
     * Air Conditioner mode
     * @example "heat"
     */
    mode?: string;
    /**
     * Fan speed
     * @example "auto"
     */
    windSpeed?: string;
    /**
     * The temperature the device should be at
     * @example 19
     */
    fixedTargetTemperature?: number;
  };
}

/** The Function you want to update. */
export interface DevicePatch {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * These should be comprised of capabilities that will be added to existing capabilities.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * @example {"button.color":"blue","button.icon":"button.jpg"}
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

/** Data pertaining to the device that will be put in a learning state */
export interface IrLearningRequest {
  /**
   * The PID of the device you want to put in a learning state
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
}

/** The desired state of an Air Conditioner */
export interface AcState {
  /**
   * The maximum temperature setting
   * @example 30
   */
  maxTemp?: number;
  /**
   * The minimum temperature setting
   * @example 16
   */
  minTemp?: number;
  /**
   * The temperature unit
   * @example "C"
   */
  unit?: string;
  /**
   * The temperature increment value
   * @example 1
   */
  step?: number;
  /**
   * The temperature value
   * @example 19
   */
  coolingSetpoint?: number;
  /**
   * The power state of the AC device
   * @example "ON"
   */
  powerState?: 'ON' | 'OFF';
  /**
   * The mode of the AC device
   * @example "AUTO"
   */
  mode?: string;
  /**
   * The fan speed of the AC device
   * @example "AUTO"
   */
  windspeed?: string;
}

export type IrCodes = {
  /** List of IR Codes */
  irCode?: {
    /**
     * The IR Code value
     * @example "26009...00029"
     */
    code?: string;
    /**
     * The description of the IR Code function
     * @example "打开空调，制冷，25度，风速2"
     */
    desc?: string;
    /**
     * The function name
     * @example "powerState"
     */
    function?: string;
    /**
     * Appears to have the same info as 'desc'
     * @example "打开空调"
     */
    name?: string;
  }[];
  /**
   * IR Code Id
   * @example "5789"
   */
  irCodeId?: string;
  /**
   * TODO
   * @example "000000000000000000000000c2050100"
   */
  pid?: string;
  /**
   * TODO
   * @example "1535607964"
   */
  timestamp?: string;
  /** The various possible values for an AC device only. Appears to be an empty object for non-AC devices */
  acState?: {
    /**
     * Max temperature for AC in Celsius
     * @example 30
     */
    maxTemp?: number;
    /**
     * Minimum temperature for AC in Celsius
     * @example 16
     */
    minTemp?: number;
    /**
     * Power states available
     * @example ["ON","OFF"]
     */
    powerState?: string[];
    /**
     * The list of modes of the AC
     * @example ["AUTO","COLD","DEHUMI","VENT","HEAT"]
     */
    model?: string[];
    /**
     * The list of fan speeds of the AC
     * @example ["AUTO","LOW","MEDIUM","HIGH"]
     */
    windspeed?: string[];
  };
  /**
   * A list of all functions for the IR code. Appears to only show up on TVs
   * @example ["power","mute","tv_av","menu","back","exit","0","1","2","3","4","5","6","7","8","9","channel_up","channel_down","volume_up","volume_down","up","down","right","left","ok"]
   */
  allFunction?: string[];
}[];

/** List of IR Codes with names (Just for AC) */
export type MatchIRCode = {
  /**
   * Name
   * @example "科龙_5693"
   */
  name?: string;
  /**
   * IR Id
   * @example 5693
   */
  irid?: number;
}[];

/** List of Provider Brands */
export type ProviderBrands = {
  /**
   * Provider brand name
   * @example "四川电信4K机顶盒 (Google Translated as Sichuan Telecom 4K set top box)"
   */
  brand?: string;
  /**
   * Provider brand id
   * @example "1223"
   */
  brandId?: string;
}[];

/** Providers under a location */
export type Providers = {
  /**
   * Provider's id
   * @example 38
   */
  providerId?: number;
  /**
   * Name of the provider
   * @example "杭州华数"
   */
  providerName?: string;
  /**
   * English name of the provider (again, always appears to be blank)
   * @example ""
   */
  providerNameEn?: string;
  /**
   * Location id associated with the provider
   * @example 0
   */
  locateId?: number;
  /**
   * Initials of the provider
   * @example "H"
   */
  initials?: string;
  /**
   * Whether the provider has a brand associated (0 = false, 1 = true)
   * @example 1
   */
  hasBrand?: number;
}[];

/** Sub areas under a location */
export type SubAreaInfo = {
  /**
   * Location id
   * @example 92
   */
  locateId?: number;
  /**
   * The level of the location (Country = 1, Province = 2, City = 3)
   * @example 3
   */
  levelId?: number;
  /**
   * Name of the location
   * @example "丽水市"
   */
  name?: string;
  /**
   * Indication of whether or not there are any sub areas under this location (0 = false, 1 = true)
   * @example 1
   */
  isLeaf?: number;
  /**
   * Status of the location
   * @example "正常"
   */
  status?: string;
  /**
   * Initials of the location
   * @example "N"
   */
  initials?: string;
}[];

/**
 * All of the OTA Versions
 * @example {"3":{"versions":[{"version":"20029","url":"google.com","date":"2017-02-28","changelog":{"en":"update","cn":"更新内"}}]}}
 */
export type OTAVersions = Record<
  string,
  {
    versions?: OTAVersion[];
  }
>;

/** OTA Version */
export interface OTAVersion {
  /**
   * OTA Version
   * @example "41024"
   */
  version?: string;
  /**
   * Url to download firmware update
   * @example "http://fwversions.ibroadlink.com/firmware/download/30014/41027.bin"
   */
  url?: string;
  /**
   * date of firmware version
   * @example "2018-03-09T00:00:00Z"
   */
  date?: string;
  /** @example {"en":"updating"} */
  changelog?: Record<string, string>;
}

/** Ota Version for Device */
export interface DeviceOTAVersion {
  /**
   * Version of the device
   * @example 50
   */
  version?: string;
  serverversion?: {
    /**
     * URL of the version
     * @example "https://broadlinkversion.com/version"
     */
    url?: string;
    /**
     * Device Type number
     * @example 10039
     */
    devtype?: string;
    /**
     * Version of the server
     * @example 55
     */
    version?: string;
  };
}

export interface OcfRouteRequest {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /**
   * Observe option
   * @default "NOTHING"
   */
  observeOption: 'SUBSCRIBE' | 'UNSUBSCRIBE' | 'NOTHING';
  /** Request method */
  method: 'GET' | 'PUT' | 'POST';
  /** Path to the resource */
  path: string;
  /** OCF interface */
  query?: string;
  /** The OCF message body in JSON */
  message?: Record<string, object>;
}

export interface OcfRouteResponse {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /** Observe option */
  observeOption?: 'SUBSCRIBE' | 'UNSUBSCRIBE';
  /** The OCF message body in JSON */
  message: object;
  /** Response code from resource server */
  responseCode: string;
  /** Path to the resource */
  path: string;
}

/** something */
export interface DeviceGroupLinks {
  /** @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0" */
  href?: string;
  /** @example "oic.r.switch.binary" */
  rt?: string;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: 'UNDETERMINED' | 'GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING';
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group. Defaults to main if not supplied. */
    components?: {
      id?: string;
    }[];
  }[];
  /** Room containing this device group */
  roomId?: RoomId;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group created */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group. Defaults to main if not supplied. */
    components?: {
      id?: string;
    }[];
  }[];
  /** Room containing this device group */
  roomId?: RoomId;
}

/** A group */
export interface DeviceGroupResponse {
  /** Name of the group */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: 'UNDETERMINED' | 'GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING';
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: Record<string, any>[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /** Room containing this device group */
  roomId?: RoomId;
  /** Lowest common denominator capability of all the devices in the group */
  links: DeviceGroupLinks[];
}

/**
 * Room containing this device group
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type RoomId = string;

export interface OcfDeviceGroupsCommandRequest {
  /**
   * Path to the resource
   * @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0"
   */
  path: string;
  /**
   * The OCF message body in JSON
   * @example {"payload":{"value":true}}
   */
  message?: object;
  /**
   * Request menthod
   * @example "POST"
   */
  method: 'GET' | 'POST';
}

/** @example {"rt":["oic.r.switch.binary"],"id":"0","if":["oic.if.baseline","oic.if.r"],"value":true,"dimmingSetting":23} */
export interface OcfDeviceGroupsCommandResponse {
  rt?: string[];
  id?: string;
  if?: string[];
  value?: boolean;
  dimmingSetting?: number;
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

export type DeviceGroupDeleteResponse = Record<string, any>;

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

/**
 * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
 * useful for filtering.
 *
 * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
 * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
 * * Case sensitive
 * * Maximum number of tags per resource: 25
 * * Reserved prefix — `st:`
 * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
 * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
 * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
 * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
 * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
 * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
 */
export type Tags = Record<string, string>;

/** A request object used to update a resource's tags. */
export interface UpdateTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the updated tags. */
export interface UpdateTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A request object used to update a resource's tags. */
export interface PatchTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  upserts?: Tags;
  removals?: string[];
}

/** A response object containing the updated tags. */
export interface PatchTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the resource's tags. */
export interface GetTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** Entity that created the event. */
export enum DeviceEventSource {
  OCFDEVICE = 'OCFDEVICE',
  HUBDEVICE = 'HUBDEVICE',
  HUB = 'HUB',
  CLOUD = 'CLOUD',
}

/** Represents a single page of Locations available in a user account. */
export interface PagedLocations {
  items: PagedLocation[];
  _links?: Links;
}

/**
 * A slimmed-down representation of the Location model.
 * @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}}
 */
export interface PagedLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent: LocationParent;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface Location {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** @example {"name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface CreateLocationRequest {
  /**
   * A name given to the Location (e.g. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * An ISO Alpha-3 country code (e.g. GBR, USA)
   * @pattern ^[A-Z]{3}$
   */
  countryCode: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800} */
export interface CreateLocationResponse {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
}

/** @example {"latitude":{"toNull":true},"longitude":{"value":50}} */
export interface PatchLocationRequest {
  /** Settings for the geographic latitude. */
  latitude?: {
    /**
     * the new value
     * @min -90
     * @max 90
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the geographic longitude. */
  longitude?: {
    /**
     * the new value
     * @min -180
     * @max 180
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the radius in meters around the latitude and longitude defining the location. */
  regionRadius?: {
    /**
     * the new value
     * @min 20
     * @max 500000
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
}

/** @example {"name":"Home","temperatureScale":"F"} */
export interface UpdateLocationRequest {
  /**
   * A name for the Location.
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface UpdateLocationResponse {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteLocationResponse = object;

/** The parent of a Location */
export interface LocationParent {
  /** The type of the Location's parent. */
  type?: LocationParentTypes;
  /**
   * The ID of the parent
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
}

/**
 * The type of the Location's parent.
 * @minLength 7
 * @maxLength 14
 */
export enum LocationParentTypes {
  LOCATIONGROUP = 'LOCATIONGROUP',
  ACCOUNT = 'ACCOUNT',
}

/** Represents a single page of Rooms available in a Location. */
export interface PagedRooms {
  items: Room[];
  _links?: Links;
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface Room {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface CreateRoomResponse {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface UpdateRoomResponse {
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"name":"Living Room","indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface CreateRoomRequest {
  /**
   * A name for the room (e.g. Living Room)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/** @example {"name":"Living Room","indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface UpdateRoomRequest {
  /**
   * A name for the room.
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** Data used for indoor map related to this room. If this property is not provided or has a null value, then the map data will not be deleted. */
  indoorMap?: {
    /**
     * The reference id for the room map. Setting this property to null disassociates the map from the room.
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteRoomResponse = object;

/** @example {"displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","installedAppType":"WEBHOOK_SMART_APP","configurationStatus":"STAGED","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface CreateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. */
  referenceId?: string;
  /**
   * The ID of the location.  A locationId may or may not be required based on the type of install.
   * @format uuid
   */
  locationId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

/** @example {"displayName":"Color App"} */
export interface UpdateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
}

/** @example {"removals":["temperature_controls","some_other_developer_defined_key"],"upserts":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface PatchInstalledAppRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  upserts?: ConfigMap;
  /** An array of config name's to delete. */
  removals?: string[];
}

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]} */
export interface InstalledApp {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus: InstalledAppStatus;
  /**
   * A user defined name for the installed app. May be null.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
  referenceId?: string;
  /**
   * The ID of the location to which the installed app may belong.
   * @format uuid
   */
  locationId?: string;
  /** A typed model which provides information around ownership of a specific domain. */
  owner: Owner;
  notices: Notice[];
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: {
    /** @format ^[a-zA-Z._]{1,99}$ */
    pluginId?: string;
    /** @format uri */
    pluginUri?: string;
    dashboardCardsEnabled: boolean;
    preInstallDashboardCardsEnabled: boolean;
  };
  /**
   * A default icon image for the app.
   * @example {"url":"https://smart-home-monitor.com/image"}
   */
  iconImage?: {
    /**
     * A default icon image url for an app. https url required.
     * @format uri
     */
    url?: string;
  };
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType: 'LOCATION' | 'USER_LEVEL';
  /** Restriction tier of the install, if any. */
  restrictionTier?: number;
  /**
   * Inform the installation systems that the associated app can only be installed once within a user's account.
   * @default false
   */
  singleInstance: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   * <ul>
   * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
   * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
   * </ul>
   */
  allowed?: string[];
}

/**
 * An empty object request.
 * @example {}
 */
export type InitializeUpdateFlowRequest = object;

/** Initialize update flow response. */
export interface InitializeUpdateFlowResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

/**
 * An configuration instance of an Installed App.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"DONE","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"}
 */
export interface InstallConfiguration {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * Encompasses both a configuration value, and any required permissions that maybe needed.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"AUTHORIZED","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"main","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}}]}}
 */
export interface InstallConfigurationDetail {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** @example {"config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface UpdateInstallConfigurationRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config: ConfigMap;
}

/**
 * Initialize request.
 * @example {"appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a"}
 */
export interface InitializeRequest {
  /** The ID of the app. */
  appId: string;
  /**
   * A user defined name for the installed app. Only used for a new installed app.
   * @maxLength 100
   */
  displayName?: string;
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
}

/** Initialize response. */
export interface InitializeResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

export interface CancelRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type CancelResponse = object;

/**
 * A simple string configuration.
 * @example {"value":"31192dc9-eb45-4d90-b606-21e9b66d8c2b"}
 */
export interface StringConfig {
  /**
   * A config value
   * @maxLength 2048
   */
  value?: string;
}

/**
 * A device and component configuration with any required permissions.
 * @example {"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}
 */
export interface DeviceConfig {
  /**
   * The ID of the device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * The component ID on the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * Required permissions for the installed app.
 * @example {"permissions":["w:notifications","r:devices:*"]}
 */
export interface PermissionConfig {
  /**
   * @maxItems 25
   * @minItems 1
   */
  permissions?: string[];
}

/**
 * A mode configuration.
 * @example {"modeId":"9206ea57-2e2e-414c-a792-9087117ca3d8"}
 */
export interface ModeConfig {
  /**
   * The ID of the mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
}

/**
 * A scene configuration.
 * @example {"sceneId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["x:scences:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface SceneConfig {
  /**
   * The ID of the scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A message configuration.
 * @example {"messageGroupKey":"leaks"}
 */
export interface MessageConfig {
  /**
   * The key value of the message group.
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A room configuration.
 * @example {"roomId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["r:locations:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface RoomConfig {
  /**
   * The ID of the room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A configuration value type and the correspodning configuration.
 * @example {"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}
 */
export interface ConfigEntry {
  /** The value type. */
  valueType?: 'STRING' | 'DEVICE' | 'PERMISSION' | 'MODE' | 'SCENE' | 'MESSAGE' | 'ROOM';
  /** The config if valueType is STRING, meaningless otherwise */
  stringConfig?: StringConfig;
  /** The config if valueType is DEVICE, meaningless otherwise */
  deviceConfig?: DeviceConfig;
  /** The config if valueType is PERMISSION, meaningless otherwise */
  permissionConfig?: PermissionConfig;
  /** The config if valueType is MODE, meaningless otherwise */
  modeConfig?: ModeConfig;
  /** The config if valueType is SCENE, meaningless otherwise */
  sceneConfig?: SceneConfig;
  /** The config if valueType is MESSAGE, meaningless otherwise */
  messageConfig?: MessageConfig;
  /** The config if valueType is ROOM, meaningless otherwise */
  roomConfig?: RoomConfig;
}

/** A list of available configuration values. */
export type ConfigEntries = ConfigEntry[];

/**
 * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
 * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
 * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
 * @example {"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}]}
 */
export type ConfigMap = Record<string, ConfigEntries>;

/** Denotes the type of installed app. */
export enum InstalledAppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
  BEHAVIOR = 'BEHAVIOR',
  API_ONLY = 'API_ONLY',
}

/**
 * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
 * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
 * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
 * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
 * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
 */
export enum InstallConfigurationStatus {
  STAGED = 'STAGED',
  DONE = 'DONE',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
}

/**
 * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
 * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
 * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
 * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
 * 'AUTHORIZED' Installed App will not execute.
 */
export enum InstalledAppStatus {
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
  DISABLED = 'DISABLED',
}

/** A composite model to provide both the details of an InstalledApp and the current configuration. */
export interface InstalledAppComposite {
  installedApp?: InstalledApp;
  /** Encompasses both a configuration value, and any required permissions that maybe needed. */
  configurationDetail?: InstallConfigurationDetail;
}

/** Represents a single page of InstalledApps available in a user account. */
export interface PagedInstalledApps {
  items?: InstalledApp[];
  _links?: Links;
}

/** @example {"installable":true} */
export interface CanInstallAppResponse {
  /**
   * Will be set to true if the provided App can be installed.
   * @default false
   */
  installable?: boolean;
}

/** A response containing details about the bearer token. */
export interface InstalledAppMeResponse {
  /**
   * The installedapp identifier.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The location identifier.
   * @format uuid
   */
  locationId?: string;
  /** A unique set of the OAuth scope associated with the bearer token. */
  scope?: string[];
}

/** Represents a single page of InstallConfiguration models available for an InstalledApp. */
export interface PagedInstallConfigurations {
  items?: InstallConfiguration[];
  _links?: Links;
}

/** The number of deleted installed apps. */
export interface DeleteInstalledAppResponse {
  /** @format int32 */
  count?: number;
}

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","permissions":["r:devices:416747c2-ac57-4f49-8d01-aff1094dee61","r:devices:656382bd-b125-4ade-a429-193fb3e7900d","w:devices:656382bd-b125-4ade-a429-193fb3e7900d","l:devices"]} */
export interface InstallConfigurationPermissionResponse {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /** A unique set of the OAuth scope required for a specific install configuration. */
  permissions?: string[];
}

export interface Notice {
  /**
   * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
   * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
   * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
   */
  code?: NoticeCode;
  /** The url of the badge icon for the notice card */
  badgeUrl?: string;
  /** The localized message to be displayed */
  message?: string;
  /** The action(s) a user can take to resolve this notice */
  actions?: NoticeAction[];
}

/**
 * An action the user can take to resolve a notice
 * @default "none"
 */
export enum NoticeAction {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  NONE = 'NONE',
}

/**
 * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
 * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
 * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
 */
export enum NoticeCode {
  USER_PAUSE = 'USER_PAUSE',
  REVISIT = 'REVISIT',
  RECONFIGURE = 'RECONFIGURE',
}

export interface Event {
  /**
   * Unique ID of the event.
   * @format uuid
   */
  id?: string;
  /** UNIX timestamp of the server. */
  serverTime?: string;
  /** ID of the location that this event relates to. */
  locationId: string;
  /** Name of the event. */
  name?: string;
  /** Whether the state is changed. */
  stateChange?: boolean;
  /** Whether this event is intended for mobile app UI display */
  displayed?: boolean;
  /**
   * UNIX timestamp of the provider when the event was created
   * @format int64
   */
  providerTime?: number;
  /** Internal event ID from provider */
  providerEventId?: string;
  /** Raw message as debugging reference */
  rawMessage?: string;
  /** Tracking IDs used to track relationship between events */
  trackingIds?: string[];
  /** Body of the legacy event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  legacyEvent?: LegacyEvent;
  /** Body of the device event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  deviceEvent?: DeviceEvent;
  /** Body of the timer event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  timerEvent?: TimerEvent;
  modeEvent?: ModeEvent;
  /**
   * If status is not `OFFLINE` or if the reason is `SERVICE_UNAVAILABLE` then `hubId` is optional, otherwise a `hubId` must
   * be provided. Further, if the `status` is `OFFLINE` then `reason` is required. If the `status` is not `OFFLINE` a `reason` must
   * not be provided.
   */
  deviceHealthEvent?: DeviceHealthEvent;
  /** If status is offline, reason can't be `NONE`. For any other status, reason has to be `NONE` */
  hubHealthEvent?: HubHealthEvent;
  hubDeviceDiscoveryEvent?: HubDeviceDiscoveryEvent;
  deviceCommandsEvent?: DeviceCommandsEvent;
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  deviceLogEvent?: DeviceLogEvent;
  installedAppLifecycleEvent?: InstalledAppLifecycleEvent;
  /** A capability lifecycle event. At least one of `create`, `update`, `delete`, `localizationChange` and `statusChange` must be set and value should not be null. */
  capabilityLifecycleEvent?: CapabilityLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
  /** An event which can be used to broadcast custom triggers from SmartApps. */
  smartAppEvent?: SmartAppEvent;
  /** An event used to trigger a client action on a SmartApp dashboard card. */
  smartAppDashboardCardEvent?: SmartAppDashboardCardEvent;
  /** An event that represents a change in the arm state of a security system. */
  securityArmStateEvent?: SecurityArmStateEvent;
  /** An event that represents a failure to change the arm state of a security system. */
  securityArmFailureEvent?: SecurityArmFailureEvent;
  /** An event that represents a SOS event has occured for a security system. */
  securitySosEvent?: SecuritySosEvent;
  /** An event that represents a quarantine state change for an entity. */
  quarantineEvent?: QuarantineEvent;
  /** An event representing the current weather forecast. */
  weatherEvent?: WeatherEvent;
  /** A GeoPlace lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. There must also be either a user or service value set and not null. A GeoPlaceLifecycleEvent should typically not have a locationId in the event wrapper object. */
  geoPlaceLifecycleEvent?: GeoPlaceLifecycleEvent;
  /** A rule lifecycle event. */
  ruleLifecycleEvent?: RuleLifecycleEvent;
  /** Schema that is registered in the system */
  schemaUri?: string;
}

/** Body of the device event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface DeviceEvent {
  /** Unique ID of a registered device in the cloud. The device must have already been registered with the system and assigned this ID. */
  deviceId?: string;
  /** ID of the device type. The service that registers the device must have looked up that device type ID prior to registration. */
  deviceTypeId?: string;
  /**
   * ID for what owns the device event. Works in tandem with `ownerType` as a composite identifier.
   * A DeviceEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** ID (componentName) of the component. Default component is 'main'. */
  component?: string;
  /** Localizable human readable title for the event. */
  linkText?: string;
  /** (TBD) Capability that this event relates to. */
  capability?: string;
  /** The capabilities for attributes that are related to multiple capabilities. */
  capabilities?: string[];
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. */
  value?: string;
  /** any JSON type wrapped in a single element array to allow for top level primitives. */
  valueJson?: string;
  /** Unit of the value field. Must be defined in the capability model. */
  unit?: string;
  /** ID of the hub that the device is connected to. Hub must have already been registered with the system. */
  hubId?: string;
  /** Localizable human readable description of the event. */
  descriptionText?: string;
  /** Serial number, IMEI, MAC address or other unique identifier of the device. */
  providerDeviceId?: string;
  /** Entity that created the event. */
  source?: DeviceEventSource;
  /**
   * When user-level devices have been shared to multiple locations, this will be `true` when the event is on the
   * user's "primary" shard.
   * @default false
   */
  primaryEvent?: boolean;
  /**
   * Identifier to ensure uniquness of events across multiple shards, when used by global services that consume
   * those events. Required if `sharedLocations` or `globalSharedLocations` are provided.
   * @format uuid
   */
  sourceEventId?: string;
  /**
   * Locations that the event was created in for the current shard.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard. If used, `sourceEventId` is required.
   */
  sharedLocations?: EventSharedLocation[];
  /**
   * Locations that the event was created in for all other shards.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard. If used, `sourceEventId` is required.
   */
  globalSharedLocations?: EventSharedLocation[];
}

/**
 * User-level DeviceEvents and DeviceLifecycleEvents can be shared into multiple locations. Each location is
 * defined by the shard it lives within plus its actual identifier.
 */
export interface EventSharedLocation {
  /**
   * Identifier of containing shard. Example: `na01`
   * @pattern ^\w{2}\d{2}\w*$
   * @example "na01"
   */
  shardId?: string;
  /**
   * Identifier of location being shared.
   * @format uuid
   */
  locationId?: string;
}

/** Body of the legacy event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface LegacyEvent {
  /** Entity that created the event */
  source?: LegacyEventSource;
  /** Localizable human readable title for the event. */
  linkText?: string;
  /** (TBD) Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Name of the component that this event relates to. */
  component?: string;
  /** Value associated with the event. */
  value?: string;
  /** Unit of the value field. Must be defined in the capability model. */
  unit?: string;
  /** True if the event should NOT be archived, defaults to false. */
  nonArchivable?: boolean;
  /** (TBD) */
  type?: string;
  /** (TBD) Event type. */
  eventType?: string;
  /** (TBD) Event data. */
  data?: string;
  /**
   * ID of command sent from a mobile app.
   * @format int32
   */
  commandId?: number;
  /** ID of the hub that the device is connected to. Hub must have already been registered with the system. */
  hubId?: string;
  /** (TBD) ID of the group that the device is related to. */
  groupId?: string;
  /** Unique ID of a registered device in the cloud. The device must have already been registered with the system and assigned this ID. */
  deviceId?: string;
  /** If this is a component event, then set the id of the parent device that kicked off the event. */
  parentDeviceId?: string;
  /** ID of the device type. The service that registers the device must have looked up that device type ID prior to registration. */
  deviceTypeId?: string;
  /** GUID for Object instance of SmartApp install unique to location installation. */
  installedDeviceId?: string;
  /** GUID for SmartApp class/code. */
  smartAppId?: string;
  /** Version of the smart app "class". */
  smartAppVersionId?: string;
  /** GUID for Object instance of SmartApp install unique to location installation. */
  installedSmartAppId?: string;
  /** Two-tiered hierarchy for Smartapps (allows parent/child). References parent installed app instance. */
  installedSmartAppParentId?: string;
  /** (TBD) */
  userID?: string;
  /** (TBD) */
  description?: string;
  /** Localizable human readable description of the event. */
  descriptionText?: string;
  /** The name of the legacy handler associated with the event. */
  handlerName?: string;
  /** (TBD) */
  triggeredBy?: string;
  /** Flag to indicate whether the descriptionText should be translated or not. */
  translatable?: boolean;
  /** Templateable message arguments for localization service. */
  messageArgs?: string;
  /** Event ID that triggered the generation of this event */
  triggerEventId?: string;
  /** (TBD) */
  virtualHub?: boolean;
  /** ID of the account that this event relates to. */
  accountId?: string;
}

/** Body of the timer event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface TimerEvent {
  /** (TBD) */
  type?: TimerEventType;
  /** ID of the installed app that created and is the target of the schedule. */
  installedAppId?: string;
  /**
   * ID for what owns the timer event. Works in tandem with `ownerType` as a composite identifier.
   * A TimerEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /**
   * UNIX timestamp of the time the event was triggered.
   * @format int64
   */
  time?: number;
  /** Cron expression that was in effect at time of event creation. */
  expression?: string;
}

/** (TBD) */
export enum TimerEventType {
  NONE = 'NONE',
  CRON = 'CRON',
  ONCE = 'ONCE',
}

/**
 * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
 * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
 * * `USER` A user-level event, where the user can be found in `ownerId`.
 * @default "LOCATION"
 */
export enum EventOwnerType {
  LOCATION = 'LOCATION',
  USER = 'USER',
}

/** Entity that created the event */
export enum LegacyEventSource {
  NONE = 'NONE',
  HUB = 'HUB',
  DEVICE = 'DEVICE',
  DEVICE_COMMAND = 'DEVICE_COMMAND',
  LOCATION = 'LOCATION',
  COMMAND = 'COMMAND',
  APP = 'APP',
  APP_COMMAND = 'APP_COMMAND',
  USER = 'USER',
  ROOM = 'ROOM',
}

export interface ModeEvent {
  /** The ID of the event. */
  eventId?: string;
  /** The name of the MODE_EVENT. */
  name?: string;
  /** The ID of the mode associated with a MODE_EVENT. */
  modeId?: string;
}

/**
 * If status is not `OFFLINE` or if the reason is `SERVICE_UNAVAILABLE` then `hubId` is optional, otherwise a `hubId` must
 * be provided. Further, if the `status` is `OFFLINE` then `reason` is required. If the `status` is not `OFFLINE` a `reason` must
 * not be provided.
 */
export interface DeviceHealthEvent {
  deviceId: string;
  hubId?: string;
  /** ID for what owns the device health event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  status?: DeviceHealthStatus;
  reason?: DeviceHealthOfflineReason;
  /** Entity that created the event. */
  eventSource?: DeviceEventSource;
}

export enum DeviceHealthStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNHEALTHY = 'UNHEALTHY',
}

export enum DeviceHealthOfflineReason {
  NONE = 'NONE',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  HUB_OFFLINE = 'HUB_OFFLINE',
  ZWAVE_OFFLINE = 'ZWAVE_OFFLINE',
  ZIGBEE_OFFLINE = 'ZIGBEE_OFFLINE',
  BLUETOOTH_OFFLINE = 'BLUETOOTH_OFFLINE',
}

/** If status is offline, reason can't be `NONE`. For any other status, reason has to be `NONE` */
export interface HubHealthEvent {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  hubId: string;
  status?: HubHealthStatus;
  reason: HubHealthOfflineReason;
}

export enum HubHealthStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  ZWAVE_OFFLINE = 'ZWAVE_OFFLINE',
  ZWAVE_ONLINE = 'ZWAVE_ONLINE',
  ZIGBEE_OFFLINE = 'ZIGBEE_OFFLINE',
  ZIGBEE_ONLINE = 'ZIGBEE_ONLINE',
  BLUETOOTH_OFFLINE = 'BLUETOOTH_OFFLINE',
  BLUETOOTH_ONLINE = 'BLUETOOTH_ONLINE',
}

export enum HubHealthOfflineReason {
  NONE = 'NONE',
  DISCONNECTED = 'DISCONNECTED',
  INACTIVE = 'INACTIVE',
}

export interface HubDeviceDiscoveryEvent {
  hubId?: string;
  mac?: string;
  networkAddress?: string;
  deviceAddress?: string;
  ssdp?: SsdpDiscovery;
  mndns?: MdnsDiscovery;
}

export interface SsdpDiscovery {
  path?: string;
  USN?: string;
  ST?: string;
  NTS?: string;
}

export interface MdnsDiscovery {
  path?: string;
}

export interface DeviceCommandsEvent {
  /** The guid of the device that the cammands are for. */
  deviceId?: string;
  /** The guid of the installed app that will process the commands for endpoint app managed devices. */
  installedAppId?: string;
  commands?: DeviceCommandsEventCommand[];
}

export interface DeviceCommandsEventCommand {
  component?: string;
  capability?: string;
  command?: string;
  arguments?: object[];
}

/** A rule lifecycle event. */
export interface RuleLifecycleEvent {
  /**
   * The rule lifecycle. The lifecycle will be one of:
   * * CREATE - Invoked when a rule is created.
   * * UPDATE - Invoked when a rule is updated.
   * * DELETE - Invoked when a rule is deleted.
   * * EXECUTE - Invoked when a rule is executed.
   * * CREATE_FOR_BIXBY - Invoked when a rule is created for Bixby.
   * * UPDATE_FOR_BIXBY - Invoked when a rule is updated for Bixby.
   * * DELETE_FOR_BIXBY - Invoked when a rule is deleted for Bixby.
   */
  lifecycle?: RuleLifecycle;
  /** The id of the event. */
  eventId?: string;
  /**
   * The id of the location in which the event was triggered.
   *
   * This field is not used or populated for user-level events.
   *
   * Location id may also be sent in `ownerId` with `ownerType` = `LOCATION`.
   */
  locationId?: string;
  /** ID for what owns the rule lifecyle event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** The id of the rule. */
  ruleId?: string;
  /** The version of the rule. */
  version?: string;
  /** Create rule lifecycle. */
  create?: RuleLifecycleCreate;
  /** Update rule lifecycle. */
  update?: RuleLifecycleUpdate;
  /** Delete rule lifecycle. */
  delete?: RuleLifecycleDelete;
  /** Execute rule lifecycle. */
  execute?: RuleLifecycleExecute;
  /** Create rule lifecycle for bixby. */
  createForBixby?: RuleLifecycleCreateForBixby;
  /** Update rule lifecycle for bixby. */
  updateForBixby?: RuleLifecycleUpdateForBixby;
  /** Delete rule lifecycle for bixby. */
  deleteForBixby?: RuleLifecycleDeleteForBixby;
}

/**
 * The rule lifecycle. The lifecycle will be one of:
 * * CREATE - Invoked when a rule is created.
 * * UPDATE - Invoked when a rule is updated.
 * * DELETE - Invoked when a rule is deleted.
 * * EXECUTE - Invoked when a rule is executed.
 * * CREATE_FOR_BIXBY - Invoked when a rule is created for Bixby.
 * * UPDATE_FOR_BIXBY - Invoked when a rule is updated for Bixby.
 * * DELETE_FOR_BIXBY - Invoked when a rule is deleted for Bixby.
 */
export enum RuleLifecycle {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EXECUTE = 'EXECUTE',
  CREATE_FOR_BIXBY = 'CREATE_FOR_BIXBY',
  UPDATE_FOR_BIXBY = 'UPDATE_FOR_BIXBY',
  DELETE_FOR_BIXBY = 'DELETE_FOR_BIXBY',
}

/** Create rule lifecycle. */
export interface RuleLifecycleCreate {
  /** The entities that trigger rule execution. */
  triggers?: Triggers;
}

/** Update rule lifecycle. */
export interface RuleLifecycleUpdate {
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  /** A Location Lifecycle Event. */
  locationLifecycleEvent?: LocationLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
  /** The entities that trigger rule execution. */
  triggers?: Triggers;
}

/** Delete rule lifecycle. */
export interface RuleLifecycleDelete {
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  /** A Location Lifecycle Event. */
  locationLifecycleEvent?: LocationLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
}

/** Create rule lifecycle for bixby. */
export type RuleLifecycleCreateForBixby = object;

/** Update rule lifecycle for bixby. */
export type RuleLifecycleUpdateForBixby = object;

/** Delete rule lifecycle for bixby. */
export type RuleLifecycleDeleteForBixby = object;

/** Execute rule lifecycle. */
export type RuleLifecycleExecute = object;

/** The entities that trigger rule execution. */
export interface Triggers {
  /** The devices that trigger rule execution. */
  devices?: Devices;
}

/** The devices that trigger rule execution. */
export type Devices = DeviceTrigger[];

/** One of the devices that trigger a rule execution. */
export interface DeviceTrigger {
  /**
   * Device ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /** Device component */
  component?: string;
  /** Device capability */
  capability?: string;
  /** Device attribute */
  attribute?: string;
}

/** A Location Lifecycle Event. */
export interface LocationLifecycleEvent {
  /** The id of the event. */
  eventId?: string;
  /**
   * The ID of the location in which the event was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  lifecycle?: LocationLifecycle;
  modeCreate?: LocationLifecycleModeCreate;
  modeUpdate?: LocationLifecycleModeUpdate;
  modeDelete?: LocationLifecycleModeDelete;
  create?: LocationLifecycleCreate;
  update?: LocationLifecycleUpdate;
  delete?: LocationLifecycleDelete;
}

export enum LocationLifecycle {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  MODE_CREATE = 'MODE_CREATE',
  MODE_UPDATE = 'MODE_UPDATE',
  MODE_DELETE = 'MODE_DELETE',
}

export interface LocationLifecycleModeCreate {
  modeId?: string;
}

export interface LocationLifecycleModeUpdate {
  modeId?: string;
}

export interface LocationLifecycleModeDelete {
  modeId?: string;
}

export type LocationLifecycleCreate = object;

export type LocationLifecycleUpdate = object;

export type LocationLifecycleDelete = object;

/** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
export interface DeviceLifecycleEvent {
  deviceId: string;
  /**
   * ID for what owns the device lifecycle event. Works in tandem with `ownerType` as a composite identifier.
   * A DeviceLifecycleEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  principal?: string;
  name?: string;
  /**
   * When user-level devices have been shared to multiple locations, this will be `true` when the event is on the
   * user's "primary" shard.
   * @default false
   */
  primaryEvent?: boolean;
  /**
   * Identifier to ensure uniquness of events across multiple shards, when used by global services that consume
   * those events. Required if `sharedLocations` or `globalSharedLocations` are provided.
   * @format uuid
   */
  sourceEventId?: string;
  /**
   * Locations that the event was created in for the current shard.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard.
   */
  sharedLocations?: EventSharedLocation[];
  /**
   * Locations that the event was created in for all other shards.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard.
   */
  globalSharedLocations?: EventSharedLocation[];
  /** Create device lifecycle. */
  create?: DeviceLifecycleCreate;
  /** Delete device lifecycle. */
  delete?: DeviceLifecycleDelete;
  /** Update device lifecycle. */
  update?: DeviceLifecycleUpdate;
  /** Move device lifecycle. */
  moveFrom?: DeviceLifecycleMove;
  /** Move device lifecycle. */
  moveTo?: DeviceLifecycleMove;
  /** Room move device lifecycle. */
  roomMove?: DeviceLifecycleRoomMove;
}

/** Create device lifecycle. */
export type DeviceLifecycleCreate = object;

/** Delete device lifecycle. */
export type DeviceLifecycleDelete = object;

/** Update device lifecycle. */
export type DeviceLifecycleUpdate = object;

/** Move device lifecycle. */
export interface DeviceLifecycleMove {
  locationId: string;
}

/** Room move device lifecycle. */
export interface DeviceLifecycleRoomMove {
  roomIdFrom?: string;
  roomIdTo?: string;
}

export interface DeviceLogEvent {
  deviceId?: string;
  /** Base 64 encoded message. */
  message?: string;
}

export interface InstalledAppLifecycleEvent {
  installedAppId?: string;
  create?: object;
  delete?: object;
  update?: object;
}

/** A capability lifecycle event. At least one of `create`, `update`, `delete`, `localizationChange` and `statusChange` must be set and value should not be null. */
export interface CapabilityLifecycleEvent {
  /** The unique identifier of the capability. In the format of `<<namespace>>.<<capabilityId>>`. */
  capabilityId?: string;
  /** The version of the capability */
  version?: number;
  create?: object;
  delete?: object;
  update?: object;
  /** A set of capability localization changes. */
  localizationChange?: CapabilityLocalizationChange;
  /** The capability status change information. */
  statusChange?: CapabilityStatusChange;
}

/** A set of capability localization changes. */
export interface CapabilityLocalizationChange {
  localizations?: CapabilityLocalizationItem[];
}

/** A capability localization change Item. */
export interface CapabilityLocalizationItem {
  locale?: string;
  manufacturerName?: string;
  presentationId?: string;
}

/** The capability status change information. */
export interface CapabilityStatusChange {
  /** The status of the capability. */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
}

/** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
export interface SceneLifecycleEvent {
  /** The id of the scene. */
  sceneId: string;
  /** Create scene lifecycle. */
  create?: SceneLifecycleCreate;
  /** Update scene lifecycle. */
  update?: SceneLifecycleUpdate;
  /** Delete scene lifecycle. */
  delete?: SceneLifecycleDelete;
}

/** Create scene lifecycle. */
export type SceneLifecycleCreate = object;

/** Update scene lifecycle. */
export type SceneLifecycleUpdate = object;

/** Delete scene lifecycle. */
export type SceneLifecycleDelete = object;

/** An event used to trigger a client action on a SmartApp dashboard card. */
export interface SmartAppDashboardCardEvent {
  /**
   * The ID of the installed application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  installedAppId?: string;
  /**
   * A developer defined dashboard card ID.
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "my_dashboard_card"
   */
  cardId?: string;
  /** An update action will trigger client to fully refresh card state. */
  update?: object;
  /** A delete action will trigger client to delete a card. */
  delete?: object;
}

/** An event which can be used to broadcast custom triggers from SmartApps. */
export interface SmartAppEvent {
  /**
   * An arbitrary name for the custom SmartApp event.  Typically useful as a hook for in-app routing.
   * @format ^[a-zA-Z_]{1,36}$
   */
  name?: string;
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 256 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
  /**
   * The ID of the installed application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  installedAppId?: string;
}

/** An event that represents a change in the arm state of a security system. */
export interface SecurityArmStateEvent {
  /** The arm state of a security system. */
  armState: 'ARMED_AWAY' | 'ARMED_STAY' | 'DISARMED';
  /**
   * A set of key / value pairs useful for passing any optional arguments.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum string value length: 128 Unicode characters in UTF-8
   * * Allowed values for *keys* are JSON strings
   * * Allowed values for *values* are null, JSON strings, numbers, booleans
   * @example {"intArgument":17,"doubleArgument":17.9,"stringArgument":"foo","booleanArgument":true}
   */
  optionalArguments?: Record<string, any>;
}

/** An event that represents a failure to change the arm state of a security system. */
export interface SecurityArmFailureEvent {
  /** The reason that the security system failed to change arm state. */
  failureReason?: 'SERVER_ERROR' | 'TIMEOUT';
}

/** An event that represents a SOS event has occured for a security system. */
export type SecuritySosEvent = object;

/** An event that represents a quarantine state change for an entity. */
export interface QuarantineEvent {
  entityId?: string;
  /** The type of entity that the quarantine applies to. */
  entityType?: QuarantineEventEntityType;
  /** The state of the quarantine. */
  state?: QuarantineEventState;
}

/** The type of entity that the quarantine applies to. */
export enum QuarantineEventEntityType {
  APP = 'APP',
  INSTALLED_APP = 'INSTALLED_APP',
}

/** The state of the quarantine. */
export enum QuarantineEventState {
  LIFTED = 'LIFTED',
  ENFORCED = 'ENFORCED',
}

/** Weather data */
export interface WeatherData {
  /** Cloud ceiling in meters */
  cloudCeilingInM?: number;
  /** The phrase of the cloud cover */
  cloudCoverPhrase?: string;
  /** Relative Humidity Percentage */
  relativeHumidityInPercent?: number;
  sunriseDate?: string;
  sunsetDate?: string;
  /**
   * Temperature in degrees celsius
   * @format double
   */
  temperatureInC?: number;
  /**
   * Feels-like temperature in degrees celsius
   * @format double
   */
  temperatureFeelsLikeInC?: number;
  uvDescription?: string;
  uvIndex?: number;
  /** @format double */
  visibilityInKm?: number;
  windDirectionInDegrees?: number;
  windDirectionCardinal?: string;
  windGustInKmph?: number;
  windSpeedInKmph?: number;
  conditionPhraseLong?: string;
  conditionState?: 'UNKNOWN' | 'CLEAR' | 'SNOW' | 'RAIN' | 'CLOUDY' | 'STORM' | 'DUSTY' | 'FOGGY';
}

/** Air quality data */
export interface AirQualityData {
  airQualityIndex?: number;
  /** @format double */
  o3AmountInUgm3?: number;
  o3Index?: number;
  /** @format double */
  no2AmountInUgm3?: number;
  no2Index?: number;
  /** @format double */
  so2AmountInUgm3?: number;
  so2Index?: number;
  /** @format double */
  coAmountInUgm3?: number;
  coIndex?: number;
  /** @format double */
  pm10AmountInUgm3?: number;
  pm10Index?: number;
  /** @format double */
  pm25AmountInUgm3?: number;
  pm25Index?: number;
}

/** Severe Weather Alert data */
export interface SevereAlertData {
  headlineText?: string;
  detailUrl?: string;
  startTime?: string;
  endTime?: string;
  severity?: 'UNKNOWN_SEVERITY' | 'EXTREME' | 'SEVERE' | 'MODERATE';
  state?: 'NONE' | 'NEW' | 'UPDATE' | 'CANCEL';
}

/** An event representing the current weather forecast. */
export interface WeatherEvent {
  /** Weather data */
  weatherData?: WeatherData;
  /** Air quality data */
  airQualityData?: AirQualityData;
  /** Severe Weather Alert data */
  severeAlertData?: SevereAlertData;
  /** The id of the GeoPlace. */
  geoPlaceId?: string;
  /** The postal code of the weather event. */
  postalCode?: string;
}

/** A GeoPlace lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. There must also be either a user or service value set and not null. A GeoPlaceLifecycleEvent should typically not have a locationId in the event wrapper object. */
export interface GeoPlaceLifecycleEvent {
  /** The id of the GeoPlace. */
  geoPlaceId: string;
  /** The id of the GeoPlace's owner (e.g. Location ID). */
  ownerId: string;
  /** Type of owner that this GeoPlace has. 0 represents a GeoPlace owned by a location. */
  ownerType: GeoPlaceOwnerType;
  user?: User;
  /** A service in the system. */
  service?: Service;
  /** Create GeoPlace lifecycle. */
  create?: GeoPlaceLifecycleCreate;
  /** Update GeoPlace lifecycle. */
  update?: GeoPlaceLifecycleUpdate;
  /** Delete GeoPlace lifecycle. */
  delete?: GeoPlaceLifecycleDelete;
}

/** Create GeoPlace lifecycle. */
export type GeoPlaceLifecycleCreate = object;

/** Update GeoPlace lifecycle. */
export interface GeoPlaceLifecycleUpdate {
  /** The changes that occurred on this GeoPlace to trigger this event. */
  changes?: string[];
}

/** Delete GeoPlace lifecycle. */
export type GeoPlaceLifecycleDelete = object;

/** Type of owner that this GeoPlace has. 0 represents a GeoPlace owned by a location. */
export enum GeoPlaceOwnerType {
  Value0 = 0,
}

export interface User {
  id?: string;
  name?: string;
  linkedAt?: string;
}

/** A service in the system. */
export interface Service {
  clientId?: string;
}

/** The type of execution allows the app to exhibit different behavior based on the type. */
export enum ExecutionType {
  INSTALL = 'INSTALL',
  UPDATE = 'UPDATE',
  UNINSTALL = 'UNINSTALL',
  EVENT = 'EVENT',
  PING = 'PING',
  CONFIGURATION = 'CONFIGURATION',
  OAUTH_CALLBACK = 'OAUTH_CALLBACK',
  EXECUTE_BEHAVIOR = 'EXECUTE_BEHAVIOR',
  EXECUTE = 'EXECUTE',
  DASHBOARD = 'DASHBOARD',
  CONFIRMATION = 'CONFIRMATION',
}

/** Dictates how Execution should process the request. */
export enum InvocationType {
  SYNCHRONOUS = 'SYNCHRONOUS',
  ASYNCHRONOUS = 'ASYNCHRONOUS',
}

export interface AppExecutionRequest {
  /** The type of execution allows the app to exhibit different behavior based on the type. */
  executionType: ExecutionType;
  /** Dictates how Execution should process the request. */
  invocationType?: InvocationType;
  /**
   * An IETF BCP 47 language tag representing the chosen locale for this account.  If not provided will attempt to
   * resolve locale from location, and lastly default to english.
   * @example "en"
   */
  locale?: string;
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
  eventData?: EventData;
  installData?: InstallData;
  updateData?: UpdateData;
  uninstallData?: UninstallData;
  pingData?: PingData;
  confirmData?: ConfirmData;
  configData?: ConfigData;
  executeBehaviorData?: ExecuteBehaviorData;
  /** Provides intergration with the result of a third party oauth attempt.  This will only be available for executions of type "OAUTH_CALLBACK". */
  oAuthCallbackData?: OAuthCallbackData;
  /**
   * Provides the ability to execute the SmartApp with custom parameters, and receive a custom response.  This lifecycle allows
   * a developer to expose a fully custom API to a client.  This will only be available for executions of type "EXECUTE".
   */
  executeData?: ExecuteData;
  /**
   * Provides the ability to execute the SmartApp to render cards on the user's dashboard. This will only be available
   * for executions of type "DASHBOARD".
   */
  dashboardData?: DashboardData;
}

/**
 * Known details about the client application from which the request was initiated.  This information is provided
 * on best effort basis.  All properties maybe null or empty.
 */
export interface ClientDetails {
  /**
   * The operating system of the client application initiating the request.
   * @maxLength 16
   */
  os?: string;
  /**
   * The version of the client application initiating the request.
   * @maxLength 16
   */
  version?: string;
  /**
   * Language header representing the client's preferred language. The format of the `Accept-Language` header follows what is defined in [RFC 7231, section 5.3.5](https://tools.ietf.org/html/rfc7231#section-5.3.5)
   * @maxLength 1024
   */
  language?: string;
  /** The display mode of the operating system of the client. */
  displayMode?: 'DARK' | 'LIGHT';
  /** A time zone [UTC offset](https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC). Note that a leading zero is required. (e.g. "UTC-06:00", "UTC+09:00" or "UTC-00:00") */
  timeZoneOffset?: string;
  /** Templates that could be renderable in the client */
  supportedTemplates?: ('BASIC_V1' | 'BASIC_V2' | 'BASIC_V3' | 'BASIC_V4' | 'BASIC_V5' | 'BASIC_V6' | 'BASIC_V7')[];
  /**
   * ID for acting user in Samsung Account. Will be null for smartthings only accounts.
   * @example "pcg38apioc"
   */
  samsungAccountId?: string;
  /**
   * ID for acting user's mobile device.
   * @example "d4e53f5c-7eb1-4f7e-a9ff-b908b2a36bf0"
   */
  mobileDeviceId?: string;
}

export interface EventData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  event: Event;
}

export interface InstallData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** An OAuth token to use when calling into SmartThings API's. */
  authToken: string;
  /**
   * A refresh token which maybe used to obtain authorization to SmartThings API after expiration of the authToken.
   * An integration will need to use this refreshToken to support calling the SmartThings API outside the context
   * of an event.
   */
  refreshToken: string;
}

export interface UpdateData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** An OAuth token to use when calling into SmartThings API's. */
  authToken: string;
  /**
   * A refresh token which maybe used to obtain authorization to SmartThings API after expiration of the authToken.
   * An integration will need to use this refreshToken to support calling the SmartThings API outside the context
   * of an event.
   */
  refreshToken: string;
}

export interface UninstallData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  event?: Event;
}

/** @example {"appType":"WEBHOOK_SMART_APP","targets":["https://smartthings.com/webhook"]} */
export interface PingData {
  /** Denotes the type of app. */
  appType: AppType;
  /**
   * A list of targets which should be executed to test connectivity.  For a LAMBDA_SMART_APP, targets would
   * be a list of AWS Lambda ARNs.  For a WEBHOOK_SMART_APP, targets would contain a single URL.
   */
  targets?: string[];
}

/** @example {"appType":"WEBHOOK_SMART_APP","targets":["https://smartthings.com/webhook"],"appId":"40110c5e-e064-4549-a366-89dab9d55f0a","principal":"user_uuid:40110c5e-e064-4549-a366-89dab9d55f0a"} */
export interface ConfirmData {
  /** Denotes the type of app. */
  appType: AppType;
  /**
   * A list of targets which should be executed to test connectivity. For WEBHOOK_SMART_APP and API_ONLY, targets
   * will contain a single URL.
   */
  targets?: string[];
  /**
   * The unique identifier of the App.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  appId?: string;
  /** The principal that created the app. */
  principal?: string;
}

/** Denotes the type of app. */
export enum AppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
  BEHAVIOR = 'BEHAVIOR',
  API_ONLY = 'API_ONLY',
}

export interface ConfigData {
  /**
   * The unique identifier of the App.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "64d1d1ab-afb9-4a75-9cd8-f1ced9430518"
   */
  appId: string;
  /**
   * The current installedAppId if available.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** Denotes the current installation phase. */
  phase: 'INITIALIZE' | 'PAGE';
  /**
   * The specific page being requested if available.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   * @example "second-page"
   */
  pageId?: string;
  /**
   * The previous page the user completed if available.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   * @example "first-page"
   */
  previousPageId?: string;
}

/** Provides intergration with the result of a third party oauth attempt.  This will only be available for executions of type "OAUTH_CALLBACK". */
export interface OAuthCallbackData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /**
   * A relative URL containing all of the query string parameters as returned by the third party oauth system. An endpoint app can
   * parse the `urlPath` property to extract any senstive auth codes/tokens which can then be used to access the third party system.
   */
  urlPath: string;
}

/**
 * Provides the ability to execute the SmartApp with custom parameters, and receive a custom response.  This lifecycle allows
 * a developer to expose a fully custom API to a client.  This will only be available for executions of type "EXECUTE".
 */
export interface ExecuteData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId?: string;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

export interface ExecuteBehaviorData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
}

/**
 * Provides the ability to execute the SmartApp to render cards on the user's dashboard. This will only be available
 * for executions of type "DASHBOARD".
 */
export interface DashboardData {
  /** @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$ */
  installedAppId: string;
}

export interface AppExecutionResponse {
  /**
   * A unique identifier for this execution.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  executionId?: string;
  /**
   * A base64 encoded JSON representation of the value returned from the execution.
   * @format byte
   */
  payload?: string;
}

export interface InstalledAppExecuteRequest {
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

export interface InstalledAppDashboardRequest {
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
}

/** Expected response for a Dashboard lifecycle execution. */
export interface DashboardResponseData {
  /**
   * A unique identifier for a card of service
   * @format some service name
   */
  serviceName?: string;
  /**
   * list of card object
   * @maxItems 5
   * @minItems 1
   */
  cards?: DashboardCard[];
}

/** payload of dashboard card */
export interface DashboardCard {
  /**
   * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
   * Each card template may have a different set requirement for data needs.
   *
   * * BASIC_V1 - The basic / default template.
   * * BASIC_V2 - default template + HTML and body items support.
   * * BASIC_V3 - V2 template + bar graph support.
   * * BASIC_V4 - Template to support Pet care and Kitchen services
   * * BASIC_V5 - Template to support UX2.5 changes
   * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
   * * BASIC_V7 - Template to support body image + bg Image + icon.
   * * FREE_FORM - A free form template with minimal constraints.
   */
  templateId: DashboardCardTemplate;
  /**
   * A unique identifier for a card of service
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "some-card-id"
   */
  cardId: string;
  /** card size */
  size?: number;
  /** Data requirements for a Basic V1 card template. */
  basicV1?: BasicCard;
  /** Data requirements for a Basic V2 card template. */
  basicV2?: BasicV2Card;
  /** Data requirements for a Basic V3 card template. */
  basicV3?: BasicV3Card;
  /** Data requirements for a Basic V4 card template. */
  basicV4?: BasicV4Card;
  /** Data requirements for a Basic V5 card template. */
  basicV5?: BasicV5Card;
  /** Data requirements for a Basic V6 card template. */
  basicV6?: BasicV6Card;
  /** Data requirements to support BasicV7 */
  basicV7?: BasicV7Card;
  freeForm?: FreeFormCard;
}

/**
 * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
 * Each card template may have a different set requirement for data needs.
 *
 * * BASIC_V1 - The basic / default template.
 * * BASIC_V2 - default template + HTML and body items support.
 * * BASIC_V3 - V2 template + bar graph support.
 * * BASIC_V4 - Template to support Pet care and Kitchen services
 * * BASIC_V5 - Template to support UX2.5 changes
 * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
 * * BASIC_V7 - Template to support body image + bg Image + icon.
 * * FREE_FORM - A free form template with minimal constraints.
 */
export enum DashboardCardTemplate {
  BASICV1 = 'BASIC_V1',
  BASICV2 = 'BASIC_V2',
  BASICV3 = 'BASIC_V3',
  BASICV4 = 'BASIC_V4',
  BASICV5 = 'BASIC_V5',
  BASICV6 = 'BASIC_V6',
  BASICV7 = 'BASIC_V7',
  FREE_FORM = 'FREE_FORM',
}

/** Data requirements for a Basic V1 card template. */
export interface BasicCard {
  /**
   * name of the card
   * @maxLength 100
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * A title icon url for card. Angit  HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image"
   */
  iconUrl?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V1 template. */
  body?: BasicBody;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicButton[];
}

/** Data requirements for a Basic V2 card template. */
export interface BasicV2Card {
  /**
   * An title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V2 template. */
  body?: BasicV2Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

export interface FreeFormCard {
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 5 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 1000 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

/** A background image. */
export interface BasicBackgroundImage {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-1]{1}$
   */
  alpha?: number;
}

/** Body definition for a Basic V1 template. */
export interface BasicBody {
  image?: BasicImage;
  /** A text object. */
  text?: BasicText;
}

/** A button definition for a Basic V1 template. */
export interface BasicButton {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic template. */
  textButton?: BasicTextButton;
  /** A text button definition for a basic template. */
  iconButton?: BasicIconButton;
}

export interface BasicImage {
  /**
   * An icon name.
   * @maxLength 100
   */
  name?: string;
  /** Position of where the image should be rendered within card. */
  position?: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
}

/** A text object. */
export interface BasicText {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
}

/**
 * The type of buttons to render.
 *
 * * TEXT - A colored button with a text overrlay.
 * * ICON - A button with an image backgroup and text overrlay.
 */
export enum BasicButtonType {
  TEXT = 'TEXT',
  ICON = 'ICON',
}

/** Position of where the image should be rendered within card. */
export enum BasicImagePosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A text button definition for a basic template. */
export interface BasicTextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic template. */
export interface BasicIconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /**
   * A default icon image url. HTTPS url required.
   * @format uri
   * @maxLength 250
   */
  iconUrl?: string;
}

/** Position of where the button should be rendered within card. */
export enum BasicButtonPosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A definition of the action to be taken when button is activated. */
export interface ServiceCardAction {
  /**
   * The type of action to take when UI element is activated.
   *
   * * LAUNCH_PLUGIN - Launch a corresponding UI plugin.
   * * EXECUTE - Execute an API call to the backing SmartApp.
   * * LAUNCH_CONFIGURATION - Launch SmartApp's configuration page in Strongman
   * * LAUNCH_PLUGIN_SERVICE - Launch a corresponding plugin in background
   */
  type?: ActionType;
  /** Launch a backing UI plugin in SmartThings Client. */
  launchPlugin?: LaunchPluginAction;
  /** Call the EXECUTE lifecycle on the backing SmartApp. */
  execute?: ExecuteAction;
  /** Launch the SmartApp's configuration page in Strongman */
  launchConfiguration?: LaunchConfiguration;
  /** Launch a service plugin in background. */
  launchPluginService?: LaunchPluginService;
}

/**
 * The type of action to take when UI element is activated.
 *
 * * LAUNCH_PLUGIN - Launch a corresponding UI plugin.
 * * EXECUTE - Execute an API call to the backing SmartApp.
 * * LAUNCH_CONFIGURATION - Launch SmartApp's configuration page in Strongman
 * * LAUNCH_PLUGIN_SERVICE - Launch a corresponding plugin in background
 */
export enum ActionType {
  LAUNCH_PLUGIN = 'LAUNCH_PLUGIN',
  EXECUTE = 'EXECUTE',
  LAUNCH_CONFIGURATION = 'LAUNCH_CONFIGURATION',
  LAUNCH_PLUGIN_SERVICE = 'LAUNCH_PLUGIN_SERVICE',
}

/** Launch a backing UI plugin in SmartThings Client. */
export interface LaunchPluginAction {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId?: string;
  /** parameter to be passed to plugin */
  uri?: string;
}

/** Call the EXECUTE lifecycle on the backing SmartApp. */
export interface ExecuteAction {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch the SmartApp's configuration page in Strongman */
export interface LaunchConfiguration {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch a service plugin in background. */
export interface LaunchPluginService {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId: string;
  /**
   * service component to be launched.
   * @format ^[a-zA-Z._]{1,99}$
   */
  componentId: string;
  /** parameter to be passed to plugin */
  uri?: string;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Body definition for a Basic V2 template. */
export interface BasicV2Body {
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
}

export interface BasicV2Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/**
 * Body item array definition for a Basic V2 template
 * @maxItems 4
 */
export type BasicV2Items = BasicV2Item[];

/** Item in Basic V2 items */
export interface BasicV2Item {
  /** Body item image height */
  height?: number;
  /** Body item object definition for a Basic V2 template */
  item?: BasicV2ImageItem;
}

/** Body item object definition for a Basic V2 template */
export interface BasicV2ImageItem {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * The text that would be shown under image
   * @maxLength 250
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text object. */
export interface BasicV2Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A button definition for a Basic V2 template. */
export interface BasicV2Button {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic V2 template. */
  textButton?: BasicV2TextButton;
  /** A text button definition for a basic V2 template. */
  iconButton?: BasicV2IconButton;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2TextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2IconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /**
   * An icon image url on button-released. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  releasedIconUrl?: string;
  /**
   * An icon image url on button-pressed. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  pressedIconUrl?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V3 card template. */
export interface BasicV3Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V3 template. */
  body?: BasicV3Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

/** Body definition for a Basic V3 template. */
export interface BasicV3Body {
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
}

/**
 * A horizontal comparision bar graph to compare two values.
 * @maxItems 2
 * @minItems 2
 */
export type ServiceCardBarGraph = ServiceCardBar[];

export interface ServiceCardBar {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value: number;
  /** color with alpha */
  color: BasicCardColor;
  /** units of the field. */
  units: string;
}

/** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
export interface ServiceCardBarGraphV2 {
  /** VALUE_UNIT_GRAPH requires value and unit fields, PERCENT_COST_GRAPH and SAME_BASE_GRAPH requires percent and cost fields. */
  type: 'VALUE_UNIT_GRAPH' | 'PERCENT_COST_GRAPH' | 'SAME_BASE_GRAPH';
  /** @minItems 1 */
  list: ServiceCardBarV2[];
}

export interface ServiceCardBarV2 {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value?: number;
  /** percent of the bar to occupy. */
  percent?: number;
  /** color with alpha */
  color: BasicCardColor;
  /** color with alpha */
  maxBarColor?: BasicCardColor;
  /** units of the field. */
  units?: string;
  /** Bar information. */
  cost?: string;
}

/** Data requirements for a Basic V4 card template. */
export interface BasicV4Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V4 template. */
  body?: BasicV4Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Header icon for Basic V4 template */
export interface BasicV4HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Body definition for a Basic V4 template. */
export interface BasicV4Body {
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV2Text;
  /** A text object. */
  text?: BasicV2Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Background spacing to show image in the Card's bgImage */
export interface BasicV4BackgroundSpacing {
  /** Spacing position */
  position: 'LEFT' | 'RIGHT';
  /** width of spacing in px */
  width: number;
}

/** item in BasicV4, BasicV5, BasicV6 items list. */
export interface BasicV4Item {
  /**
   * Text 1 in the body/header item
   * @maxLength 250
   */
  name?: string;
  /**
   * Text 2 in the body item
   * @maxLength 250
   */
  description?: string;
  /** icon of the body/header item */
  icon?: BasicV4Icon;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** icon of the body/header item */
export interface BasicV4Icon {
  /**
   * icon url for the item. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** Item alignment */
  align: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Item position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Item icon height */
  height?: number;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
}

/** Switch button in BasicV4 body */
export interface BasicV4SwitchButton {
  /** Switch enabled status */
  status: boolean;
  /** color with alpha */
  color: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action: ServiceCardAction;
}

/** BasicV4 icon button */
export interface BasicV4IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** BasicV4 text button */
export interface BasicV4TextButton {
  /**
   * text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V5 card template. */
export interface BasicV5Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V5 template. */
  body?: BasicV5Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Body definition for a Basic V5 template. */
export interface BasicV5Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** A text object. */
export interface BasicV5Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text vertical alignment. Default CENTER */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** text horizontal alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V6 card template. */
export interface BasicV6Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV6HeaderIcon[];
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  headerItems?: ServiceCardItemsV2;
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V6 template. */
  body?: BasicV6Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV6IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV6TextButton[];
  };
}

/** Body definition for a Basic V6 template. */
export interface BasicV6Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  /** Image definition for Basic V6. */
  image?: BasicV6Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Header icon for Basic V6 template */
export interface BasicV6HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for icon.
   * @maxLength 250
   * @example "Barcode Scanner"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 icon button */
export interface BasicV6IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for Button.
   * @maxLength 250
   * @example "off device"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Image definition for Basic V6. */
export interface BasicV6Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** describes how image should be scaled. */
  scaleType?: 'CENTER_CROP' | 'FIT_CENTER' | 'CENTER_INSIDE' | 'FIT_XY';
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 text button */
export interface BasicV6TextButton {
  /**
   * 1st line of text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /**
   * 2nd line of text in button
   * @maxLength 250
   * @example "Locks all devices"
   */
  description?: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements to support BasicV7 */
export interface BasicV7Card {
  /** Common properties that shared by entire card in Basic V7. */
  card?: BasicV7CardProperties;
  /** Data requirement to support Basic V7 header types. */
  header?: BasicV7Header;
  /** Data requirement to support Basic V7 body types. */
  body: BasicV7Body;
}

/** Common properties that shared by entire card in Basic V7. */
export interface BasicV7CardProperties {
  /** Background for the entire card. */
  bgImage?: BasicV7Image;
  /** Default action of the card. */
  action: ServiceCardAction;
}

/** Data requirement to support Basic V7 header types. */
export interface BasicV7Header {
  /** Type of header as per GUI naming. */
  headerType: 'STYLE_1' | 'STYLE_2' | 'STYLE_3' | 'STYLE_4';
  /** A title icon url for card. */
  titleIcon?: BasicV7Image;
  /** Text to be shown on header */
  text: BasicV7Text;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  iconsList?: BasicV7Image[];
  /** header items for small device icon and a single line of text. */
  headerItems?: BasicV7ItemGroup;
}

/** Data requirement to support Basic V7 body types. */
export interface BasicV7Body {
  /** Type of body as per GUI naming. */
  bodyType: 'TYPE_1' | 'TYPE_2' | 'TYPE_3' | 'TYPE_4' | 'TYPE_5' | 'TYPE_6';
  /** Data requirements for name for Basic V7. */
  nameGroup?: BasicV7NameGroup;
  /** Text for UI components of Basic V7. */
  name?: BasicV7Text;
  /** Text for UI components of Basic V7. */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  image?: BasicV7Image;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraph?: ServiceCardBarGraphV2;
  /** Data requirements for header/body items for Basic V7. */
  items?: BasicV7ItemGroup;
  /** Text to be displayed on button. */
  buttonText?: BasicV7Text;
  /** Image definition for Basic V7. */
  bgImage?: BasicV7Image;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
}

/** Text for UI components of Basic V7. */
export interface BasicV7Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content: string;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Image definition for Basic V7. */
export interface BasicV7Image {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-9]{1,2}$
   */
  alpha?: number;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** Defines scale type of the image. */
  scaleType?: BasicV7ImageScaleType;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Defines scale type of the image. */
export enum BasicV7ImageScaleType {
  CENTER_CROP = 'CENTER_CROP',
  FIT_CENTER = 'FIT_CENTER',
  CENTER_INSIDE = 'CENTER_INSIDE',
  FIT_XY = 'FIT_XY',
}

/** Position/Padding of any UI entity. */
export interface BasicV7Position {
  /** General Position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Defines left Padding. */
  paddingLeft?: number;
  /** Defines right Padding. */
  paddingRight?: number;
}

/** Align/Padding of any UI entity. */
export interface BasicV7Align {
  /** General Position */
  position: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Defines Top Padding. */
  paddingTop?: number;
  /** Defines Bottom Padding. */
  paddingBottom?: number;
}

/** Defines the dimension of the UI entity. */
export interface BasicV7Dimension {
  width: number;
  height: number;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7ItemGroup {
  /** Image definition for Basic V7. */
  dividerUrl?: BasicV7Image;
  /**
   * @maxItems 3
   * @minItems 1
   */
  items: BasicV7Item[];
}

/** Data requirements for name for Basic V7. */
export interface BasicV7NameGroup {
  /** Text for UI components of Basic V7. */
  mainName: BasicV7Text;
  /** Text for UI components of Basic V7. */
  subName?: BasicV7Text;
  /** Image definition for Basic V7. */
  dividerImage?: BasicV7Image;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7Item {
  /** Type of body as per GUI naming. */
  itemType: 'BODY_TYPE_1' | 'BODY_TYPE_2' | 'HEADER_STYLE_4';
  /** Text for line 1 in the item */
  name?: BasicV7Text;
  /** Text for line 2 in the item */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** WebView for service card body */
export interface ServiceCardWebView {
  /**
   * HTML content for the web view
   * @maxLength 10000
   */
  content: string;
  /**
   * CSS styles for the web view
   * @maxLength 5000
   */
  styles?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
export interface ServiceCardItemsV2 {
  /** divider width in dp */
  dividerWidth?: number;
  /**
   * URL of the divider for the items. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  dividerUrl?: string;
  /**
   * A list of items.
   * @maxItems 4
   */
  list: BasicV4Item[];
}

/**
 * color with alpha
 * @format ^[a-fA-F0-9]{8}$
 */
export type BasicCardColor = string;

/** The behavior */
export type Behavior = BehaviorRequest & {
  /**
   * Unique id for the behavior
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
};

/**
 * Input object to create a Behavior
 * @example {"parentId":"g2a6ce48-5geb-4287-bb34-8bc0xa241j59","parentType":"SCENE","actions":[{"action":"send","target":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d","cmd":"off","capability":"Switch","component":"main"}],"triggers":[{"type":"subscription","pattern":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d.contact.open"},{"type":"","pattern":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d.contact.open"}],"guard":[{"LI":{"I64":0}},{"LI":{"I64":0}},{"CE":{"time":"isDay"}}],"default":[]}
 */
export interface BehaviorRequest {
  /** Unique name for the behavior */
  name?: string;
  /** ID of the parent. */
  parentId?: string;
  /** The source of the Behavior */
  parentType: ParentType;
  /** Execution strategy for the behavior */
  executionStrategy?: 'interrupt' | 'ignore';
  actions: Action[];
  triggers?: Trigger[];
  /** Guard condition that must be true before a behavior is executed. The array represents a RPN expression. */
  guard?: Element[];
  /** Follows IANA(Internet Assigned Numbers Authority) time zone database notion. If provided, this will dictate the timezone in which the schedule is created. If not provided, the location timezone will be used, or, if not available, UTC will be assumed. */
  timezone?: string;
  /** If this automation should executed once per a day or once per N hours. Only for "RULE" and can be null. */
  oncePer?: {
    /** Limit execution to once per interval, ex. once every 24 hours */
    interval?: {
      seconds?: number;
    };
    /** Limit execution to once per unit on the calendar, ex. once per day */
    calendar?: {
      value?: number;
      unit?: 'day' | 'hour' | 'min';
    };
  };
  /** Default set of actions executed in case of Guard evaluates to false. */
  default?: Action[];
  /** The status of the Behavior */
  status?: BehaviorEnabledEnum;
  /** Defines expiration, or scheduled deletion of Behaviors. */
  expiration?: Expiration;
}

/**
 * Defines a behavior set in the smartthings system.
 * @example {"id":"2baf54f0-7d3a-4ee1-a68a-d59a035e6060","behaviorIds":["5n6f54f0-7d3a-4ee1-a68a-d59a035e6061","b9mf54f0-7d3a-4ee1-a68a-d59a035e6062"]}
 */
export interface BehaviorSet {
  /**
   * Unique id for the behavior set
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** List of behaviors' IDs in this set */
  behaviorIds?: string[];
  /** List of behaviors in this set */
  behaviors?: Behavior[];
}

/**
 * Input object to create a BehaviorSet
 * @example {"behaviorIds":["5n6f54f0-7d3a-4ee1-a68a-d59a035e6061","b9mf54f0-7d3a-4ee1-a68a-d59a035e6062"]}
 */
export interface BehaviorSetRequest {
  /**
   * Parent ID for behaviors
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  parentId?: string;
  /** List of behaviors in this set */
  behaviorIds?: string[];
  /** List of BehaviorRequests to be included in this set */
  behaviorRequests?: BehaviorRequest[];
}

/** Action that will be executed by a behavior */
export interface Action {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  id?: string;
  /**
   * The type of action.
   * call is for API calls (e.g. setting a timer)
   * raise is for raising an internal event
   * send is for remote control (e.g. device commands)
   * set is for changing internal states
   * Not all action types needs to be implemented.
   */
  action: 'send' | 'call' | 'set' | 'raise' | 'sleep' | 'cycle' | 'devicegroup' | 'sms';
  /** LEGACY - The target of the Action. Can be device id with optional component id. */
  target?: string;
  /** LEGACY - The command to send. */
  cmd?: string;
  /** LEGACY - The capability id, i.e. switch, switchLevel */
  capability?: string;
  /**
   * LEGACY - The component of a device.
   * @default "main"
   */
  component?: string;
  /** LEGACY - Generic value for action arguments */
  value?: object;
  /** LEGACY - Map containing a key-value that describes a call */
  call?: CallNode;
  /** Action used to send a command to a device */
  sendAction?: SendAction;
  /** Action used to call various APIs */
  callAction?: CallAction;
  /** Action used to immediately trigger another behavior */
  raiseAction?: RaiseAction;
  /** Action used to set state variable */
  setStateAction?: SetAction;
  /** Action used to sleep a behavior */
  sleepAction?: SleepAction;
  /** Action used to cycle through a list of actions */
  cycleAction?: CycleAction;
  /** Action used to send a command to a device group */
  sendDeviceGroupAction?: SendDeviceGroupAction;
  /** Action used to send an SMS to a list of phone numbers */
  smsAction?: SmsAction;
}

/** Action used to send a command to a device */
export interface SendAction {
  /** Device GUID */
  device?: string;
  /** The capability id, i.e. switch, switchLevel */
  capability?: string;
  /** Command name */
  command?: string;
  /**
   * Device component
   * @default "main"
   */
  component?: string;
  /** Arguments for device command */
  arguments?: object;
}

/** Action used to call various APIs */
export interface CallAction {
  scheduler?:
    | 'runIn'
    | 'runOnce'
    | 'schedule'
    | 'runEveryMinute'
    | 'runEvery5Minutes'
    | 'runEvery10Minutes'
    | 'runEvery15Minutes'
    | 'runEvery30Minutes'
    | 'runEvery1Hour'
    | 'runEvery3Hours'
    | 'unschedule'
    | 'canSchedule';
  time?: 'now' | 'isDay' | 'isNight' | 'todaysSunrise' | 'todaysSunset';
  notification?: 'sendPush' | 'sendPlugin' | 'sendImage';
  location?: 'setMode';
  security?: 'setArmStay' | 'setArmAway' | 'disarm';
  /** List of args */
  arguments?: Element[];
}

/** Action used to immediately trigger another behavior */
export type RaiseAction = object;

/** Action used to set state variable */
export interface SetAction {
  /** The name of the variable */
  name?: string;
  /** Value of the variable represented as string */
  value?: {
    /** Literal value, only one of the properties should be specified */
    LI?: Literal;
    /** Member expression */
    ME?: MemberExpression;
    /** Call expression */
    CE?: CallExpression;
  };
}

/** Action used to sleep a behavior */
export interface SleepAction {
  /** Number of seconds to sleep */
  seconds?: number;
}

/** Action used to cycle through a list of actions */
export interface CycleAction {
  /** Target device to run cycle actions on */
  device?: string;
  /** List of Send Actions */
  action?: SendAction[];
}

/** Action used to send a command to a device group */
export interface SendDeviceGroupAction {
  /** Device Group GUID */
  deviceGroup?: string;
  /** The capability id, i.e. switch, switchLevel */
  capability?: string;
  /** Command name */
  command?: string;
  /** Arguments for device command */
  arguments?: object;
}

/** Action used to send an SMS to a list of phone numbers */
export interface SmsAction {
  recipients?: string[];
  /** SMS content */
  message: string;
  /** The type of message group entity. */
  entityType?: MessageGroupEntityType;
  /**
   * SMS Message Group Entity ID (usually the ISA or USER ID)
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  entityId?: string;
  /**
   * SMS Message Group Set ID - usually the config ID of an ISA
   * @format ^[-._a-zA-Z0-9]{1,36}$
   */
  messageGroupSet?: string;
  /**
   * SMS Message Group ID - unique identifier for the group
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A Trigger represents a
 * @example {"type":"subscription","pattern":"31192dc9-eb45-4d90-b606-21e9b66d8c2b.main.switch.switch.on"}
 */
export interface Trigger {
  /**
   * Unique id for the trigger
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** Trigger type */
  type: 'subscription' | 'cron' | 'sunevent' | 'init' | 'update';
  /** The pattern of the trigger */
  pattern: string;
  /** Modify trigger criteria */
  modifiers?: {
    /** Lead time between two events */
    leadTime?: LeadTimeModifier;
    /** Delay execution after triggered */
    delay?: DelayModifier;
    filters?: TriggerFilter[];
  };
  /** Trigger subscription values */
  subscription?: TriggerSubscription;
}

/**
 * Lead time between two events
 * @example {"seconds":300,"begin":{"STR":"not_present"},"end":{"STR":"present"}}
 */
export interface LeadTimeModifier {
  /** Number of seconds between events */
  seconds?: number;
  /** Literal value, only one of the properties should be specified */
  begin?: Literal;
  /** Literal value, only one of the properties should be specified */
  end?: Literal;
}

/** Delay execution after triggered */
export interface DelayModifier {
  /** Number of seconds to delay */
  seconds?: number;
}

/** A trigger filter */
export interface TriggerFilter {
  /**
   * Unique id for the base action
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  type: string;
  expression: Element[];
}

/** A filter that expects the expression to equal the value */
export type EqualsTriggerFilter = TriggerFilter & {
  /** Literal value, only one of the properties should be specified */
  value?: Literal;
};

/** A filter that expects the expression to change to value */
export type ChangesToTriggerFilter = TriggerFilter & {
  /** Literal value, only one of the properties should be specified */
  value?: Literal;
};

/** A filter that expects the expression to increase since its last evaluation */
export type IncreasesTriggerFilter = TriggerFilter;

/** A filter that expects the expression to decrease since its last evaluation */
export type DecreasesTriggerFilter = TriggerFilter;

/** Trigger subscription values */
export interface TriggerSubscription {
  /** Trigger subscription type */
  type?: 'DEVICE' | 'MODE' | 'SECURITY_ARM_STATE' | 'WEATHER';
  /**
   * Location id for MODE & SECURITY_ARM_STATE subscriptions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * Device id for the DEVICE subscriptions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /** Device component for the DEVICE subscriptions */
  componentId?: string;
  /** Component capability for DEVICE subscriptions */
  capabilityId?: string;
  /** Capability attribute for DEVICE and WEATHER subscriptions */
  attribute?: string;
  /** Attribute value for DEVICE subscriptions */
  value?: string;
}

/** LEGACY - Map containing a key-value that describes a call */
export type CallNode = any;

/** Only one of these elements should be present. */
export interface Element {
  /** Binary operator */
  BO?:
    | 'ADD'
    | 'SUB'
    | 'MUL'
    | 'DIV'
    | 'POW'
    | 'MOD'
    | 'AND'
    | 'OR'
    | 'XOR'
    | 'SHL'
    | 'SHR'
    | 'EQ'
    | 'NE'
    | 'LT'
    | 'GT'
    | 'LE'
    | 'GE';
  /** Unary operator */
  UO?: 'NEG' | 'POS' | 'NOT';
  /** Logical operator */
  LO?: 'AND' | 'OR';
  /** Literal value, only one of the properties should be specified */
  LI?: Literal;
  /** Member expression */
  ME?: MemberExpression;
  /** Call expression */
  CE?: CallExpression;
}

/** Literal value, only one of the properties should be specified */
export interface Literal {
  Number?: number;
  I64?: number;
  U64?: number;
  F64?: number;
  BOOL?: boolean;
  STR?: string;
}

/** An array of behaviors */
export interface PagedBehaviors {
  items?: Behavior[];
  _links?: Links;
}

/** The source of the Behavior */
export enum ParentType {
  RULE = 'RULE',
  SCENE = 'SCENE',
  SMARTAPP = 'SMARTAPP',
  NONE = 'NONE',
}

/**
 * The status of the Behavior
 * @default "ENABLED"
 */
export enum BehaviorEnabledEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

/** Call expression */
export interface CallExpression {
  /** The name of the call */
  time?:
    | 'now'
    | 'isDay'
    | 'isNight'
    | 'todaysSunrise'
    | 'todaysSunset'
    | 'todaysSolarNoon'
    | 'hourOfDay'
    | 'minuteOfHour'
    | 'dayOfWeek'
    | 'dayOfMonth'
    | 'dayOfYear'
    | 'monthOfYear'
    | 'minuteOfDay'
    | 'nowMatches';
  /** The name of the weather property to use */
  weather?:
    | 'absoluteFineDust'
    | 'absoluteUltraFineDust'
    | 'fineDust'
    | 'humidity'
    | 'temperature'
    | 'ultraFineDust'
    | 'weather';
}

/** Member expression */
export type MemberExpression = string;

/** The result of an action execution */
export interface ActionExecutionResult {
  /** Action that will be executed by a behavior */
  action: Action;
  resultCode: number;
}

/** The result of a behavior execution */
export interface BehaviorExecutionResult {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** ID of the parent. */
  parentId?: string;
  /** The source of the Behavior */
  parentType?: ParentType;
  actions?: ActionExecutionResult[];
  /** @default false */
  filtered?: boolean;
  /**
   * The owner of the rule is either a location or user
   * @default "Location"
   */
  ownerType: 'Location' | 'User';
  /** The UUID of the rule owner for a User rule */
  userUuid?: string;
  /** The location ids that are effected by actions in a User rule */
  actionLocationIds?: string[];
}

/**
 * Defines expiration, or scheduled deletion of Behaviors.
 * @example {"pattern":"1","type":"MAXEXECUTIONS","strategy":"DELETE"}
 */
export interface Expiration {
  /** The pattern for the expiration type, e.g. the number of allowed executions */
  pattern?: string;
  /** Expiration type or condition, e.g. expire after maximum number of exections */
  type: 'MAXEXECUTIONS';
  /** Behavior handling after expiration, e.g. delete behavior */
  strategy: 'DELETE';
}

export interface ModesResponse {
  /** @maxItems 10 */
  items: Mode[];
}

export interface Mode {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:modes - the user can edit the Mode
   *   <li> d:modes - the user can delete the Mode
   *   </ul>
   */
  allowed?: string[];
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
   * then the returned label will be translated from the name based on the `Accept-Language` header.
   * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * Unique per Location.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface CreateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface UpdateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface CreateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface UpdateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface ChangeModeRequest {
  /**
   * Update the current Mode for this Location to the given Mode ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  modeId: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteModeResponse = object;

export interface CreateInstalledAppEventsRequest {
  /**
   * An array of smartapp events used to trigger client behavior in loaded web plugin detail pages.  Events will
   * be delivered to JavaScript event handler of all active client processes related to parameterized installed app.
   * @maxItems 8
   * @minItems 1
   */
  smartAppEvents?: SmartAppEventRequest[];
  /**
   * An array of smartapp dashboard card events used to trigger client behavior for dashboard cards.
   * Dashboard card events are directives to a SmartThings client to take actions in relation to lifecycle changes
   * to a specific dashboard card.  These events are not delivered to the web plugin event handler.
   * @maxItems 8
   * @minItems 1
   */
  smartAppDashboardCardEvents?: SmartAppDashboardCardEventRequest[];
}

/** An event used to trigger a client action on a SmartApp dashboard card. */
export interface SmartAppDashboardCardEventRequest {
  /**
   * A developer defined dashboard card ID.
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "my_dashboard_card"
   */
  cardId?: string;
  lifecycle?: DashboardCardLifecycle;
}

export enum DashboardCardLifecycle {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export interface SmartAppEventRequest {
  /**
   * An arbitrary name for the custom SmartApp event.  Typically useful as a hook for in-app routing.
   * @format ^[a-zA-Z_]{1,36}$
   */
  name?: string;
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 256 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

export type CreateInstalledAppEventsResponse = object;

export interface SceneSummary {
  /** Scene type */
  type?: 'CLASSIC' | 'SEQUENCED';
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The user-defined name of the Scene */
  sceneName?: string;
  /** The name of the icon */
  sceneIcon?: string;
  /** The color of the icon */
  sceneColor?: string;
  /** The unique identifier of the backing behavior */
  behaviorId?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The unique identifier of the user that created the scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  createdBy?: string;
  /**
   * The date the scene was created
   * @format date-time
   */
  createdDate?: string;
  /**
   * The date the scene was last updated
   * @format date-time
   */
  lastUpdatedDate?: string;
  /**
   * The date the scene was last executed
   * @format date-time
   */
  lastExecutedDate?: string;
  /** Whether or not this scene can be edited by the logged in user using the version of the app that made the request */
  editable?: boolean;
  /** Date-based version of the API with which the scene was created in format YYYYMMDD */
  apiVersion?: string;
}

export type Scene = SceneSummary & {
  /** device configuration objects */
  devices?: SceneDevice[];
  /** The mode activated by the Scene */
  mode?: SceneMode;
  /** device group action */
  devicegroups?: SceneDeviceGroup[];
  /** Whether or not this scene's behavior is locally executed */
  executingLocally?: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:scenes - the user can edit the scene
   *   <li> x:scenes - the user can execute the scene
   *   <li> d:scenes - the user can delete scene
   *   </ul>
   */
  allowed?: 'w:scenes' | 'x:scenes' | 'd:scenes';
};

export interface SceneDevice {
  /** the id of the device */
  deviceId?: string;
  /** the label of the device */
  deviceLabel?: string;
  /** the name of the device */
  deviceName?: string;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceTypeId?: string;
  components?: SceneComponent[];
  /**
   * Location of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface SceneDeviceGroup {
  /** the id of the device */
  deviceGroupId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode activated by the Scene */
export interface SceneMode {
  /**
   * the id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /** the name of the mode */
  modeName?: string;
}

/** JSON body for creating or updating a Scene */
export interface SceneRequest {
  /** The user-defined name of the Scene */
  sceneName: string;
  /** The name of the icon */
  sceneIcon?: string;
  /**
   * The color of the icon
   * @format ^\#[0-9A-F]{6}$
   */
  sceneColor?: string;
  /** Non-sequential list of device actions */
  devices: SceneDeviceRequest[];
  /** List of parallel action sequences */
  sequences?: SceneActionSequence[];
  /** The mode to be activated by the Scene */
  mode?: SceneModeRequest;
  /** The security mode to be activated by the Scene */
  securityMode?: SceneSecurityModeRequest;
  /** List of device group actions */
  devicegroups?: SceneDeviceGroupRequest[];
}

export type SceneActionSequence = SceneAction[];

/** Possible scene actions, mutually exclusive */
export interface SceneAction {
  /** JSON structure for a device when creating a Scene */
  deviceRequest?: SceneDeviceRequest;
  /** The mode to be activated by the Scene */
  modeRequest?: SceneModeRequest;
  /** Sleep a particular sequence */
  sleepRequest?: SceneSleepRequest;
  /** JSON structure for a device group when creating a Scene */
  deviceGroupRequest?: SceneDeviceGroupRequest;
}

/** JSON structure for a device when creating a Scene */
export interface SceneDeviceRequest {
  /**
   * the id of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  components?: SceneComponent[];
}

/** JSON structure for a device group when creating a Scene */
export interface SceneDeviceGroupRequest {
  /**
   * the id of the device group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode to be activated by the Scene */
export interface SceneModeRequest {
  /**
   * The id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The name of the mode */
  modeName?: string;
}

/** The security mode to be activated by the Scene */
export interface SceneSecurityModeRequest {
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The id of the security mode */
  security: 'setArmStay' | 'setArmAway' | 'disarm';
  /** Additional query param */
  arguments?: string;
}

/** Sleep a particular sequence */
export interface SceneSleepRequest {
  /** Number of seconds to sleep the sequence */
  seconds: number;
}

/** A component of the scene device */
export interface SceneComponent {
  /** the id of the component */
  componentId?: string;
  capabilities?: SceneCapability[];
}

/** A device component capability */
export interface SceneCapability {
  /** The id of the capability */
  capabilityId?: string;
  /** The status of the capability */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
  /** Capability commands */
  commands?: Record<string, SceneCommand>;
}

/** A component capability command */
export interface SceneCommand {
  /** the command arguments */
  arguments?: SceneArgument[];
}

/** A capability command argument */
export interface SceneArgument {
  /** the name of the command */
  name?: string;
  /** the schema of the command */
  schema?: object;
  /** The value being set for the capability command */
  value?: object;
}

export interface ScenePagedResult {
  items?: SceneSummary[];
  _links?: Links;
}

export interface SceneDevicePagedResult {
  items?: SceneDevice[];
  _links?: Links;
}

/** {"status": "success"} */
export interface StandardSuccessResponse {
  /** @default "success" */
  status?: 'success';
}

export type RegistrationRequest = Registration;

export type RegistrationResponse = Registration;

export interface Registration {
  /** Type of registration */
  type?: RegistrationType;
  armAway?: RegistrationTargetConfig;
  armStay?: RegistrationTargetConfig;
  disarm?: RegistrationTargetConfig;
  armState?: {
    url?: string;
    supportedOptionalReturnValues?: string[];
  };
}

export interface RegistrationTargetConfig {
  url?: string;
  supportedOptionalArguments?: string[];
}

/** Type of registration */
export enum RegistrationType {
  APP = 'APP',
  DEVICE = 'DEVICE',
}

export type RegistrationDeletionResponse = object;

/** Security system arm state */
export enum SecurityArmState {
  ARMED_AWAY = 'ARMED_AWAY',
  ARMED_STAY = 'ARMED_STAY',
  DISARMED = 'DISARMED',
}

export interface SecurityArmStateResponse {
  /** Security system arm state */
  armState: SecurityArmState;
  /** If Home monitoring service is installed, default is 'true' */
  vssEnabled: boolean;
  /** Return only when VA(Voice Assistant) is set. */
  vaEnabled?: boolean;
}

export type ArmAwayRequest = object;

export type ArmAwayResponse = object;

export type ArmStayRequest = object;

export type ArmStayResponse = object;

export type DisarmRequest = object;

export type DisarmResponse = object;

export interface NotificationRequest {
  /** The target location of sending push message. */
  locationId: string;
  /** The notification indicator type. The type determines the type of alerts the user sees on the device. */
  type: 'ALERT' | 'SUGGESTED_ACTION' | 'EVENT_LOGGING' | 'AUTOMATION_INFO';
  /**
   * The title and content that you want to display with the push message. Individual supported language sets may be added in the form of ISO standard {language code}_{country code} and are shown to a user according to the settings of the mobile device. If you add a default set here, you can set the default language when it does not match with the actual setting.
   * @example [{"en_US":{"title":"${System.locationNickname}","body":"The job is now ${progress} % in progress."}},{"default":{"title":"${System.locationNickname}","body":"The job is now ${progress} % in progress."}}]
   */
  messages: MessagesObject[];
  /** Supports the ability to replace the custom variable in a title or body. The format of 'key' must be of the form ${...}. If you want to show the location nickname that the platform has, put it as the form of ${System.locationNickname} in the title or body. */
  replacements?: ReplacementsObject[];
  /**
   * Supports the ability to launch the specific plugin on your SmartThings app.
   * @example {"type":"device","id":"b968e0f3-c542-4256-acfa-e7690dac7ef9"}
   */
  deepLink?: {
    /** The plugin type where the push message will be delivered. */
    type?: 'device' | 'installedapp' | 'location';
    /** The specific plugin id. */
    id?: string;
  };
  /** Notification image url. */
  imageUrl?: string;
}

export interface MessagesObject {
  localeCode?: {
    title?: string;
    body?: string;
  };
}

/** @example {"key":"${progress}","value":"50"} */
export interface ReplacementsObject {
  key?: string;
  value?: string;
}

/** Represents a single page of Hub information. */
export interface PagedHubList {
  items?: Hub[];
  _links?: Links;
}

export interface Hub {
  /**
   * @format uuid
   * @example "6496be9a-aa23-4320-b60f-904e472db962"
   */
  id?: string;
  /** @example "Happy Hub" */
  name?: string;
  /** @example "D052A82674C90001" */
  eui?: string;
  /** @example "john.doe@smartthings.com" */
  owner?: string;
  /** @example "30.xx" */
  firmwareVersion?: string;
}

export interface HubUpdateRequest {
  /** @example "Happy hub" */
  name?: string;
  /** @example "1234abcd-eaff-47b3-80d6-a4cbe14e3344" */
  locationId?: string;
}

/** The type of message group entity. */
export enum MessageGroupEntityType {
  INSTALLED_APP = 'INSTALLED_APP',
  USER = 'USER',
}

export type App = EndpointApp[];

export interface UserIdApp {
  /** UserId */
  userId?: string;
  endpointApps?: EndpointApp[];
}

export interface Isa {
  /** Possible values - __requiresLogin__ or __loggedIn__. These two values determine what fields are returned in this response. If value is "requiresLogin", only "oAuthLink" is returned in the response. If value is "loggedIn", only isaId, partnerName, appName, devices and icons are returned. */
  pageType?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** partner or brand name eg LIFX Inc. */
  partnerName?: string;
  /** Connector name. eg Lifx (Connect) */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** location of the installed smart app */
  locationId?: string;
  devices?: DeviceResults[];
  /** generated oAuth link for the user to login to partner server. This will only be returned when the user is not logged in. */
  oAuthLink?: string;
  viperAppLinks?: ViperAppLinks;
  /** connection status between partner and ST platform */
  partnerSTConnection?: 'connected' | 'disconnected';
}

export interface LocationIsa {
  installedSmartApps?: IsaResults[];
}

export interface GetOauthCallback200Resp {
  /** Number of new partner devices added */
  devices_added?: number;
  /** Number of existing partner devices */
  existing_devices?: number;
  /** Number of partner devices which Viper failed to create */
  failed_to_create_devices?: number;
}

export interface GetOauthCallback400Resp {
  /** Error sent by partner */
  error?: string;
  /** Error description sent by partner */
  error_description?: string;
  /** Error URI sent by partner */
  error_uri?: string;
  viper_error?:
    | 'missing_required_query_parameters'
    | 'redirect_expired'
    | 'unexpected_redirect_called'
    | 'oauth_state_verification_failed';
}

export interface GetOauthCallback404Resp {
  viper_error?: 'isa_not_found' | 'endpoint_app_not_found';
}

export interface GetOauthCallback424Resp {
  viper_error?:
    | 'access_token_request_failed'
    | 'discovery_request_failed'
    | 'isa_deleted'
    | 'grant_callback_access_failed';
}

export interface GetOauthCallback500Resp {
  viper_error?: 'server_error';
}

export interface OauthCallbackJson {
  /** isaId */
  isaId?: string;
  /** partner or brand name */
  partnerName?: string;
  /** SmartThings Schema App name */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  devices?: DeviceResults[];
}

export interface IsaResults {
  /** isaId installed for the user */
  isaId: string;
  /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
  appName: string;
  /** Parnter name eg Lifx Inc */
  partnerName: string;
  /** url of partner icon */
  icon: string;
  /** url of partner icon in 2x dimensions */
  icon2x: string;
  /** url of partner icon in 3x dimensions */
  icon3x: string;
  /** location of the installed smart app */
  locationId: string;
  /** connection status between partner and ST platform */
  partnerSTConnection: 'connected' | 'disconnected';
  /** endpoint app id of the installed smart app */
  endpointAppId: string;
}

export interface PostEndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface EndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName?: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl?: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** endpoint app id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId?: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret?: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl?: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType?: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface ViperAppLinks {
  /** app deep linking to partners in android */
  android?: string;
  /** app deep linking to partners in ios */
  ios?: string;
  /** whether deep app linking is enabled */
  isLinkingEnabled?: boolean;
}

export interface DeviceResults {
  /** deviceId created by DM */
  deviceId?: string;
  /** initial device name from the partner */
  name?: string;
}

export interface CommandResponse {
  success?: string;
}

export interface CommandBody {
  /** deviceId of the device */
  deviceId?: string;
  /** command name to be processed on the device */
  commandName?: string;
  /** Arguments for specific command types like setLevel, colorControl etc. */
  arguments?: CommandArguments[];
}

/** @example 30 */
export type CommandArguments = string;

export interface PostReceipt {
  /**
   * @format uuid
   * @example "viper_9121f970-f503-11e8-a7de-7319cef9605d"
   */
  endpointAppId?: string;
  /**
   * @format uuid
   * @example "e3fd04cb-c488-4bbd-9759-8deb512656a8"
   */
  stClientId?: string;
  /**
   * @format uuid
   * @example "02c75d945e69e167233cb635b1f9be76d97ebb0b04f4e6839f3acfad320bed64ab86838dc6312585b037259e7797bf2bb44b3caa7a60539c1f402abe3bbe9256424615fddc48e76823b9c230b15669901becb33711e48192aa54a31e4e287ff47295c61c15e2e046103f13aa250bb561136625b69304cc31ef5004d267d0847184426144c60a74329bb47e2f773469ebb6a1e585175370fda78e03413abbcafe51665e8cbe51adf37dd5a3ff376300ebdbe2a359589951a72867bd3fcc574bd77b9ac85127023f931de3c5bcb213efeab3d94a7ee4a3d20acc6f6e575755b10bceb74290f4182c9bddc407d4361710492611568ebcb0b2ffac09e70d0c977d5f"
   */
  stClientSecret?: string;
}

export interface GenerateStOauthBody {
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
}

/** @example {"invokeType":"email","fromAddress":"example@smartthings.com","toAddresses":["example@smartthings.com"],"ccAddresses":["example@smartthings.com"],"bccAddresses":["example@smartthings.com"],"isTemplatedEmail":false,"emailparams":{"subject":"Example subject.","body":{"text":"Hello. This is the email body.","html":"<div>Hello. This is the email body.</div>"}}} */
export interface EmailBody {
  /**
   * What operation the handler is performing.
   * @example "email"
   */
  invokeType: 'email' | 'createTemplate' | 'updateTemplate' | 'deleteTemplate' | 'verifyEmail';
  /**
   * Required if invokeType is email - This is the address your email will be 'from'. Any email not from the @smartthings.com domain must be verified with the verifyEmail invokeType.
   * @example "example@smartthings.com"
   */
  fromAddress?: string;
  /**
   * Required if invokeType is email - The email addresses you want to send your email to.
   * @example ["example@smartthings.com"]
   */
  toAddresses?: string[];
  /**
   * Not required - The email addresses you want to cc on your email.
   * @example ["example@smartthings.com"]
   */
  ccAddresses?: string[];
  /**
   * Not required - The email addresses you want to bcc on your email.
   * @example ["example@smartthings.com"]
   */
  bccAddresses?: string[];
  /**
   * Required if invokeType is email - Designates whether you are sending a regular email or a templated email.
   * @example true
   */
  isTemplatedEmail?: boolean;
  /** Required if invokeType is email - Contains parameters specific for regular or templated emails. */
  emailParams?: {
    /**
     * Required if isTemplatedEmail is false - The subject your regular email will have.
     * @example "Hello World"
     */
    subject?: string;
    /** Required if isTemplatedEmail is false - Contains any text or html that your email body will have. */
    body?: {
      /**
       * Required if html is not provided, but both text and html can be provided - The text format of your email body.
       * @example "Hello. This is the email body."
       */
      text?: string;
      /**
       * Required if text is not provided, but both text and html can be provided - The html format of your email body.
       * @example "<div>Hello. This is the email body.</div>"
       */
      html?: string;
    };
    /**
     * Required if isTemplatedEmail is true - Contains info needed to send a templated email.
     * @example "MyEmailTemplate"
     */
    template?: string;
    /**
     * Not Required - Contains any data to replace variables in your template. For more info: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
     * @example {"name":"John Doe"}
     */
    templateData?: object;
  };
  /**
   * Required if invokeType is createTemplate or updateTemplate - Contains data about the template. For more info, checkout the value of 'Template' here: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
   * @example {"TemplateName":"MyEmailTemplate","SubjectPart":"Hello {{name}}","HtmlPart":"<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>","TextPart":"Dear {{name}},\r\nYour favorite color is {{color}}."}
   */
  templateInfo?: {
    /**
     * Required - The name of the template. When you send the email, you refer to this name.
     * @example "MyEmailTemplate"
     */
    TemplateName?: string;
    /**
     * Required - The subject line of the email. This property may contain replacement tags. These tags use the following format: {{tagname}}. When you send the email, you can specify a value for tagname for each destination.
     * @example "Hello {{name}}"
     */
    SubjectPart?: string;
    /**
     * Required if TextPart is not provided, but both can be provided - The HTML body of the email. This property may contain replacement tags.
     * @example "<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>"
     */
    HtmlPart?: string;
    /**
     * Required if HtmlPart is not provided, but both can be provided - The text body of the email. Recipients whose email clients don't display HTML email see this version of the email. This property may contain replacement tags.
     * @example "Dear {{name}},
     * Your favorite color is {{color}}."
     */
    TextPart?: string;
  };
  /**
   * Required if invokeType is deleteTemplate - The name of the template to delete.
   * @example "MyEmailTemplate"
   */
  templateName?: string;
  /**
   * Required if invokeType is verifyEmail - The email address to verify. All email addresses from @smartthings.com are already verified. this is for external addresses such as @gmail.com
   * @example "example@gmail.com"
   */
  email?: string;
}

export interface PutIsaBody {
  /** Whether the user is required to sign in through oauth flow */
  needsAttention?: boolean;
}

export interface TriggerDiscoveryBody {
  /** @example {"schema":"st-schema","version":"1.0","interactionType":"triggerDiscovery","requestId":"fe09d40d-a55f-4bc0-8b62-2dea171567a6"} */
  headers?: {
    /** st-schema */
    schema?: string;
    /** version 1.0 */
    version?: string;
    /** triggerDiscovery */
    interactionType?: string;
    /** Matching request ID from request */
    requestId?: string;
  };
}

/** @example {"endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","locationId":"e6c887ac-f293-402a-8335-ee3557a380cd","email":"example@smartthings.com"} */
export interface TriggerPreinstallIsaBody {
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** location id of device location */
  locationId?: string;
  /** user email that is used */
  email?: string;
}

/** @example {"deviceHandlerType":"c2c-rgbw-color-bulb","deviceId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","isaId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","label":"Color Bulb"} */
export interface PutDeviceBody {
  /** Example-"c2c-rgbw-color-bulb" */
  deviceHandlerType?: string;
  /** deviceId created by ST cloud */
  deviceId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** Example -"Color Bulb" */
  label?: string;
}

export interface FlatDeviceStatus {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the device
   * @example "main"
   */
  componentId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceStatusPagedResult {
  items?: FlatDeviceStatus[];
  _links?: Links;
}

export interface ConnectedService {
  /** The name of the Connected Service */
  name?: string;
  /** The id of the Connected Service */
  id?: string;
  /** The id of the location */
  locationId?: string;
  /** The type of Connected Service */
  serviceType?: 'groovy_app' | 'endpoint_app' | 'viper_app' | 'api_only';
  /** URL to the icon that represents the Connected Service */
  iconUrl?: string;
}

export interface FlatDeviceGroupStatus {
  /**
   * The identifier for the device group.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceGroupId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceGroupStatusPagedResult {
  items?: FlatDeviceGroupStatus[];
  _links?: Links;
}

/**
 * The id of the favorite.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteId = string;

/**
 * The id of the location to which the favorite belongs.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type LocationId = string;

/**
 * The id of a Thing the favorite represents.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type MemberId = string;

/** The type of favorite. */
export enum MemberType {
  DEVICE = 'DEVICE',
  SCENE = 'SCENE',
  DEVICE_GROUP = 'DEVICE_GROUP',
}

/**
 * The id of room which this favorite belongs. Nullable.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */

// removed this line because it is a duplicate definition
// export type RoomId = string;

/** The sort order of the favorite. */
export type SortOrder = number;

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","sortOrder":1} */
export interface FavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

export interface WidgetFavoritePagedResult {
  items?: WidgetFavorite[];
  links?: Links;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","locationId":"020c9fe5-98e2-4919-9603-a20781df25d0","memberId":"f0353f80-64dd-4e03-98be-95f98f0b0a08","memberType":"SCENE","sortOrder":1} */
export interface WidgetFavorite {
  /** The id of the favorite. */
  favoriteId?: FavoriteId;
  /** The id of the location to which the favorite belongs. */
  locationId?: LocationId;
  /** The id of a Thing the favorite represents. */
  memberId?: MemberId;
  /** The type of favorite. */
  memberType?: MemberType;
  /** The sort order of the favorite. */
  sortOrder?: SortOrder;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","sortOrder":1} */
export interface WidgetFavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

/**
 * Thing to be added to widget favorites. Requires a memberId, memberType, and sortOrder.
 * @example {"memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1}
 */
export interface WidgetFavoriteBodyObject {
  /** The id of a Thing the favorite represents. */
  memberId: MemberId;
  /** The type of favorite. */
  memberType: MemberType;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

/** room wallpaper info */
export interface RoomWallpaper {
  /** Id of the location */
  locationId: string;
  /** Id of the room */
  roomId: string;
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

/** location wallpaper info */
export interface LocationWallpaper {
  /** Id of the location */
  locationId: string;
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface UpdateWallpaperBodyObject {
  /** Id of the wallpaper */
  wallpaperId: string;
}

export interface MigrateWallpapersBodyObject {
  /** Id of the location wallpaper */
  wallpaperId: string;
  /** List of rooms with wallpaperIds */
  roomWallpapers?: {
    /** Id of the wallpaper */
    wallpaperId: string;
    /** Id of the room */
    roomId: string;
  }[];
}

export interface InstalledAppSummary {
  /** The type of app. SMARTAPP is a legacy SmartApp, ENDPOINTAPP is a SmartApp from the public API. */
  appType: 'SMARTAPP' | 'ENDPOINTAPP';
  /** This will only be populated when appType is SMARTAPP */
  smartapp?: {
    /** The developer-defined name of the app */
    name: string;
    /** The user-defined label of the installedapp */
    label?: string;
    /** The id of the installed app */
    installedAppId: string;
    /**
     * The id of the location the app is installed
     * @format uuid
     */
    locationId: string;
    /** Whether or not the SmartApp has been completely installed */
    state: 'COMPLETE' | 'INCOMPLETE';
    /**
     * An icon image url for the app
     * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
     */
    iconUrl: string;
    /** @default "NONE" */
    samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
    /**
     * Whether or not the automation can be paused
     * @default false
     */
    pausable: boolean;
    /**
     * Whether or not the automation is paused
     * @default false
     */
    paused: boolean;
    /**
     * Whether or not the automation is maintained by SmartThings or a third party
     * @default false
     */
    usesThirdPartyAuthentication: boolean;
  };
  /**
   * This will only be populated when appType is ENDPOINTAPP
   * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]}
   */
  endpointapp?: {
    /**
     * The ID of the installed app.
     * @format uuid
     */
    installedAppId: string;
    /** Denotes the type of installed app. */
    installedAppType: InstalledAppType;
    /**
     * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
     * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
     * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
     * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
     * 'AUTHORIZED' Installed App will not execute.
     */
    installedAppStatus: InstalledAppStatus;
    /**
     * A user defined name for the installed app. May be null.
     * @maxLength 100
     */
    displayName?: string;
    /** The ID of the app. */
    appId: string;
    /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
    referenceId?: string;
    /**
     * The ID of the location to which the installed app may belong.
     * @format uuid
     */
    locationId?: string;
    /** A typed model which provides information around ownership of a specific domain. */
    owner: Owner;
    notices: Notice[];
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    createdDate: string;
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    lastUpdatedDate: string;
    /**
     * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
     * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
     */
    ui?: {
      /** @format ^[a-zA-Z._]{1,99}$ */
      pluginId?: string;
      /** @format uri */
      pluginUri?: string;
      dashboardCardsEnabled: boolean;
      preInstallDashboardCardsEnabled: boolean;
    };
    /**
     * A default icon image for the app.
     * @example {"url":"https://smart-home-monitor.com/image"}
     */
    iconImage?: {
      /**
       * A default icon image url for an app. https url required.
       * @format uri
       */
      url?: string;
    };
    /**
     * An App maybe associated to many classifications.  A classification drives how the integration is presented
     * to the user in the SmartThings mobile clients.  These classifications include:
     * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
     * * SERVICE - Denotes an integration that is classified as a "Service".
     * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
     * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
     * * HIDDEN - Denotes an integration that should not display in mobile clients
     */
    classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
    /** Denotes the principal type to be used with the app.  Default is LOCATION. */
    principalType: 'LOCATION' | 'USER_LEVEL';
    /** Restriction tier of the install, if any. */
    restrictionTier?: number;
    /**
     * Inform the installation systems that the associated app can only be installed once within a user's account.
     * @default false
     */
    singleInstance: boolean;
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     * <ul>
     * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
     * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
     * </ul>
     */
    allowed?: string[];
  };
}

/** A tile corresponding to a scene */
export interface SceneTile {
  /** the name of the tile */
  name?: string;
  /** the label of the tile, currently same as name */
  label?: string;
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  memberId?: string;
  /** The name of the icon */
  iconName?: string;
  /** The color of the icon */
  iconColor?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Type of the tile. Hardcoded to scene */
  type?: string;
  /** State of the Scene */
  state?: string;
  /** The type of object the tile represents, hardcoded to SCENE */
  memberSource?: string;
  /** SmartApp Id of the Scene */
  installedSmartAppId?: string;
  /** The width of the tile. Hard-coded to 3 */
  width?: number;
  /** The width of the tile. Hard-coded to 3 */
  height?: number;
  /** Indicates whether the scene is editable */
  action?: 'DEFAULT' | 'READ_ONLY';
  /** The url to the icon */
  iconUrl?: string;
  /** The url to the icon */
  iconX2Url?: string;
  /** The url to the icon */
  iconX3Url?: string;
}

export interface SceneTilePagedResult {
  items?: SceneTile[];
  _links?: Links;
}

export interface LegacyInstalledAppSummary {
  /** The developer-defined name of the app */
  name: string;
  /** The user-defined label of the installedapp */
  label?: string;
  /** The id of the installed app */
  installedAppId: string;
  /**
   * The id of the location the app is installed
   * @format uuid
   */
  locationId: string;
  /** Whether or not the SmartApp has been completely installed */
  state: 'COMPLETE' | 'INCOMPLETE';
  /**
   * An icon image url for the app
   * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
   */
  iconUrl: string;
  /** @default "NONE" */
  samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
  /**
   * Whether or not the automation can be paused
   * @default false
   */
  pausable: boolean;
  /**
   * Whether or not the automation is paused
   * @default false
   */
  paused: boolean;
  /**
   * Whether or not the automation is maintained by SmartThings or a third party
   * @default false
   */
  usesThirdPartyAuthentication: boolean;
}

export interface DeviceHealthResponse {
  /** Id of the device */
  deviceId?: string;
  /** Current state of the device */
  state?: 'ONLINE' | 'UNHEALTHY' | 'OFFLINE';
  /**
   * Last reported date/time in UTC in milliseconds since epoch
   * @format int64
   * @example 1511913638679
   */
  lastUpdatedDate?: number;
  /** id of the location the device is in. Will be null for user level devices */
  locationId?: string;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","sceneName":"Test Scene","sceneIcon":"st.scenes.wand","ocfIconId":"200","locationId":"ece68254-ad83-4c49-9b96-5a723098a118","locationName":"Test Location"}
 */
export interface SceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The name of the Scene. Not nullable. */
  sceneName?: string;
  /** The name for the Scene Icon. Nullable. */
  sceneIcon?: string;
  /** The id for the OCF Icon. Not nullable. */
  ocfIconId?: string;
  /**
   * The location id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The name for the location of the Scene. Not nullable. */
  locationName?: string;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","locationId":"ece68254-ad83-4c49-9b96-5a723098a118"}
 */
export interface CreateSceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
  /**
   * The location id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  sortOrder?: number;
}

export interface ConnectedServiceSummary {
  /** The type of Connected Service */
  serviceType: 'ENDPOINTAPP' | 'SMARTAPP' | 'VIPER';
  /**
   * This will only be populated when appType is ENDPOINTAPP
   * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]}
   */
  endpointapp?: {
    /**
     * The ID of the installed app.
     * @format uuid
     */
    installedAppId: string;
    /** Denotes the type of installed app. */
    installedAppType: InstalledAppType;
    /**
     * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
     * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
     * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
     * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
     * 'AUTHORIZED' Installed App will not execute.
     */
    installedAppStatus: InstalledAppStatus;
    /**
     * A user defined name for the installed app. May be null.
     * @maxLength 100
     */
    displayName?: string;
    /** The ID of the app. */
    appId: string;
    /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
    referenceId?: string;
    /**
     * The ID of the location to which the installed app may belong.
     * @format uuid
     */
    locationId?: string;
    /** A typed model which provides information around ownership of a specific domain. */
    owner: Owner;
    notices: Notice[];
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    createdDate: string;
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    lastUpdatedDate: string;
    /**
     * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
     * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
     */
    ui?: {
      /** @format ^[a-zA-Z._]{1,99}$ */
      pluginId?: string;
      /** @format uri */
      pluginUri?: string;
      dashboardCardsEnabled: boolean;
      preInstallDashboardCardsEnabled: boolean;
    };
    /**
     * A default icon image for the app.
     * @example {"url":"https://smart-home-monitor.com/image"}
     */
    iconImage?: {
      /**
       * A default icon image url for an app. https url required.
       * @format uri
       */
      url?: string;
    };
    /**
     * An App maybe associated to many classifications.  A classification drives how the integration is presented
     * to the user in the SmartThings mobile clients.  These classifications include:
     * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
     * * SERVICE - Denotes an integration that is classified as a "Service".
     * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
     * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
     * * HIDDEN - Denotes an integration that should not display in mobile clients
     */
    classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
    /** Denotes the principal type to be used with the app.  Default is LOCATION. */
    principalType: 'LOCATION' | 'USER_LEVEL';
    /** Restriction tier of the install, if any. */
    restrictionTier?: number;
    /**
     * Inform the installation systems that the associated app can only be installed once within a user's account.
     * @default false
     */
    singleInstance: boolean;
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     * <ul>
     * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
     * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
     * </ul>
     */
    allowed?: string[];
  };
  /** This will only be populated when appType is SMARTAPP */
  smartapp?: {
    /** The developer-defined name of the app */
    name: string;
    /** The user-defined label of the installedapp */
    label?: string;
    /** The id of the installed app */
    installedAppId: string;
    /**
     * The id of the location the app is installed
     * @format uuid
     */
    locationId: string;
    /** Whether or not the SmartApp has been completely installed */
    state: 'COMPLETE' | 'INCOMPLETE';
    /**
     * An icon image url for the app
     * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
     */
    iconUrl: string;
    /** @default "NONE" */
    samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
    /**
     * Whether or not the automation can be paused
     * @default false
     */
    pausable: boolean;
    /**
     * Whether or not the automation is paused
     * @default false
     */
    paused: boolean;
    /**
     * Whether or not the automation is maintained by SmartThings or a third party
     * @default false
     */
    usesThirdPartyAuthentication: boolean;
  };
  /** This will only be populated when appType is VIPER */
  viper?: {
    /** isaId installed for the user */
    isaId: string;
    /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
    appName: string;
    /** Parnter name eg Lifx Inc */
    partnerName: string;
    /** url of partner icon */
    icon: string;
    /** url of partner icon in 2x dimensions */
    icon2x: string;
    /** url of partner icon in 3x dimensions */
    icon3x: string;
    /** location of the installed smart app */
    locationId: string;
    /** connection status between partner and ST platform */
    partnerSTConnection: 'connected' | 'disconnected';
    /** endpoint app id of the installed smart app */
    endpointAppId: string;
  };
}

export interface VoiceAssistantApp {
  /** The name of the app */
  name: string;
  /** Icon for the app from hawker */
  icon?: string;
  /** localization info */
  localizations: {
    /** metadata display name */
    metadataDisplayName: string;
    /** language string the rest of the data is for */
    language: string;
  }[];
  /** appLinks */
  appLinks: {
    /** ios url */
    ios: string;
    /** android url */
    android: string;
    /** web url */
    web?: string;
    /** activation uri */
    activationUri?: string;
  };
  /** additional metadata for voice app with arbitrary key-value string map */
  voiceAppMetadata?: Record<string, string>;
  /** whether it is connected to the account or not. will be true if locations is not empty */
  connected: boolean;
  /** list of locations where the app is installed */
  locations: VoiceAssistantAppLocation[];
  /** key for pii consent info */
  pii_key?: string;
}

export interface VoiceAssistantAppLocation {
  /** id of the location */
  locationId: string;
  /** name of the location */
  name: string;
}

export interface UserMigrationStatus {
  status?: 'DONE' | 'INCOMPLETE' | 'NOT_STARTED';
  showWelcomeFlow?: boolean;
}

export interface LocationUsersResponse {
  owner: LocationUser;
  members: LocationUser[];
}

export interface LocationUser {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "e4190894-6ab2-4c80-a233-29fa9e87ae90"
   */
  uuid: string;
  /**
   * will be null for smartthings accounts
   * @example "pcg38apioc"
   */
  samsungAccountId?: string;
  /** @example "Mickey Mouse" */
  name: string;
  /** @example "mickey@mouse.com" */
  email: string;
}

export interface UserToRemove {
  /** @example "mickey@mouse.com" */
  email: string;
}

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","locationId":"811ba20b-9c6f-4064-851e-53e6fd3985ff","memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1,"additionalId":null,"bucket":null} */
export interface Favorite {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location. */
  locationId: FavoriteLocationId;
  /** The id of a Thing the favorite represents. */
  memberId: FavoriteMemberId;
  /** The type of favorite. */
  memberType: FavoriteMemberType;
  /** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
  sortOrder: FavoriteSortOrder;
  /** Additional Id used for SERVICE favorites. */
  additionalId?: FavoriteAdditionalId;
  /** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
  bucket?: FavoriteBucket;
  /** The model of device that created the favorite. Used for debugging purposes. */
  deviceModel: FavoriteDeviceModel;
  /**
   * The date the favorite was created.
   * @format date-time
   */
  createdDate: string;
  /**
   * The date the favorite was updated.
   * @format date-time
   */
  lastUpdatedDate: string;
}

/**
 * The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteLocationId = string;

/** The id of a Thing the favorite represents. */
export type FavoriteMemberId = string;

/** The type of favorite. */
export enum FavoriteMemberType {
  DEVICE = 'DEVICE',
  DEVICE_GROUP = 'DEVICE_GROUP',
  SCENE = 'SCENE',
  SERVICE = 'SERVICE',
  D2D = 'D2D',
}

/** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
export type FavoriteSortOrder = number;

/** Additional Id used for SERVICE favorites. */
export type FavoriteAdditionalId = string;

/** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
export type FavoriteBucket = string;

/** The model of device that created the favorite. Used for debugging purposes. */
export type FavoriteDeviceModel = string;

/** Request body for fade cancellation. */
export interface FadeCancelRequest {
  /**
   * The deviceId for which the fade light effects need to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

/** Request body for circadian cancellation. */
export interface CircadianCancelRequest {
  /**
   * The deviceId for which the circadian light effect needs to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

/** map view info to update. Will not update the other rooms/devices in location */
export interface RoomsAndDevicesMapViewData {
  rooms?: RoomMapViewData[];
  devices?: DeviceMapViewData[];
}

export interface RoomMapViewData {
  /**
   * The UUID of the room.
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  roomId: string;
  /** Data used for indoor map. */
  indoorMap: {
    /**
     * The reference id for the map room. Setting this key to null deletes the map room from the room.
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
  };
}

export interface DeviceMapViewData {
  /**
   * The UUID of the device
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  deviceId: string;
  /** The location of a device on a floorplan map, if any. */
  indoorMap: IndoorMap;
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

export interface InstallRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface MigrationInstallRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /** SMS message groups for the App.  This is optional. */
  smsMessageGroups?: MessageGroup[];
}

export interface MessageGroup {
  /**
   * The message group key for the migrated SHM app
   * @example "message_group_key_leak"
   */
  messageGroupKey: string;
  /**
   * A channel is a compound identifier which combines both the message protocal and destination to which a
   * message should be delivered.  A channel value follows the following format: `<protocol>:<target-destination>`.
   *
   * ## Supported Protocols
   * | Protocol | Channel Format | Restrictions |
   * | -------- | -------------- | ------------ |
   * | SMS      | sms:+19999999999 | Phone Number in E.164 format. Messaging API is only supported for US based phone numbers. |
   */
  recipients: string[];
  /**
   * A user defined name for the message group.
   * @maxLength 100
   */
  displayName?: string;
}

export interface NextPageRequest {
  installInformation?: InstallInformation;
  /** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
  configurationData?: ConfigurationData;
}

export interface InstallInformation {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface InstallSummary {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface StartInstallResponse {
  installSummary?: InstallSummary;
  appSummary?: AppSummary;
  /** The first page for the install. */
  page?: Page;
}

export interface InstallResponse {
  /** The initial setting to be returned when starting a new configuration install. */
  app?: Setting & {
    /**
     * A developer defined page ID of the first page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    firstPageId?: string;
    /**
     * A developer defined page ID of any page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    customDisplayNamePageId?: string;
    /**
     * Disable the ability for the user to customize the display name.
     * @default false
     */
    disableCustomDisplayName?: boolean;
    /**
     * Disable the ability to remove the app from the configuration flow.
     * @default false
     */
    disableRemoveApp?: boolean;
    permissions?: string[];
  };
  installSummary?: InstallSummary;
  /** The first page for the install. */
  page?: Page;
  /** If the app is preauthorized or not. */
  preauthorized?: boolean;
}

export interface NextPageResponse {
  installSummary?: InstallSummary;
  page?: Page;
}

export interface UpdateInstallRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface UpdateInstallResponse {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface AppSummary {
  /**
   * Name of the app to be configured.
   * @maxLength 256
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
  /**
   * A developer defined page ID of the first page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  firstPageId?: string;
  requirements?: Requirement[];
}

export interface Requirement {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Value chosen for this configuration setting.
   * @maxLength 2048
   */
  value?: string;
  permissions?: string[];
}

export interface Section {
  /**
   * Name of the section.
   * @maxLength 128
   */
  name?: string;
  /**
   * Whether or not the section can be collapsed
   * @default false
   */
  hideable?: boolean;
  /**
   * If section can be collapsed, whether or not it defaults to hidden
   * @default false
   */
  hidden?: boolean;
  /**
   * Change how the section is presented
   * @default "NORMAL"
   */
  style?: 'NORMAL' | 'FOOTER';
  /**
   * Configuration settings represent the questions asked to the end user installing an integration the answers to
   * which provide the configuration for which the integration will use when executing. Settings follow an inheritance
   * pattern.  The type field dictates the expected instance of setting that is provided.
   */
  settings?: SectionSetting[];
}

export interface Setting {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Name of the setting to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
}

/** Device Setting */
export type DeviceSetting = Setting & {
  /** Indicates if this device setting can have multiple values. */
  multiple?: boolean;
  /** The required capabilities for the device(s) options. */
  capabilities?: string[];
  /** The required permissions for the selected device(s). */
  permissions?: ('READ' | 'EXECUTE' | 'WRITE')[];
  /** The device options for this setting that meet the required cababilities. */
  options?: Device[];
};

export interface Device {
  id?: string;
  name?: string;
  type?: string;
}

/** Enum Setting */
export type EnumSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** Display the enum options as groups. */
  groupedOptions?: GroupedOption[];
  /** The enum options. */
  options?: Option[];
};

/** Mode Setting */
export type ModeSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** The mode options. */
  options?: Option[];
};

export interface GroupedOption {
  /**
   * The display name of this group of enum options.
   * @maxLength 128
   */
  name?: string;
  /** The enum options. */
  options?: Option[];
}

export interface Option {
  /**
   * The unique ID for this option.
   * @maxLength 128
   */
  id?: string;
  /**
   * The display name for this option.
   * @maxLength 128
   */
  name?: string;
}

export interface Page {
  /**
   * Name of the page to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * A developer defined page ID for the next page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  nextPageId?: string;
  /**
   * A developer defined page ID for the previous page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /**
   * Indicates if this is the last page in the configuration process.
   * @default false
   */
  complete?: boolean;
  /**
   * Change how the page is presented
   * @default "NORMAL"
   */
  style?: 'NORMAL' | 'SPLASH';
  /**
   * The text for the next button. Only applies if style is `SPLASH`
   * @maxLength 128
   */
  nextText?: string;
  /** The display sections for user defined settings. */
  sections?: Section[];
}

/** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
export interface ConfigurationData {
  /** Denotes the current installation phase. */
  phase: 'INITIALIZE' | 'PAGE';
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * The previous page the user completed. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /** Settings currently configured by user. */
  config?: ConfigMap;
  /** Global settings as defined on the App. */
  settings?: Record<string, string>;
}

export interface ServiceAppCompleteRequest {
  installInformation?: ServiceInstallInformation;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface ServiceInstallInformation {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface ServiceAppCompleteResponse {
  /**
   * Url that is used to allow/deny permissions and redirect to install/finalize endpoint.
   * @example "https://consigliere-regionald.smartthingsgdev.com/oauth/authorize?response_type=code&principal=installedapp:{{installedAppId}}:{{locationId}}&client_id={{clientId}}&state={{encrypted_state}}&installedAppId={{installedAppId}}&installedAppConfigId={{configurationId}}&language=en&redirect_uri=https://strongman-regionald.smartthingsgdev.com/install/finalize"
   */
  url?: string;
}

export interface SwatchDefinitionResponse {
  /** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
  swatchType: SwatchType;
  capabilityId: string;
  label: string;
  icon: string;
  attributeName?: string;
  command?: string;
  /** A list of arguments to be included in the request to set the color. */
  arguments?: ColorSwatchArgument[];
  /** A list of possible states this Swatch can be in. */
  possibleStates?: EnumeratedSwatchPossibleState[];
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  /** Data specific to the on or off state of a toggle control. */
  onState?: ToggleState;
  /** Data specific to the on or off state of a toggle control. */
  offState?: ToggleState;
  type?: string;
  appearance?: string;
}

export interface WrappedSwatchItem {
  /** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
  type: SwatchType;
}

/** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
export enum SwatchType {
  BUTTON = 'BUTTON',
  COLOR = 'COLOR',
  ENUMERATED = 'ENUMERATED',
  SLIDER = 'SLIDER',
  TOGGLE = 'TOGGLE',
  VALUE = 'VALUE',
}

export interface Swatch {
  /**
   * Unique Id of a swatch.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
  /**
   * The Id of the Component represented by this Swatch.
   * @example "main"
   */
  componentId: string;
  /**
   * The Id of the Capability represented by this Swatch.
   * @example "switchLevel"
   */
  capabilityId: string;
  /** The label to display to the user. */
  label: string;
  /**
   * A url that points to the Swatch Icon.
   * @format uri
   * @example "https://client.smartthings.com/icons/capabilities/switchLevel/level"
   */
  icon: string;
}

/** A stateless control with a command. */
export type BUTTON = WrappedSwatchItem & {
  /** A stateless control with a command. */
  button: ButtonSwatch;
};

/** A stateless control with a command. */
export type ButtonSwatch = Swatch & {
  /** The command to call when the button is pushed. */
  command: string;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A control representing a color picker. */
export type COLOR = WrappedSwatchItem & {
  /** A control representing a color picker. */
  color: ColorSwatch;
};

/** A control representing a color picker. */
export type ColorSwatch = Swatch & {
  /** The method to call to set the color after user interaction. */
  command: string;
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of arguments to be included in the request to set the color. */
  arguments: ColorSwatchArgument[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** An object describing the argument to be sent when setting the color. */
export interface ColorSwatchArgument {
  /** The name of the argument which coincides with a capability attribute value. */
  name?: string;
  /** The type of value the argument should be. */
  type?: 'number';
  /** The minimum value allowed. */
  min?: number;
  /** The maximum value allowed. */
  max?: number;
  /** Whether or not this argument is required when calling the setter. */
  required?: boolean;
}

/** An enum control. */
export type ENUMERATED = WrappedSwatchItem & {
  /** An enum control. */
  enumerated: EnumeratedSwatch;
};

/** An enum control. */
export type EnumeratedSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of possible states this Swatch can be in. */
  possibleStates?: EnumeratedSwatchPossibleState[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

export interface EnumeratedSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** The command to call when the user interacts with this state. */
  command: string;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** A slider control. */
export type SLIDER = WrappedSwatchItem & {
  /** A slider control. */
  slider: SliderSwatch;
};

/** A slider control. */
export type SliderSwatch = Swatch & {
  /** The minimum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  min: object;
  /** The maximum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  max: object;
  /** The Command to call to set the value after user interaction. */
  command: string;
  /**
   * The Attribute represented by this Swatch.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit: string;
  /** The number to be added or subtracted to the current setting when incrementing or decrementing the value. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  step: object;
  /** The type of data this slider represents. */
  type: 'NUMBER' | 'INTEGER';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A toggle control. */
export type TOGGLE = WrappedSwatchItem & {
  /** A toggle control. */
  toggle: ToggleSwatch;
};

/** A toggle control. */
export type ToggleSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** Data specific to the on or off state of a toggle control. */
  onState: ToggleState;
  /** Data specific to the on or off state of a toggle control. */
  offState: ToggleState;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** Data specific to the on or off state of a toggle control. */
export interface ToggleState {
  /** The Command to call when the toggle is flipped to this state. */
  command: string;
  /** The value of the Device status that indicates whether the toggle is in this state. */
  status: string;
  /** The label to display when the the device is in this state. */
  label: string;
  /** A url to the icon that represents the toggle when it is in this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** A control with a value that doesn't have a command. */
export type VALUE = WrappedSwatchItem & {
  /** A control with a value that doesn't have a command. */
  value: ValueSwatch;
};

/** A control with a value that doesn't have a command. */
export type ValueSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit?: string;
  /** The type of data this control represents. */
  type: 'NUMBER' | 'INTEGER' | 'STRING';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
  /** A list of possible states this Swatch could be in. */
  possibleStates?: ValueSwatchPossibleState[];
};

export interface ValueSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** Information about which plugin to display for the details view. If this is present, `detailSwatchIds` will be an empty array. */
export interface SwatchPlugin {
  /** The URI for the plugin in the form `plugin://...` */
  uri?: string;
}

export interface DeviceSwatch {
  /**
   * The id of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /**
   * The Location that the Device is in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * Id of the swatch to use in the list view.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  listSwatchId: string;
  /** Ordered list of swatchIds to display on the details view. This will be an empty array if `plugin` is present. */
  detailSwatchIds: string[];
  swatches: WrappedSwatchItem[];
  /**
   * Id of the swatch to use for device health information
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  healthSwatchId: string;
  /**
   * The Room that the Device is in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** Information about which plugin to display for the details view. If this is present, `detailSwatchIds` will be an empty array. */
  plugin?: SwatchPlugin;
}

export interface PartialDeviceSwatchResponse {
  /**
   * A key used by the server to track which updates the client needs.
   * Clients must store the most recently fetched `since` value, and pass it as a query param the next time
   * DeviceSwatches are fetched. It will automatically be added to any paginated `_links` so clients
   * do not need to modify the paginated urls before calling them.
   */
  since: string;
  /**
   * A boolean that indicates whether the client should update their local cache or completely replace it.
   * `incremental: true` indicates that the cache should be updated.
   * `incremental: false` indicates that the cache should be replaced.
   * @default true
   */
  incremental: boolean;
  /**
   * A list of DeviceSwatches that have been added or modified.
   * Any DeviceSwatch in this list should replace any locally cached DeviceSwatches.
   * This is expected to be an idempotent action.
   */
  modified: DeviceSwatch[];
  /**
   * A list of Device Ids that have been deleted. Any locally cached DeviceSwatches should be removed.
   * This is expected to be an idempotent action.
   */
  deleted: string[];
  /**
   * Links to previous and next page if the result is large enough to require pagination.
   * If present, clients must fetch the `next` page by calling the specified url as-is.
   * Clients must continue fetching the `next` page until all pages hav been fetched.
   */
  _links?: Links;
}

export type SwatchStatus = FlatDeviceStatus & {
  /**
   * Unique Id of a swatch.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
};

export interface SwatchStatusPagedResult {
  items?: SwatchStatus[];
  _links?: Links;
}

export interface UiMetadata {
  n?: string;
  mnmn?: string;
  vid?: string;
  version?: string;
  type?: string;
  dpResources?: DPResources[];
  dpInfo?: DPInfo[];
  language?: Language[];
  ms?: State[];
  ma?: UiMetadataAction[];
  iconUrl?: IconUrl;
}

export interface DPResources {
  name?: string;
  group?: string;
  controllable?: boolean;
  order?: number;
  link?: MetadataLink;
  property?: string;
  valueType?: string;
  controlType?: string;
  alternatives?: Alternative[];
  range?: number[];
  step?: number;
  iconUrl?: IconUrl;
  label?: Label;
  visible?: UiMetadataVisible;
  emphasis?: boolean;
  ruleEvent?: boolean;
  ruleAction?: boolean;
}

export interface MetadataLink {
  href?: string;
  if?: string;
  rt?: string;
}

export interface DPInfo {
  os?: string;
  dpType?: string;
  dpUri?: string;
}

export interface Language {
  locale?: string;
  version?: string;
  mnmn?: string;
  vid?: string;
  poCodes?: POCodes[];
}

export interface POCodes {
  po?: string;
  label?: string;
}

export interface State {
  name?: string;
  group?: string;
  iconUrl?: string;
  type?: string;
  order?: number;
  label?: Label;
  visible?: string;
  emphasis?: boolean;
}

export interface Label {
  n?: string;
  label?: string;
  arguments?: Argument[];
}

export interface Argument {
  n?: string;
  href?: string;
  property?: string;
  valueType?: string;
  alternatives?: Alternative[];
}

export interface Alternative {
  key?: string;
  value?: string;
  type?: string;
  disabled?: boolean;
}

export interface IconUrl {
  /** Small icon url. */
  small?: string;
  /** Mid icon url. */
  mid?: string;
  /** Large icon url. */
  large?: string;
  /** Vector icon url. */
  vector?: string;
}

export interface UiMetadataVisible {
  href?: string;
  property?: string;
  operand?: string;
  operator?: string;
  source?: string;
}

export interface UiMetadataAction {
  name?: string;
  group?: string;
  type?: string;
  order?: number;
  link?: MetadataLink;
  property?: string;
  valueType?: string;
  controlType?: string;
  alternatives?: Alternative[];
  range?: number[];
  step?: string;
  iconUrl?: IconUrl;
  label?: Label;
  visible?: UiMetadataVisible;
  emphasis?: string;
}

export interface UiMetadataVersionData {
  mnmn?: string;
  vid?: string;
  version?: string;
  resource_type?: string;
}

export interface WrappedMainCard {
  /** The icon url */
  icon: string;
  /** The label to display for this card */
  label: string;
  /** The card status */
  status: string;
  details: GenericCardTypeDetails;
}

export interface GenericCardTypeDetails {
  /** The selected card type of object: `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `LIGHTS`, `BLINDS`, `WEATHER` `OUTDOOR_AIR_QUALITY` */
  cardType: CardType;
}

export type CardTypeDetails = GenericCardTypeDetails;

/** The selected card type of object: `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `LIGHTS`, `BLINDS`, `WEATHER` `OUTDOOR_AIR_QUALITY` */
export enum CardType {
  INDOOR_TEMPERATURE = 'INDOOR_TEMPERATURE',
  INDOOR_HUMIDITY = 'INDOOR_HUMIDITY',
  LIGHTS = 'LIGHTS',
  BLINDS = 'BLINDS',
  WEATHER = 'WEATHER',
  OUTDOOR_AIR_QUALITY = 'OUTDOOR_AIR_QUALITY',
}

/** Response object for type INDOOR_TEMPERATURE */
export type INDOORTEMPERATURE = CardTypeDetails & {
  indoorTemperature: CardTypeIndoorTemperature;
};

/** Response object for type INDOOR_HUMIDITY */
export type INDOORHUMIDITY = CardTypeDetails & {
  indoorHumidity: CardTypeIndoorHumidity;
};

/** Response object for type LIGHTS */
export type LIGHTS = CardTypeDetails & {
  lights: CardTypeLights;
};

/** Response object for type BLINDS */
export type BLINDS = CardTypeDetails & {
  blinds: CardTypeBlinds;
};

export type CardTypeIndoorTemperature = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatus[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeIndoorHumidity = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatus[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeLights = {
  /** Flag to identify if card is displayed as active/inactive */
  active: boolean;
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatusIcon[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeBlinds = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatusIcon[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

/** Response object for type WEATHER */
export type WEATHER = CardTypeDetails & {
  weather: CardTypeWeather;
};

/** Response object for type OUTDOOR_AIR_QUALITY */
export type OUTDOORAIRQUALITY = CardTypeDetails & {
  outdoorAirQuality: CardTypeWeather;
};

export type CardTypeWeather = {
  /** A provided url for weather */
  url: string;
  /** Name of the vendor */
  vendor?: string;
  /**
   * An ISO Alpha-3 country code. (i.e. USA, CAN)
   * @format ^[A-Z]{3}$
   */
  countryCode?: string;
  /**
   * Time the data was pulled from the content provider.
   * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
   */
  updatedTime?: string;
};

export interface SummaryCapability {
  /** The ID of the capability */
  capabilityId: string;
  /** The name of the attribute */
  attributeName: string;
  /** The ID of the component */
  componentId: string;
}

export interface SummaryRoom {
  /**
   * The roomId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
  /** The name of the room */
  name?: string;
  /** A list of devices in the room with the same capability */
  devices?: SummaryDevice[];
  /** The Summary Room status */
  status?: string;
  /** Flag to identify if card is displayed as active/inactive */
  active?: boolean;
}

export type SummaryRoomStatus = SummaryRoom & {
  /** The overall status of the rooms devices (ex - average temperature of room devices) */
  status: string;
};

export type SummaryRoomStatusIcon = SummaryRoom & {
  /** The icon url */
  icon: string;
};

export interface SummaryDevice {
  /**
   * The deviceId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** The device component id */
  componentId: string;
  /** The status of the device */
  status?: string;
}

export interface SummaryPresentation {
  data: SummaryData;
  languages: SummaryLanguages[];
}

export interface SummaryData {
  static: (
    | StaticTemperatureDefinition
    | StaticLightDefinition
    | StaticHumidityDefinition
    | StaticBlindDefinition
    | StaticWeatherDefinition
    | StaticOutdoorAirQualityDefinition
    | (StaticTemperatureDefinition &
        StaticLightDefinition &
        StaticHumidityDefinition &
        StaticBlindDefinition &
        StaticWeatherDefinition &
        StaticOutdoorAirQualityDefinition)
  )[];
  dynamic: (
    | DynamicBatteryDefinition
    | DynamicOpenDefinition
    | DynamicRunningDefinition
    | (DynamicBatteryDefinition & DynamicOpenDefinition & DynamicRunningDefinition)
  )[];
}

export interface DynamicBatteryDefinition {
  battery?: SummaryDynamicDefinition[];
}

export interface DynamicOpenDefinition {
  open?: SummaryDynamicDefinition[];
}

export interface DynamicRunningDefinition {
  running?: SummaryDynamicDefinition[];
}

export interface StaticTemperatureDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  temperature?: SummaryStaticDefinition[];
}

export interface StaticLightDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  light?: SummaryStaticDefinition[];
  group: SummaryGroup;
}

export interface StaticHumidityDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  humidity?: SummaryStaticDefinition[];
}

export interface StaticBlindDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  blind?: SummaryStaticDefinition[];
}

export interface StaticWeatherDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  weather?: {
    /** The label to display */
    label: string;
  };
}

export interface StaticOutdoorAirQualityDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  outdoorAirQuality?: {
    /** The label to display */
    label: string;
    alternatives: SummaryStateAlternatives[];
  };
}

export interface SummaryStaticDefinition {
  /** The definition type (ex - `oic.d.airconditioner` */
  type: string;
  observableDeviceEvents?: SummaryObservableDeviceEvent[];
  states: SummaryStaticState[];
  /** A list of supported platforms (ex - `iOS, Android, ...`) */
  supportedPlatforms?: SummarySupportedPlatforms;
}

export interface SummaryDynamicDefinition {
  /** The definition type (ex - `oic.d.airconditioner`) */
  type: string;
  observableDeviceEvents?: SummaryObservableDeviceEvent[];
  states: SummaryDynamicState[];
  /** A list of supported platforms (ex - `iOS, Android, ...`) */
  supportedPlatforms?: SummarySupportedPlatforms;
}

/** component/capability/attribute used to subscribe to events */
export interface SummaryObservableDeviceEvent {
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
  /** The name of the attribute */
  attribute: string;
}

export interface SummaryGroup {
  states?: SummaryGroupState[];
  actions?: SummaryGroupAction[];
}

/** State definition for group control */
export interface SummaryGroupState {
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
  /** The value to check `switch.value` */
  value: string;
}

/** Action definition for group control */
export interface SummaryGroupAction {
  /** The action button display type `standbyPowerSwitch` */
  displayType: 'standbyPowerSwitch';
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
}

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
export type StandbyPowerSwitch = SwitchCommand & SwitchState & object;

/** @example {"command":{"name":"setLock","on":"locked","off":"unlocked"}} */
export interface SwitchCommand {
  /** To specify separate commands with no arguments for on and off, use the "on" and "off" fields respectively. To specify a single command, use "name" for the command and the "on" and "off" fields for the arguments. */
  command: {
    name?: string;
    on: string;
    off: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked","label":"Lock: {{lock.value}}"}} */
export interface SwitchState {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The attribute value that corresponds to the `on` state. */
    on: string;
    /** The attribute value that corresponds to the `off` state. */
    off: string;
    /**
     * This displays a string. This can be a formatted string with variables.
     * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
     */
    label?: FormattedLabel;
  };
}

/**
 * This displays a string. This can be a formatted string with variables.
 * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
 * @example "{{temperatureMeasurement.value}}"
 */
export type FormattedLabel = string;

/**
 * Notation which indicates the value of an attribute
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "switch.value"
 */
export type Value = string;

/**
 * The data type of the `value`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ValueType = string;

/**
 * The data type of the `argument`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ArgumentType = string;

/** The possible state(s) used for displaying the label */
export interface SummaryStaticState {
  /** Flag to determine if device is displayed as active/inactive */
  active: boolean;
  /** Label displayed to user */
  label?: string;
  /** The name of the device component, or `*` for any component */
  component?: string;
  /** The name of the capability (ex - `temperatureMeasurement`) */
  capability?: string;
  visible?: SummaryStateVisible[];
  alternatives?: SummaryStateAlternatives[];
}

/** The possible state(s) used for displaying the label */
export interface SummaryDynamicState {
  /** Flag to determine if device is displayed as active/inactive */
  active: boolean;
  useDevicePresentation?: boolean;
  /** Label displayed to user */
  label?: string;
  /** The name of the device component, or `*` for any component */
  component?: string;
  /** The name of the capability (ex - `temperatureMeasurement`) */
  capability?: string;
  /** The type and interval for update frequency */
  format?: SummaryFormat;
  visible?: SummaryStateVisible[];
  alternatives?: SummaryStateAlternatives[];
}

/** When populated, the properties defined to determine when the state should be displayed. */
export interface SummaryStateVisible {
  /** The device component id */
  component: string;
  /** The capability id */
  capability: string;
  /** The attribute value */
  value: string;
  /** The value to match on */
  operand: string;
  /** The operator value to use when matching the operand value (ex - EQUAL) */
  operator:
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'EQUALS'
    | 'DOES_NOT_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_OR_EQUALS'
    | 'LESS_THAN'
    | 'LESS_THAN_OR_EQUALS'
    | 'ONE_OF';
}

/** Alternative values for the state label */
export interface SummaryStateAlternatives {
  /** The status key (ex - `open`) */
  key: string;
  /** The PO_CODE value to translate for the label */
  value: string;
}

/** A list of supported platforms (ex - `iOS, Android, ...`) */
export type SummarySupportedPlatforms = string[];

/** The type and interval for update frequency */
export interface SummaryUpdateFrequency {
  /** The update type (ex - immediately, periodic...) */
  type: 'immediately' | 'periodic';
  /** Optional interval value, will not be populated when type is `immediately` */
  interval?: number;
}

/** The type and interval for update frequency */
export interface SummaryFormat {
  /** The format type (ex - `HH:mm`) */
  type: string;
  /** Interval value (ex - `60`) */
  interval?: number;
}

/** A locale and list of translated strings */
export interface SummaryLanguages {
  /** The locale to translate */
  language: string;
  data: LanguageData[];
}

/** A key and value used to translate labels with PO Code */
export interface LanguageData {
  /** The PO_CODE key used to determine the value */
  key: string;
  /** The translated value */
  value: string;
}

export interface InstallCompleteRequest {
  installInformation?: AppInstallInformation;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface AppInstallInformation {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface InstallCompleteResponse {
  /**
   * Url that is used to allow/deny permissions and redirect to install/finalize endpoint.
   * @example "https://consigliere-regionald.smartthingsgdev.com/oauth/authorize?response_type=code&principal=installedapp:{{installedAppId}}:{{locationId}}&client_id={{clientId}}&state={{encrypted_state}}&installedAppId={{installedAppId}}&installedAppConfigId={{configurationId}}&language=en&redirect_uri=https://clientd.smartthingsgdev.com/strongman/install/finalize"
   */
  url?: string;
}

export interface InstallInitializeRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
}

export interface InstallInitializeResponse {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the configuration.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  configurationId?: string;
  /** Indicates if the app is certified. */
  certified?: boolean;
  /** The display name of the app. */
  displayName?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /** The initial setting to be returned when starting a new configuration install. */
  initializeSetting?: InitializeSetting;
}

/** The initial setting to be returned when starting a new configuration install. */
export type InitializeSetting = Setting & {
  /**
   * A developer defined page ID of the first page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  firstPageId?: string;
  /**
   * A developer defined page ID of any page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  customDisplayNamePageId?: string;
  /**
   * Disable the ability for the user to customize the display name.
   * @default false
   */
  disableCustomDisplayName?: boolean;
  /**
   * Disable the ability to remove the app from the configuration flow.
   * @default false
   */
  disableRemoveApp?: boolean;
  permissions?: string[];
};

export type SectionSetting = Setting & {
  /**
   * Indicates if this setting is required for configuration.
   * @default false
   */
  required?: boolean;
  /**
   * Indicates if this setting should be disabled
   * @default false
   */
  disabled?: boolean;
  /** Denotes the type of setting. */
  type: SettingType;
};

/** Denotes the type of setting. */
export enum SettingType {
  DEVICE = 'DEVICE',
  DATE = 'DATE',
  DAYSOFWEEK = 'DAYSOFWEEK',
  TEXT = 'TEXT',
  PASSWORD = 'PASSWORD',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  MODE = 'MODE',
  SCENE = 'SCENE',
  LINK = 'LINK',
  PAGE = 'PAGE',
  ANIMATION = 'ANIMATION',
  ANIMATIONS = 'ANIMATIONS',
  IMAGE = 'IMAGE',
  IMAGES = 'IMAGES',
  VIDEO = 'VIDEO',
  GENERIC_MEDIA = 'GENERIC_MEDIA',
  MEDIA_CAROUSEL = 'MEDIA_CAROUSEL',
  TIME = 'TIME',
  PARAGRAPH = 'PARAGRAPH',
  EMAIL = 'EMAIL',
  DECIMAL = 'DECIMAL',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  OAUTH = 'OAUTH',
  SOUND = 'SOUND',
  COLOR = 'COLOR',
  MESSAGE_GROUP = 'MESSAGE_GROUP',
  ROOM = 'ROOM',
}

/** @example {"code":200,"message":"OK"} */
export interface SuccessResponseEmpty {
  code?: number;
  message?: string;
}

export interface GetCertResponse {
  certificateChain: string;
  certificate: string;
  snlpEnv?: number;
}

/** @example {"deviceType":"TV","certificateArn":"arn:aws:acm-pca:us-east-2:xxxxx:certificate-authority/xxxxx-150f-4c0d-8774-xxxxxx/certificate/xxxxxxxxxxxxxxxxxx"} */
export interface GetCertRequest {
  deviceType: CertDeviceType;
  certificateArn: string;
}

/** @example {"deviceId":"10cb7f1e-28c1-4a35-9b4c-c91316acf55f","uuid":"testUUID","scope":"fixed-helper","findNode":{"type":"STATIONARY","host":"TV","version":"1.0.0","policyVersion":"1.0.0","configuration":{"allowedNlpGap":-1,"allowManualGeolocation":true},"geolocation":{"latitude":"123.266139","longitude":"123.999873"}},"publicKey":"MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAulyFtNFU+VYCLLye0o1/STulacRjTDjkcV1GtgJrzuOKPoKs3...."} */
export interface GetTokenRequest {
  scope: string;
  deviceId: string;
  uuid: string;
  /** Info of fixed find node */
  findNode?: {
    /** type of fixed find node (STATIONARY | MOVING) */
    type: string;
    /** host of fixed find node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
    host: string;
    /** version of fixed find node */
    version: string;
    /** policy version of fixed find node. */
    policyVersion?: string;
    /** location of fixed find node (e.g TV or HUB) */
    geolocation?: {
      latitude: string;
      longitude: string;
    };
  };
  /**
   * RSA public key encoded in base64. This publicKey is used to encrypt server side key & iv.
   * RSA keypair spec
   * - key size : 2048bit
   * - format : PKCS#8
   */
  publicKey?: string;
}

export interface DeviceAdvertisement {
  /** Whole Service Data encoded in base64 from byte data. (not hexstring) */
  serviceData: string;
}

export interface IssueCertResponse {
  certificateArn: string;
}

export interface FixedHelperGeolocationItem {
  /**
   * Fmm Device's advertising privacyId [ It’s mandatory when type is `others` not `tag` ]
   * encoded in base64 from byte data. (not hexstring)
   */
  privacyId?: string;
  deviceAdvertisement: DeviceAdvertisement;
  geolocation: GeolocationInput;
}

/** @example {"items":[{"deviceAdvertisement":{"serviceData":"EjcxADM6J/OOwrfl8wAAADWjNi8="},"privacyId":null,"geolocation":{"latitude":"123.266139","longitude":"123.999873","method":"wifi","accuracy":"20.284","heading":"1","speed":"5.00000","timestamp":1623654701}}],"findNode":{"type":"STATIONARY","host":"TV","version":"1.0.0","configuration":{"allowedNlpGap":-1,"allowManualGeolocation":true}}} */
export interface FixedHelperGeolocationRequest {
  items: FixedHelperGeolocationItem[];
  /** Info of fixed find node */
  findNode?: {
    /** type of fixed find node (STATIONARY | MOVING) */
    type: string;
    /** host of find node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
    host: string;
    /** version of fixed find node */
    version: string;
    /** Configuration of find node */
    configuration: FindNodeConfiguration;
  };
}

export enum CertDeviceType {
  TV = 'TV',
  HUB = 'HUB',
  LAPTOP = 'LAPTOP',
}

/** @example {"deviceType":"TV","csr":"LS0tLS1CRUdJTiBDRVJUSUZJQ0FURSBSRVFVRVNULS0tLS0KTUlJQ3J6Q0NBWmNDQVFBd2FqRUxNQWtHQTFVRUJoTUNTMUl4RGpBTUJnTlZCQWdNQlZOMWQyOXVNUnd3R2dZRApWUVFLREJOVFlXMXpkVzVuSUVWc1pXTjBjbTl1YVdOek1Sa3dGd1lEVlFRTERCQlRiV0Z5ZEZSb2FXNW5jeUIwClpXRnRNUkl3RUFZRFZRUUREQWxvZFdKb1pXeHdaWEl3Z2dFaU1BMEdDU3FHU0liM0RRRUJBUVVBQTRJQkR3QXcKZ2dFS0FvSUJBUUNpNjJKU3JwVVVqS1NvdHROMVdRVDZxZ3lSb1g2S2FBenRvZEEwNWErZmVrd2o5d2JPd01jZgpSVjREemQ3dE10ajdGQnAraFJCQjZydVZWT3hCOU1YM0g2aUNzUGsrR2J2dkNaNlRSeml3UHUwWm1IY1ZtRzVSClFLUHg3N2RqcEFFejVYcXM4bG5LOXhtOG5xUkprMXlvV0xwdkpySWFaY2VPeC9XVFFVc0Z2QVNKUThvMmZqZkcKeklob2JpRDFkbmxTNGNIMHJ5Mjk5eG9qMUd3Tm92d0NXOUJKY0szRHdEb2xucXdqY3VMdEtSQjhMdUd0eCtyVQo4OVEwWng3VkZZQXpIcE9XVW81OXpRL25PVzlGT1V5aDJjMVludHIwRTA3ZHVpTXNlRDh2U3dBTGJWY2FkR0lICnByelNaMTRJNTB4ZGk2a0wxYzR5bzR6elRZbzNFRmtaQWdNQkFBR2dBREFOQmdrcWhraUc5dzBCQVFzRkFBT0MKQVFFQWZCdy81SmlVbzFRaE1CcHVkMktQb0pIYnhkRStRVWg1eVRxVmw1Q1g5ZEE3R1JZSis4MkNXT2dKcmFGVQo4V2xRblVFNXlKWU1NT0V4KzZyTWxtRGIyUXlPNDExUDBNaDFHUzlMS3NpaUIrZ0hOdXBCblh3VXRVaXNxRDFSClhmQXprSjVKbjBhWEZPQmNoZ01IeGJuNVJoTUlmN1hNOE9yRkNtOVd1NjVaZ21TUTZQU2F6dU5LcUxQYldPUVcKdDZuSVc2VE1kUzNsRFJuZFdtWlBpeXJNYnFCSE90SjIrMWhMN21XYlJMWkxtV2ZDM0hhdXBHb1RuZ0hrY0JvYgovSlQvVUtLdVh0VWRVNnZPZEFoQ1k4b2VObnFxL1FESlBBeHV5VG5ST1B4Y2YvdFp5ayt0U0JVYWdDWEJNRUZFCjVpb01SQVFZcTg4SWhYa1BHaTVPKzhZcVVBPT0KLS0tLS1FTkQgQ0VSVElGSUNBVEUgUkVRVUVTVC0tLS0tCg==","deviceId":"10cb7f1e-28c1-4a35-9b4c-c91316acf55f"} */
export interface IssueCertRequest {
  deviceType: CertDeviceType;
  csr: string;
  deviceId: string;
}

export interface PubKeyItem {
  result: string;
  encryptionEnabled?: boolean;
  pid: string;
  pubKey?: string;
}

export interface GetFixedHelperPubKeyResponse {
  items: PubKeyItem[];
}

export interface FixedHelperCreateLocationResponse {
  /** Request logging Id */
  requestId: string;
  /** Policy data of findNode */
  fmmResponse?: string;
}

export interface GetTokenResponse {
  scope: string;
  helperDataRouter: HelperDataRouterResponse;
  accessToken: string;
  tokenType: string;
  expiresAt: number;
  /** Info of fixed find node */
  findNode?: {
    /** type of fixed find node (STATIONARY | MOVING) */
    type?: string;
    /** host of find node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
    host?: string;
    /** version of fixed find node */
    version?: string;
    /** policy version of fixed find node */
    policyVersion?: string;
    /** Configuration of find node */
    configuration: FindNodeConfiguration;
    /** location of fixed find node (e.g TV or HUB) */
    geolocation?: {
      latitude: string;
      longitude: string;
    };
  };
}

export interface HelperDataRouterResponse {
  name: string;
  url: string;
}

export type CSVParams = object;

/** @example {"authString":"c2RmYXMzM2Rmc2Rm","nonceT":"aBTpegIjc9eStOcgjU0COA==","algorithm":"AES128-CBC-PKCS7padding","tagAdvertisement":{"serviceData":"EwgqACh6L50VI2mHcwAAABdkJjI="}} */
export interface AnonymousRequest {
  /** Base64 encoded initial vector. Typically created by a tag and then passed to the app */
  nonceT: string;
  /** Base64 encoded data to be encrypted for authentication */
  authString: string;
  /** Default: AES128-CBC-PKCS7padding. This is only algorithm supported for now */
  algorithm?: string;
  tagAdvertisement: TagAdvertisement;
}

export interface AnonymousResponse {
  encryptedAuthString: string;
  commandKey: string;
  lostMessage?: TrackerLostMessage;
}

export interface TrackerLostMessage {
  phoneNumber?: string;
  type?: TrackerLostMessageType;
  message?: string;
  enabled: boolean;
}

export type TrackerLostMessageType = object;

export interface GetGeolocationsResponse {
  items: GetGeolocationsResponseItem[];
}

export interface GetGeolocationsResponseItem {
  /** @format uuid */
  deviceId: string;
  /** User guid of Samsung Account */
  saGuid: string;
  geolocations: GeolocationOutput[];
}

export interface CreateGeolocationsRequest {
  /** Array containing location datum of multiple tracker devices (array length must be 1 - Phase 1) */
  items: CreateGeolocationsRequestItem[];
  /** Info of find node */
  findNode?: FindNode;
}

/** Location data set of a tracker device */
export interface CreateGeolocationsRequestItem {
  tagAdvertisement: TagAdvertisement;
  geolocation: GeolocationInput;
}

export interface TagAdvertisement {
  /** Raw data advertised by a tag, encoded in base64 */
  serviceData: string;
}

export interface TagAdvertisementInputForTrackedBatchRequest {
  /** Raw data advertised by a tag, encoded in base64 */
  serviceData: string;
  /**
   * the time when this device (scanner/helper) captured this advertisement
   * @format int64 (UTC timestamp in sec)
   */
  timestamp: number;
}

export interface GeolocationInput {
  /**
   * Geographic coordinate (-90, 90)
   * @format may be encrypted
   */
  latitude: string;
  /**
   * Geographic coordinate (-180, 180)
   * @format may be encrypted
   */
  longitude: string;
  /**
   * The method used to produce location data
   * @format may be encrypted
   */
  method?: string;
  /**
   * Radius of a circle around given coordinates (meter)
   * @format may be encrypted
   */
  accuracy?: string;
  /**
   * Degree measured between the latest location and the second latest location (-180, 180)
   * @format may be encrypted
   */
  heading?: string;
  /**
   * Travel speed (Km/H)
   * @format may be encrypted
   */
  speed?: string;
  /**
   * RSSI of BLE signal (dBM)
   * @format may be encrypted
   */
  rssi?: string;
  /**
   * Battery level
   * VERY_LOW (<= 5%) The tag's battery level is very low
   * LOW (<= 15%) The tag's battery level is low
   * MEDIUM (<= 90%) The tag's battery level is medium
   * FULL (<= 100%) The tag's battery level is full
   */
  battery?: TagBatteryLevelEnums;
  /** Whether location is reliable */
  valid?: boolean;
  /** Time which location is measured (epoch time in milliseconds) */
  timeStamp?: number;
}

export interface GeolocationOutput {
  /**
   * `true` : Tag is nearby or connected
   * `false` : Tag is no longer nearby or connected
   */
  nearby?: boolean;
  /**
   * `bleScanned` : ST app is able to scan the tag
   * `gattConnected` : ST app is GATT connected with the tag
   * if omitted, regarded as `bleScanned`
   */
  d2dStatus?: string;
  /**
   * `true` : Geolocation posted as per on-demand request
   * `false` : Geolocation posted as per ST app’s algorithm
   * if omitted, regarded as `false`
   */
  onDemand?: boolean;
  connectedDevice?: {
    /**
     * Phone’s ST device uuid when the tracker is connected to a phone
     * @format uuid
     */
    id: string;
    /** Phone’s name when the tracker is connected to a phone */
    name: string;
  };
  connectedUser?: {
    /** User’s Samsung Account Guid when the tracker is connected to a phone */
    id: string;
    /** User’s name when the tracker is connected to a phone */
    name: string;
  };
  /**
   * Geographic coordinate (-90, 90)
   * @format may be encrypted
   */
  latitude: string;
  /**
   * Geographic coordinate (-180, 180)
   * @format may be encrypted
   */
  longitude: string;
  /**
   * The method used to produce location data
   * @format may be encrypted
   */
  method?: string;
  /**
   * Radius of a circle around given coordinates (meter)
   * @format may be encrypted
   */
  accuracy?: string;
  /**
   * Degree measured between the latest location and the second latest location (-180, 180)
   * @format may be encrypted
   */
  heading?: string;
  /**
   * Travel speed (Km/H)
   * @format may be encrypted
   */
  speed?: string;
  /**
   * RSSI of BLE signal (dBM)
   * @format may be encrypted
   */
  rssi?: string;
  /**
   * Battery level
   * VERY_LOW (<= 5%) The tag's battery level is very low
   * LOW (<= 15%) The tag's battery level is low
   * MEDIUM (<= 90%) The tag's battery level is medium
   * FULL (<= 100%) The tag's battery level is full
   */
  battery?: TagBatteryLevelEnums;
  /** Stored time of data on server (epoch time in milliseconds) */
  lastUpdatedTime: number;
  /** Whether location is reliable */
  valid?: boolean;
  /** Find node info that provided the location */
  findNode?: {
    /** Host of find Node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
    host: string;
    /** Version of find node */
    version: string;
  };
}

export interface EncryptionInput {
  /**
   * List of objects that are encrypted in given geolocation item
   * @example ["latitude","longitude"]
   */
  encObjs: string[];
}

export interface EncryptionOutput {
  /**
   * List of objects that are encrypted in given geolocation item
   * @example ["latitude","longitude"]
   */
  encObjs: string[];
}

export interface GetTrackerGeolocationResponse {
  /** User guid of Samsung Account */
  saGuid: string;
  geolocations: GeolocationOutput[];
  /**
   * The key of the item where the operation stopped, inclusive of the previous result.
   * If offset is present in the response, you need to paginate the result set.
   * Use this value to fetch next result.
   */
  offset?: string;
}

export interface CreateTrackerGeolocationsRequest {
  /**
   * `true` : Tag is nearby or connected
   * `false` : Tag is no longer nearby or connected
   */
  nearby: boolean;
  /**
   * `bleScanned` : ST app is able to scan the tag
   * `gattConnected` : ST app is GATT connected with the tag
   * if omitted, regarded as `bleScanned`
   */
  d2dStatus?: string;
  /**
   * `true` : Geolocation posted as per on-demand request
   * `false` : Geolocation posted as per ST app’s algorithm
   * if omitted, regarded as `false`
   */
  onDemand?: boolean;
  connectedDevice: ConnectedDevice;
  connectedUser: ConnectedUser;
  geolocation: GeolocationInput;
  /** Info of find node */
  findNode?: FindNode;
}

export interface CreateTrackerGeolocationsResponse {
  /** Current epoch time of the server to sync with tag (in sec). */
  currentServerTime?: number;
}

/** @example {"deviceId":"96dcd0d4-4dca-4ace-93ed-5b7075d3a642","encryptionKey":"WByffon7cfQOBTfNPVhlmVf_UYsOk0r_G3MtSZpeqeU=","identifier":"EB3691320678","deviceManufacturerCode":"Samsung Electronics","metadata":{"vid":"IM-SmartTag-BLE","mnmn":"Samsung Electronics","sa_guid":"r5o4yjmiyj"},"tagData":{"mnId":"0afd","setupId":"430","modelName":"EI-T5300","serialNumber":"C234EBB5D4C5","firmware":{"version":"v1.0.0","specVersion":"v1.0.0"}}} */
export interface TrackerRequest {
  cipher?: string;
  /** Values used for QR scan */
  tagData?: TrackerRequestTagQRData;
  /** Device S/N */
  identifier: string;
  /** Device meta data. Chaser checks whether it is Tracker or not with `vid` and `mnmn` values. */
  metadata: TrackerRequestMetadata;
  /** `MASTER-SECRET` Value for generating pIds. The length of tracker’s encryptionKey is 64(32byte) or more. */
  encryptionKey: string;
  /** Device ID registered in Gizmo. */
  deviceId: string;
  deviceManufacturerCode?: string;
  /**
   * Key to encrypt latitude and longitude
   * Base64 encoded
   */
  e2eePublicKey?: string;
  /**
   * true: E2E Encryption ON
   * false: E2E Encryption OFF(initial value)
   */
  e2eeEnabled?: string;
}

export interface TrackerRequestMetadata {
  /** Vendor ID */
  vid: string;
  /** Manufacturer name */
  mnmn: string;
  /** Samsung account user guid */
  sa_guid: string;
}

/** @example {"saGuid":"r5o4yjmiyj","version":"v1.0"} */
export interface TrackerPPRecordRequest {
  /** User guid of Samsung Account */
  saGuid: string;
  /** Privacy policy version */
  version: string;
}

export interface TrackerMetaPPRecordResponse {
  /** User guid of Samsung Account */
  saGuid: string;
  /** Privacy policy version */
  version: string;
  /** Updated time */
  updated: number;
}

/** Values used for QR scan */
export interface TrackerRequestTagQRData {
  /** Model name of tag device */
  modelName: string;
  /** Serial number of tag device */
  serialNumber: string;
  /** Setup Id of tag device */
  setupId: string;
  /** MnId of tag device */
  mnId: string;
  firmware?: {
    version?: string;
    specVersion?: string;
  };
}

/** Tag firmware version */
export interface TrackerRequestTagDataFirmware {
  /** version */
  version?: string;
}

export interface TrackerResponse {
  /** If the status code is 201, it is `required`. */
  metadata: TrackerResponseMetadata;
}

export interface TrackerResponseMetadata {
  /** The number to know environment / region at the device. */
  regionCode: number;
  /** When Tag onboards initial value must be set */
  numAllowableConnections: number;
  iBeacon: Beacon;
  lastKnownConnection?: LastKnownConnection;
  /** Enum: `"stop"` `"searching"` `"spotted"`. Searchings status of a tracker. */
  searchingStatus: SearchingStatus;
  /** Seed value to compute privacy ID. */
  privacyIdSeed: string;
  /** The numbers of privacyId. */
  privacyIdPoolSize: number;
  /** Privacy ID IV(Initial Vector) value */
  privacyIdInitialVector: string;
  /** Current epoch time of the server to sync with tag (in sec). */
  currentServerTime: number;
  /** Most recently synched Tag’s aging timer value (epoch in sec). */
  timer?: number;
  /** A message to show to the person who acquired my tag when I lost it. */
  lostMessage: TrackerLostmessageOutput;
  /** Values for E2E Encryption */
  e2eEncryption?: TrackerE2EEncryptionConfig;
  /** Whether to save only the latest location information */
  geolocationStorage: GeolocationStorage;
  remoteRing?: RemoteRingResponse;
  shareable: ShareableResponse;
  onboardedBy: OnboardedByResponse;
  agingCounter?: AgingCounterResponse;
  battery?: BatteryResponse;
  vendor: VendorResponse;
  firmware: TrackerFirmwareMetadataResponse;
  /** Category Info */
  category: {
    /**
     * Category ID
     * @default 0
     */
    id?: number;
  };
  /** Epoch time in sec when this data is firstly created (when tag onboarded) */
  createTime: number;
  /** Epoch time in sec when this data is lastly updated */
  updateTime: number;
  /** Update a tacker's priority connection */
  priorityConnection?: UpdatePriorityConnectionResponse;
  /** whether fmm search option of fmm web turns on or off. */
  fmmSearch?: boolean;
  /** A tracker's overmature offline entry time information. */
  ooTime?: {
    /** OO entry time on the tracker side. */
    currentOoTime?: number;
    /** OO entry time on the server side. */
    defaultOoTime?: number;
  };
  /** A tracker's privacy id pool size information. */
  pidPoolSize?: {
    /** Pid pool size on the server side. */
    desiredPidPoolSize?: number;
    /** Pid pool size on the tracker side. */
    currentPidPoolSize?: number;
  };
  /** Active mode info of TAG */
  activeMode?: {
    /** active mode value of TAG [Normal Mode(0), Power Saving Mode(1), Activity Tracker Mode(2)] */
    mode?: number;
  };
}

export interface Beacon {
  /** Unique ID of device within iBeacon UUID (4bytes, Base64 encoded). */
  majorMinorId?: string;
  /** Unique Vender ID for iBeacon (16bytes, Base64 encoded). */
  uuid?: string;
}

export interface PPRecord {
  saGuid?: string;
  version?: string;
  updated?: string;
}

export interface CreateTrackerRequest {
  /** @format uuid */
  deviceId: string;
  advertisingId?: string;
  /** @format uuid */
  locationId?: string;
  label?: string;
  roomId?: string;
  profileId?: string;
  routingKey?: string;
  encryptionKey: string;
  cipher?: string;
  identifier: string;
  deviceManufacturerCode?: string;
  metadata: TrackerMetadata;
}

export interface TrackerMetadata {
  vid: string;
  mnmn: string;
  sa_guid: string;
}

export interface PubKeyResponseForBatchRequests {
  items: KeyResponseItem[];
}

export interface KeyResponseItem {
  /**
   * Privacy ID
   * @format Base64 URL Safe encoded
   */
  pid?: string;
  /** Result for the individual item processing */
  result?: 'OK' | 'DEVICE_NOT_FOUND' | 'PUBKEY_NOT_FOUND' | 'INVALID_PID';
  /** true if E2E encryption is ON */
  encryptionEnabled?: boolean;
  /**
   * Public key of the tag (If encryptionEnabled is “true” and pubKey is not null, it is included)
   * @format Base64 encoded
   */
  pubKey: string;
}

export interface Key {
  /** @format uuid */
  deviceId: string;
  /** @format Base64 encoded */
  pubKey: string;
  encPrivKey: string;
}

/** Privacy data advertised by the tracker device */
export interface PrivacyData {
  /** Privacy ID */
  id: string;
}

/**
 * Has tracker's state and scanners ID
 * @example {"state":"connected","connectedDeviceId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","connectedUserId":"ce5dcxcbaa","geolocations":[{"encryption":{"encObjs":["latitude","longitude"]},"latitude":"wJMcXFwazt4n7uHQ3ZKi9g==","longitude":"Uko5CMFXNmmTfWfPU+D+zQ==","method":"method","accuracy":"accuracy","heading":"heading","speed":"speed"}]}
 */
export interface TrackerStateItemInput {
  state: 'undefined' | 'connected' | 'disconnected' | 'lost' | 'found';
  /** connectedDeviceId is only defined when the state is "connected", "disconnected", otherwise it's null. */
  connectedDeviceId?: string;
  /** connectedUserId is only defined when the state is "connected", "disconnected", "lost", otherwise it's null. */
  connectedUserId?: string;
  /** geolocations is only defined when the state is "connected", "disconnected", otherwise it's null. */
  geolocations?: GeolocationInput[];
}

/**
 * Has tracker's state and scanners ID
 * @example {"state":"connected","connectedDeviceId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","connectedUserId":"ce5dcxcbaa","geolocations":[{"encryption":{"encObjs":["latitude","longitude"],"encPrivKey":"Ek3SJxM7etLnUsDEKbofI789uML6XwE7eTZrbj0WAeQ="},"latitude":"wJMcXFwazt4n7uHQ3ZKi9g==","longitude":"Uko5CMFXNmmTfWfPU+D+zQ==","method":"method","accuracy":"accuracy","heading":"heading","speed":"speed"}]}
 */
export interface TrackerStateItemOutput {
  state: 'undefined' | 'connected' | 'disconnected' | 'lost' | 'found';
  /** connectedDeviceId is only defined when the state is "connected", "disconnected", otherwise it's null. */
  connectedDeviceId?: string;
  /** connectedUserId is only defined when the state is "connected", "disconnected", "lost", otherwise it's null. */
  connectedUserId?: string;
  /** geolocations is only defined when the state is "connected", "disconnected", otherwise it's null. */
  geolocations?: GeolocationOutput[];
}

export interface StateItem {
  state: 'undefined' | 'connected' | 'disconnected' | 'lost' | 'found';
  /** connectedDeviceId is only defined when the state is "connected", "disconnected", otherwise it's null. */
  connectedDeviceId: string;
  /** connectedUserId is only defined when the state is "connected", "disconnected", "lost", otherwise it's null. */
  connectedUserId: string;
  lastUpdated: string;
}

/** @example {"searchingStatus":"searching","installedAppId":"75bca692-4dca-4ace-93ed-5b7075d3a642"} */
export interface TrackerSearchingStatusRequest {
  /** Searchings status of a tracker" */
  searchingStatus: SearchingStatus;
  /** Installed App Id of ST Find Plugin */
  installedAppId?: string;
}

export interface TrackerSearchingStatusResponse {
  status?: number;
}

/**
 * searching status of a tracker. it must be lowercase.
 * @example {"searchingStatus":"searching"}
 */
export interface UpdateTrackerSearchingStatusRequest {
  /**
   * Searchings status of a tracker
   *
   * | searchingStatus | description                                                                          |
   * | --------------- | ------------------------------------------------------------------------------------ |
   * | stop            | Initial status. it is updated when Onboarding or User action.                        |
   * | searching       | It is updated by User when device is lost.                                           |
   * | spotted         | It is updated when spotted by a nearby Galaxy device in searching status.            |
   * | stopByServer    | It is updated when spotted by a member or owner's Galaxy device in searching status. |
   */
  searchingStatus: SearchingStatus;
}

/** nonce */
export interface Nonce {
  nonce: string;
}

/** chaser JWT token */
export interface ChaserToken {
  accessToken: string;
  /** 1 day after being issued (epoch time) */
  expirationTime: number;
  /** Info of find node */
  findNode?: {
    /** type of find node (STATIONARY | MOVING) */
    type?: string;
    /** host of find node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
    host?: string;
    /** version of find node */
    version?: string;
    /** Configuration of find node */
    configuration: FindNodeConfiguration;
  };
}

export interface CreateTrackerResponse {
  /** Metadata required to create privacyId */
  metadata: CreateTrackerResponseMetadata;
}

/** Metadata required to create privacyId */
export interface CreateTrackerResponseMetadata {
  /** The number to know environment / region at the device */
  regionCode: number;
  /** The numbers of privacyId */
  privacyIdPoolSize: number;
  /** Seed value to compute privacy ID */
  privacyIdSeed: string;
  /** Privacy Id IV ( Initial Vector ) value */
  privacyIdInitialVector: string;
  /** Current epoch time of the server to sync with tag (in sec) */
  currentServerTime: number;
  /** When Tag onboards initial value must be set */
  numAllowableConnections: string;
  iBeacon: IBeacon;
  /** Lost mode url for NFC TAG */
  lostModeUrl?: string;
}

export interface GetTrackerMetadataResponse {
  /** The number to know environment / region at the device */
  regionCode: number;
  /** The numbers of privacyId */
  privacyIdPoolSize: number;
  /** Seed value to compute privacy ID */
  privacyIdSeed: string;
  /** Current epoch time of the server to sync with tag (in sec) */
  currentServerTime: number;
  lastKnownConnection?: LastKnownConnection;
  /**
   * Searchings status of a tracker
   *
   * | searchingStatus | description                                                                          |
   * | --------------- | ------------------------------------------------------------------------------------ |
   * | stop            | Initial status. it is updated when Onboarding or User action.                        |
   * | searching       | It is updated by User when device is lost.                                           |
   * | spotted         | It is updated when spotted by a nearby Galaxy device in searching status.            |
   * | stopByServer    | It is updated when spotted by a member or owner's Galaxy device in searching status. |
   */
  searchingStatus: SearchingStatus;
  iBeacon: IBeacon;
  /** Most recently synched Tag’s aging timer value (epoch in sec) */
  timer?: number;
  firmware: TrackerFirmwareMetadataResponse;
}

/** @example {"tagTime":1594359205} */
export interface UpdateTrackerTimerRequest {
  /** synced date time by seconds (epoch in sec) */
  tagTime: number;
}

/**
 * Tracker timer object
 * @example {"requestId":"688b8c02-72ec-47c4-93d2-cea691678503","receivedServerTime":1594359210,"tagTime":1594359205,"timeGap":5}
 */
export interface UpdateTrackerTimerResponse {
  /** epoch time when server processed the call (epoch in sec) */
  receivedServerTime: number;
  /** the same value in request payload (epoch in sec) */
  tagTime: number;
  /** time gap between what tag has and when server received */
  timeGap: number;
}

/** Create events request object */
export interface CreateTrackerEventsRequest {
  /** Array containing events datum of tracker */
  deviceEvents: TrackerDeviceEvent[];
}

/** Create events response object */
export interface CreateTrackerEventsResponse {
  /** Result of create events */
  stateChanges: boolean[];
}

/** Device event object */
export interface TrackerDeviceEvent {
  /** ID of component */
  componentId: string;
  /** ID of capability */
  capability: string;
  /** Name of attribute */
  attribute: string;
  /** State value of attribute */
  state?: object;
}

export interface IBeacon {
  /** Unique Vender ID for iBeacon (16bytes, Base64 encoded) */
  uuid: string;
  /** Unique ID of device within iBeacon UUID (4bytes, Base64 encoded) */
  majorMinorId: string;
}

export interface LastKnownConnection {
  connectedDevice?: ConnectedDevice;
  connectedUser?: ConnectedUser;
  /** When the connected information is uploaded (epoch in sec). */
  updated?: number;
  /**
   * `bleScanned` : ST app is able to scan the tag
   * `gattConnected` : ST app is GATT connected with the tag
   * if omitted, regarded as `bleScanned`
   */
  d2dStatus?: string;
  /**
   * `true` : Tag is nearby or connected
   * `false` : Tag is no longer nearby or connected
   */
  nearby?: boolean;
  /**
   * `true` : Geolocation posted as per on-demand request
   * `false` : Geolocation posted as per ST app’s algorithm
   */
  onDemand?: boolean;
}

export interface ConnectedDevice {
  /**
   * Phone’s ST device uuid when the tracker is connected to a phone
   * @format uuid
   */
  id: string;
  /** Phone’s name when the tracker is connected to a phone */
  name: string;
}

export interface ConnectedUser {
  /** User’s Samsung Account Guid when the tracker is connected to a phone */
  id: string;
  /** User’s name when the tracker is connected to a phone */
  name: string;
}

/**
 * Searchings status of a tracker
 *
 * | searchingStatus | description                                                                          |
 * | --------------- | ------------------------------------------------------------------------------------ |
 * | stop            | Initial status. it is updated when Onboarding or User action.                        |
 * | searching       | It is updated by User when device is lost.                                           |
 * | spotted         | It is updated when spotted by a nearby Galaxy device in searching status.            |
 * | stopByServer    | It is updated when spotted by a member or owner's Galaxy device in searching status. |
 */
export enum SearchingStatus {
  Stop = 'stop',
  Searching = 'searching',
  Spotted = 'spotted',
  StopByServer = 'stopByServer',
}

export interface CreateTrackerCommandsRequest {
  /** An array of commands to execute on the Device. */
  commands?: TrackerDeviceCommand[];
}

export interface CreateTrackerCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the request.
   * @format uuid
   */
  id?: string;
  /** `ACCEPTED`: the command is processing but it's outcome is unknown */
  status?: string;
}

/** @example {"component":"main","capability":"tag.updatedInfo","command":"update","arguments":[]} */
export interface TrackerDeviceCommand {
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @default "main"
   */
  component?: string;
  /** Capability that this command relates to. This must be a capability of the component. */
  capability: string;
  /** Name of the command, this must be valid for the capability. */
  command: string;
  /**
   * Arguments of the command.
   * All the required arguments defined in the capability's command argument definition must be provided.
   * The type of the arguments are dependent on the type of the capability's command argument.
   * Please refer to the capabilities definition at https://smartthings.developer.samsung.com/develop/api-ref/capabilities.html
   */
  arguments?: object[];
}

/**
 * Request must contain at least one of message, phoneNumber, enable
 * @example {"message":"This is a lost tag, please help me to find it","phoneNumber":"+821011112222","enabled":true}
 */
export interface TrackerLostmessageInput {
  message?: string;
  phoneNumber?: string;
  /** controls whether the lost message and the image is visible to AR apps */
  enabled?: boolean;
}

export interface LostmessageResponseForQrRequests {
  own: boolean;
  /** A message to show to the person who acquired my tag when I lost it. */
  lostMessage: TrackerLostmessageOutput;
  image?: TrackerImage;
}

export interface LostmessageResponseForBatchRequests {
  items: LostmessageResponseItem[];
}

export interface LostmessageResponseItem {
  /**
   * privacy ID
   * @format Base64 URL Safe encoded
   */
  pid: string;
  /** Result for the individual item processing */
  result:
    | 'OK'
    | 'DEVICE_NOT_FOUND'
    | 'NO_LOST_MESSAGE'
    | 'MESSAGE_NOT_ENABLED'
    | 'INVALID_STATE'
    | 'INVALID_AGING_COUNTER'
    | 'INVALID_SERVICE_DATA'
    | 'INVALID_PID';
  /** A message to show to the person who acquired my tag when I lost it. */
  lostmessage?: TrackerLostmessageOutput;
}

/**
 * A message to show to the person who acquired my tag when I lost it.
 * @example {"type":"CUSTOM","message":"This is a lost tag, please help me to find it","phoneNumber":"+821011112222"}
 */
export interface TrackerLostmessageOutput {
  /** There are two types. User-defined or not. PREDEFINED(default). CUSTOM */
  type: 'CUSTOM' | 'PREDEFINED';
  /** User-defined message */
  message?: string;
  /** User-defined phone number */
  phoneNumber?: string;
}

export interface CommonLostmessageOutput {
  /** message type */
  type: 'CUSTOM' | 'PREDEFINED';
  /** plain text that user defines up to 100 characters */
  message?: string;
}

export interface ImageResponse {
  items: ImageResponseItem[];
}

export interface ImageResponseItem {
  /**
   * privacy ID
   * @format Base64 URL Safe encoded
   */
  pid: string;
  /** Result for the individual item processing */
  result: 'OK' | 'DEVICE_NOT_FOUND' | 'AR_MESSAGE_NOT_ENABLED';
  image?: TrackerImage;
}

export interface TrackerImage {
  imageUrl: string;
}

/** @example {"version":"2.5.6_avz","specVersion":"1.0.0"} */
export interface TrackerFirmwareInput {
  /** installed firmware version */
  version: string;
  /** tag spec version of installed firmware version */
  specVersion?: string;
}

/** @example {"version":"2.5.6_avz","url":"https://tag-firmware-storage/path/to/firmware/bin"} */
export interface TrackerFirmwareOutput {
  version: string;
  url: string;
}

/** @example {"version":"2.5.6_avz","specVersion":"1.0.0","lastUpdatedTime":1631065537} */
export interface TrackerFirmwareMetadataResponse {
  /** installed firmware version */
  version: string;
  /** tag spec version of installed firmware version */
  specVersion?: string;
  /** epoch time in milliseconds */
  lastUpdatedTime: number;
  latestFirmware: LatestFirmwareResponse;
}

/**
 * Values for E2E Encryption
 * @example {"enabled":false}
 */
export interface TrackerE2EEncryptionConfig {
  /** Whether E2E's operation is on */
  enabled?: boolean;
}

export interface TrackerConnectionOption {
  /** When Tag onboards intial value must be set (As of 11/Nov, 2 is the initial number) */
  numAllowableConnections?: NumAllowableConnections;
}

/** When Tag onboards intial value must be set (As of 11/Nov, 2 is the initial number) */
export type NumAllowableConnections = number;

/** Whether to save only the latest location information */
export interface GeolocationStorage {
  /**
   * `true`: only most recent ONE data is stored (true by default)
   * `false`: Saves location infromation up to 7 days from now.
   */
  recentDataOnly: boolean;
}

export interface TrackedBatchRequest {
  tagAdvertisements: TagAdvertisementInputForTrackedBatchRequest[];
}

export interface PubKeyRequest {
  /** user pubkey */
  pubKey: boolean;
  /** Updated time */
  updated: number;
}

export interface CategoryRequest {
  category?: CategoryIdRequest;
}

export interface CategoryIdRequest {
  /** Selected Category ID */
  id: number;
}

export interface CategoryResponse {
  /** Epoch time when this category modified */
  updateTime: number;
  categories: CategoryResponseItem[];
}

export interface CategoryResponseItem {
  id: number;
  /**
   * true: The categories are visible to the user and can be selected.
   * false: The Categories are not visible to the user and cannot be selected.
   */
  enabled: boolean;
  name: string;
  /**
   * It has the following prefix.
   * Preload image: preload://
   * Server image: http://
   */
  iconUrl: string;
}

/**
 * Target device for remote ring service
 * @example {"remoteRing":{"enabled":true,"targetId":"AAAA:123456789","targetName":"05 device"}}
 */
export interface ButtonOptionsRequest {
  remoteRing: ButtonOptionRequestRemoteRing;
}

export interface ButtonOptionRequestRemoteRing {
  /** true: Ring My Phone enabled. false: Ring My Phone disabled */
  enabled: boolean;
  /** Target phone's deviceId that needs to ring when tag button pressed */
  targetId: string;
  /** Target phone's name */
  targetName: string;
}

/**
 * Target device for remote ring service of user
 * @example {"remoteRing":{"enabled":true,"preTargetId":"AAAA:Pre-123456789","targetId":"AAAA:123456789","targetName":"05 device"}}
 */
export interface UserButtonOptionRequest {
  remoteRing: UserOptionRequestRemoteRing;
}

export interface UserOptionRequestRemoteRing {
  /** true: Ring My Phone enabled. false: Ring My Phone disabled */
  enabled: boolean;
  /** Previous phone's deviceId that was set ring. */
  preTargetId: string;
  /** New phone's deviceId that needs to ring when tag button pressed */
  targetId: string;
  /** Target phone's name */
  targetName: string;
}

/** @example {"type":"remoteRing","targetId":"safe4ga-gafl-49lkjsdfg"} */
export interface ButtonCommandRequest {
  /** Type of command. `remoteRing` is only allowable command */
  type: string;
  /** Target ID where this command should be sent to. */
  targetId?: string;
}

export interface RemoteRingResponse {
  /** Device ID of the remote ring target */
  targetId: string;
  /** true: Ring My Phone enabled. false: Ring My Phone disabled */
  enabled: boolean;
  /** Target Phone's name */
  targetName: string;
}

/** @example {"id":100,"version":"1.0.23"} */
export interface LatestFirmwareResponse {
  /** internal object ID of the latest firmware */
  id: number;
  /** Latest firmware version available */
  version: string;
  data?: FirmwareData;
}

/** @example {"checksum":"123","size":"1024B","supportedVersion":"1.0_RELEASE"} */
export interface FirmwareData {
  /** Firmware binary checksum used for validation */
  checksum?: string;
  /** Firmware binary size */
  size?: string;
  /** Compatible minimum tag plugin version */
  supportedVersion?: string;
}

/** @example {"version":"1.0.23","url":"https://firmware.download.url"} */
export interface FirmwareUrlResponse {
  /** Latest firmware version available */
  version: string;
  /** Firmware download URL */
  url: string;
}

export interface ShareableResponse {
  /** Shareable status */
  enabled: boolean;
  members: ShareableMemberResponse[];
}

export interface ShareableMemberResponse {
  saGuid: string;
  agreementVersion: string;
  searchingStatus?: string;
  /** Time stamp when this entry is inserted to the DB */
  createTime: number;
}

/** @example {"enabled":true} */
export interface ShareableRequest {
  /**
   * true: Share the Tag with members
   * false: Stop sharing
   */
  enabled: boolean;
}

/** @example {"saGuid":"saguid","agreementVersion":"1.1.25"} */
export interface ShareableMemberRequest {
  /** Samsung Account guid of member */
  saGuid: string;
  /** Member's agreed version */
  agreementVersion: string;
}

/** @example {"agingCounterStatus":"INVALID_ALLOW"} */
export interface UpdateTrackerAgingCounterStatusRequest {
  /** aging counter status of Tracker. */
  agingCounterStatus: AgingCounterStatus;
}

/**
 * aging counter status of a tracker
 *
 * | agingCounterStatus | description                                                                |
 * | ------------------ | -------------------------------------------------------------------------- |
 * | VALID              | tracker's aging counter status is valid                                    |
 * | INVALID            | tracker's aging counter status is invalid                                  |
 * | INVALID_ALLOW      | tracker's aging counter status is invliad but User allows invalid status   |
 */
export enum AgingCounterStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  INVALID_ALLOW = 'INVALID_ALLOW',
}

/** Info of find node */
export interface FindNode {
  /** type of find node (STATIONARY | MOVING) */
  type: string;
  /** host of find node (GALAXY_PHONE | TV | GALAXY_BOOK | HUB | WIRELESS_CHARGER) */
  host: string;
  /** version of find node */
  version: string;
  /** Configuration of find node */
  configuration: FindNodeConfiguration;
}

/** Configuration of find node */
export interface FindNodeConfiguration {
  /** allowable distance difference between SNLP and GNLP (number in metets) */
  allowedNlpGap: number;
  /** whether Manually configurable node */
  allowManualGeolocation: boolean;
}

/**
 * Battery level
 * VERY_LOW (<= 5%) The tag's battery level is very low
 * LOW (<= 15%) The tag's battery level is low
 * MEDIUM (<= 90%) The tag's battery level is medium
 * FULL (<= 100%) The tag's battery level is full
 * @format may be encrypted
 */
export enum TagBatteryLevelEnums {
  VERY_LOW = 'VERY_LOW',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  FULL = 'FULL',
}

/** @example {"saGuid":"sdf93ngafg"} */
export interface OnboardedByResponse {
  /** Owner's Samsung Account GUID */
  saGuid: string;
}

/** @example {"status":"VALID","updated":1631065537} */
export interface AgingCounterResponse {
  /**
   * aging counter status of a tracker
   *
   * | agingCounterStatus | description                                                                |
   * | ------------------ | -------------------------------------------------------------------------- |
   * | VALID              | tracker's aging counter status is valid                                    |
   * | INVALID            | tracker's aging counter status is invalid                                  |
   * | INVALID_ALLOW      | tracker's aging counter status is invliad but User allows invalid status   |
   */
  status: AgingCounterStatus;
  /** Epoch time in sec when status is lastly updated */
  updated: number;
}

/** @example {"level":"VERY_LOW","updated":1631065537} */
export interface BatteryResponse {
  /**
   * Last updated battery level info of Tag device.
   * "VERY_LOW" (<= 5%) The tag's battery level is very low
   * "LOW" (<= 15%) The tag's battery level is low
   * "MEDIUM" (<= 90%) The tag's battery level is medium
   * "FULL" (<= 100%) The tag's battery level is full
   */
  level: string;
  /** Epoch time in sec when battery is lastly updated */
  updated: number;
}

/** @example {"mnId":"0AFD","setupId":"430"} */
export interface VendorResponse {
  /** mnId of the tag */
  mnId: string;
  /** setupId of the tag */
  setupId: string;
}

/**
 * Update a tacker's priority connection
 * @example {"targetId":"IMEI:123456789012345","tagMacAddress":"50:86:C0:1C:44:1B","isSendCommand":false,"lba":true,"cameraShutter":false}
 */
export interface UpdatePriorityConnectionRequest {
  /** Target device's FMM device ID that needs to Priority connection. */
  targetId?: string;
  /** MAC address of tag devcie. */
  tagMacAddress?: string;
  /** Whether to require to send commend. */
  isSendCommand: boolean;
  /** Whether to use lba feature. */
  lba: boolean;
  /** Whether to use camera shutter feature. */
  cameraShutter: boolean;
}

/**
 * Update a tacker's priority connection
 * @example {"lba":true,"cameraShutter":false}
 */
export interface UpdatePriorityConnectionResponse {
  /** Target device's FMM device ID that needs to Priority connection. */
  targetId?: string;
  /** MAC address of tag devcie. */
  tagMacAddress?: string;
  /** Whether to use lba feature. */
  lba: boolean;
  /** Whether to use camera shutter feature. */
  cameraShutter: boolean;
}

/** @example {"authString":"c2RmYXMzM2Rmc2R=","nonceT":"lC3v88SY/eTl22j+j225=","algorithm":"AES128-CBC-PKCS7padding","tagAdvertisement":{"serviceData":"E0IDAXLomcjfqaPmQwAAAMKl4l="}} */
export interface CreateSessionKeyRequest {
  /** Data to be encrypted, encoded in Base64. */
  authString: string;
  /** Initialization vector for encryption, encoded in Base64. */
  nonceT: string;
  /** Encryption algorithm to use (AES128-CBC-PKCS7padding is currently only supported) */
  algorithm?: string;
  tagAdvertisement: TagAdvertisement;
}

/** @example {"encryptedAuthString":"ZDD4LPWelcrcb2DxNGrXU=","commandKey":"bjnWk4f8o232Sk1U3oCrI=","configurationUrl":"https://apis.samsungiotcloud.com/v1/miniature/profile/profile-id","lostMessage":{"type":"CUSTOM","message":"lost message","phoneNumber":8210234123551}} */
export interface CreateSessionKeyResponse {
  /** Encrypted authString, with the key bounded to the target tracker and nonceT as IV, encoded in Base64. */
  encryptedAuthString: string;
  /** Encrypted "commandKey". (Find out more from the `Galaxy Find Network Tag Specification`) */
  commandKey: string;
  /** Device configuration url. */
  configurationUrl: string;
  lostMessage?: CommonLostmessageOutput;
}

/** @example {"nonceT":"lC3v88SY/eTl22j+j225="} */
export interface NckRequest {
  /** Initialization vector for encryption, encoded in Base64. */
  nonceT: string;
}

/** @example {"commandKey":"bjnWk4f8o232Sk1U3oCrI="} */
export interface NckResponse {
  /** Encrypted "commandKey". (Find out more from the `Galaxy Find Network Tag Specification`) */
  commandKey: string;
}

export interface GetTrackerImagesRequest {
  items: TagAdvertisement[];
}

export interface GetTrackerImagesResponse {
  items: GetTrackerImagesResponseItem[];
}

export interface GetTrackerImagesResponseItem {
  serviceData: string;
  /** Spec version of the tag */
  specVersion?: string;
  firmwareMetadata?: GetVendorFirmwareMetadataResponse;
  contents?: EasySetupImageContents[];
  /** Result for the individual item processing */
  result:
    | 'OK'
    | 'DEVICE_NOT_FOUND'
    | 'IMAGE_NOT_FOUND'
    | 'INVALID_REQUEST'
    | 'INVALID_SERVICE_DATA'
    | 'INVALID_STATE'
    | 'INVALID_SIGNATURE'
    | 'INVALID_AGING_COUNTER';
}

/** @example {"resourceType":"troubleshooting","type":"replace_tag_battery","file":"https://file-url-to-montage.server","effectFile":"https://effectFile-url-to-montage-server"} */
export interface EasySetupImageContents {
  /** page resource */
  resourceType?: string;
  /** popup page type */
  type: string;
  /** file url */
  file: string;
  /** effect file url */
  effectFile?: string;
}

/** @example {"scanDuration":20,"numOfScanTimes":3,"rssiFilter":-65} */
export interface UtsConfigResponse {
  /** Scan duration of UTS (in seconds). */
  scanDuration: number;
  /** Number of scans. */
  numOfScanTimes: number;
  /** RSSI filter for UTS. */
  rssiFilter: number;
  brand?: string;
}

export interface CheckServiceDataRequest {
  /** source service data to compare, Service data must be encoded in base64 */
  knownServiceData: string[];
  /** target service data to compare, Service data must be encoded in base64 */
  targetServiceData: string[];
}

export interface CheckServiceDataResponse {
  /**
   * Return list of target service data that matches device of known service data
   * Condition
   * - Valid service data (signature & aging count)
   * - Overmature Offline service data
   * - Same device of known service data
   */
  result: string[];
}

export interface UpdateFmmSearchRequest {
  fmmSearch: boolean;
}

export interface UpdateFmmSearchResponse {
  deviceId: string;
  guid: string;
}

export interface TrackerRingRequest {
  /** Only "start" and "stop" value allowed. ("stop" action is not supported now.) */
  command: string;
  /** Custom information forwarded. */
  custom?: object;
}

/** @example {"metadata":{"firmwareVersion":"1.0.0","firmwareSpecVersion":"1.0.1","ooTime":8,"tagPidPoolSize":1000,"timer":1623818555,"activeMode":1}} */
export interface UpdateTrackerMetadataRequest {
  metadata: {
    /** A tracker's firmware version */
    firmwareVersion?: string;
    /** A tracker's firmware spec version */
    firmwareSpecVersion?: string;
    /** The time (hour) it takes to enter into overmature offline state. */
    ooTime?: number;
    /** The number of a tracker's privacy id. */
    tagPidPoolSize?: number;
    /** A tracker's synced datetime */
    timer?: number;
    /** active mode value of TAG [Normal Mode(0), Power Saving Mode(1), Activity Tracker Mode(2)] */
    activeMode?: number;
  };
}

/** @example {"items":[{"pid":"2mZ-ARDfwuQ=","serviceData":"En/wANpmfgEQ38LkcwAAAEp1SVA="},{"pid":"37EzwdroctXeU2So","serviceData":"Eop2ABOvMJ+UFq91QgAAAKMlkFA="}]} */
export interface RetrievePubKeyRequest {
  /** The size limitation of this list is 10. */
  items: {
    /** Base64 encoded Privacy ID */
    pid: string;
    /** Base64 encoded Service Data */
    serviceData: string;
  }[];
}

/** @example {"items":[{"pid":"ClODI5b28Tw=","serviceData":"ClODI5b28Tw=","result":"OK","encryptionEnabled":true,"pubKey":"test"},{"pid":"j1f5mLUSN7A=","serviceData":"j1f5mLUSN7A=","result":"INVALID_PID"},{"pid":"j1f5mLUSN7A=","serviceData":"WAKHvgx09fw=","result":"DEVICE_NOT_FOUND"},{"pid":"j1f5mLUSN7A=","serviceData":"WAKHvgx09fw=","result":"OK","encryptionEnabled":false},{"pid":"j1f5mLUSN7A=","serviceData":"WAKHvgx09fw=","result":"PUBKEY_NOT_FOUND","encryptionEnabled":true}]} */
export interface RetrievePubKeyResponse {
  items: {
    /** requested Privacy ID */
    pid?: string;
    /** requested Service Data */
    serviceData?: string;
    /**
     * if deviceType is “tag”
     * - OK
     * - INVALID_PID
     * - DEVICE_NOT_FOUND
     * - PUBKEY_NOT_FOUND: when e2e encryption is enabled but fails to find key from FMM
     *
     * if deviceType is “others”
     * - OK
     * - INVALID_PID
     */
    result?: string;
    /**
     * if deviceType is “tag”
     * - true: if E2E encryption is ON
     * - false: if E2E encryption is OFF
     *
     * if deviceType is “others”
     * - true: if FMM returns key
     * - false: if FMM does not returns key
     *
     * null in both cases if pid is invald
     */
    encryptionEnabled?: boolean;
    /**
     * if deviceType is “tag”
     * - exists when device e2ee is ON and FMM returns key
     *
     * if deviceType is “others”
     * - exists when FMM returns key
     */
    pubKey?: string;
  }[];
}

/** @example {"encryptedData":"Gqm3VawOpOyHovvbw8qssIK+hnUTrw6obYWoO006bYBPd+9xgLYOdvNGRMYei/QL1OB20ss6nOa+taSmjgctUmGwnrIo+....","encryptedSecretKey":"DjssM2zKyNMGIljBRvks6F5Qk+e7f+OgdIzPDGqHJ54A+EZwMOXUIULpVfwGK4Hw9mRhPseHeoRRa27LuDPVsyXZ....","encryptedIv":"mwIUNbzpPW5zh8HGaBjrmJeGaY8YWyBoMf5QpVSFjL76QyXJwQEypdyMx5lDbHANI1ETakUhM56oYlvGwxzAX+9MTxxPs5X...."} */
export interface SecurityAPIResponse {
  /**
   * AES-encrypted Json String. refer to encryptedData
   * This is encoded in base64.
   */
  encryptedData: string;
  /**
   * RSA-encrypted AES SecretKey to decrypt response data.
   * Client can decrypt this value with client’s private key.
   * This is encoded in base64.
   */
  encryptedSecretKey: string;
  /**
   * RSA-encrypted AES IV to decrypt response data.
   * Client can decrypt this value with client’s private key.
   * This is encoded in base64.
   */
  encryptedIv: string;
}

/** @example {"method":"POST","uri":"/v1/kms/fixedhelper/device","body":{"test":"test"}} */
export interface CreateExecuteFmmRequest {
  /** Request HTTP Method */
  method: string;
  /** Request URI */
  uri: string;
  /** Request Body */
  body: object;
}

/** @example {"requestId":"f7da5c58-ced6-4d0d-a81f-c2a3c056e0a6","fmmResponse":"{resultCode:200}"} */
export interface CreateExecuteFmmResponse {
  /** Request logging Id */
  requestId: string;
  /** Response of Fmm */
  fmmResponse: string;
}

/** @example {"category":"tag","modelName":"EI-T7300","setupId":"abcd","mnId":"1234","vid":"IM-SmartTag-BLE-UWB","mnmn":"Samsung Electronics","sdkVersion":"1.3.8","specVersion":"0.5.6","firmwareVersion":"1.0.0","supportedFeatures":{"ringTheTag":true,"updateRingtone":true,"buttonAction":true,"batteryType":"replaceable","leftBehindAlert":true,"firmwareUpdate":true,"nfc":true,"accelerometer":true,"powerSavingMode":true}} */
export interface GetVendorFirmwareMetadataResponse {
  /** category */
  category?: string;
  /** modelName */
  modelName?: string;
  /** setupId */
  setupId: string;
  /** mnId */
  mnId: string;
  /** vid */
  vid?: string;
  /** mnmn */
  mnmn?: string;
  /** sdkVersion */
  sdkVersion?: string;
  /** specVersion */
  specVersion?: string;
  /** firmwareVersion */
  firmwareVersion: string;
  /** tag type ex) BLE or UWB */
  tagType?: string;
  supportedFeatures?: GetSupportedFeatures;
}

/** @example {"ringTheTag":true,"updateRingtone":true,"buttonAction":true,"batteryType":"replaceable","leftBehindAlert":true,"firmwareUpdate":true,"nfc":true,"accelerometer":true,"powerSavingMode":true} */
export interface GetSupportedFeatures {
  /** ringTheTag */
  ringTheTag?: boolean;
  /** updateRingtone */
  updateRingtone?: boolean;
  /** buttonAction */
  buttonAction?: boolean;
  /** batteryType */
  batteryType?: string;
  /** leftBehindAlert */
  leftBehindAlert?: boolean;
  /** firmwareUpdate */
  firmwareUpdate?: boolean;
  /** nfc */
  nfc?: boolean;
  /** accelerometer */
  accelerometer?: boolean;
  /** powerSavingMode */
  powerSavingMode?: boolean;
  /** ledBlinking */
  ledBlinking?: boolean;
}

export interface Application {
  deviceID?: string;
  publicKey?: string;
  userID?: string;
}

export interface Auth {
  authorizationURL?: string;
  clientID?: string;
  redirectURL?: string;
  responseType?: string;
  scopes?: string[];
}

export interface AvailableDevice {
  id?: string;
  providers?: AvailableProvider[];
}

export interface AvailableValidateDevice {
  id?: string;
  providerIds?: string[];
}

export interface ValidateDeviceBody {
  deviceIds?: string[];
  country?: string;
  providerIds?: string[];
}

export interface ValidateMetricBody {
  sessionType: 'created' | 'existing' | 'removed';
  providerId: string;
  /** @example "tv" */
  device?: string;
  result: 'success' | 'failure';
}

export interface AvailableValidateDeviceResponse {
  devices?: AvailableValidateDevice[];
}

export interface AvailablePlayersResponse {
  devices?: AvailableDevice[];
}

export interface AvailableProvider {
  id?: string;
}

export interface Content {
  context?: string;
  cursor?: string;
  items?: Item[];
  /** @format int64 */
  limit?: number;
  /** @format int64 */
  offset?: number;
  operation?: string;
  /** @format int64 */
  progress?: number;
  /** @format int64 */
  total?: number;
}

export interface ContentProvider {
  applications?: ProviderApplication[];
  auth?: Auth;
  companyName?: string;
  country?: string[];
  description?: string;
  /** @format int64 */
  displayOrder?: number;
  icon?: {
    /** @format int64 */
    height?: number;
    url?: string;
    /** @format int64 */
    width?: number;
  }[];
  id?: string;
  isLocal?: boolean;
  /** @format int64 */
  lastUpdateTime?: number;
  name?: string;
  supportedContentTypes?: string[];
  type?: string;
  url?: string;
  version?: string;
}

export interface ContentProviderList {
  providers?: ContentProvider[];
}

export interface Session {
  sessionId?: string;
  deviceId?: string;
  providerId?: string;
  contents?: string;
  /** @format date-time */
  timestamp?: string;
}

export interface SessionList {
  sessions?: Session[];
}

export type ContentProviderMap = Record<string, ContentProvider>;

export type Contents = object;

export interface Credentials {
  authUrl?: string;
  blob?: string;
  clientID?: string;
  linkedUserID?: string;
  userID?: string;
  userName?: string;
}

export interface CurrentlyPlayingTrack {
  context?: object;
  is_playing?: boolean;
  item?: object;
  /** @format int64 */
  progress_ms?: number;
}

export interface Description {
  albumArtist?: string[];
  albumTitle?: string;
  artist?: string[];
  /** @format int64 */
  duration?: number;
  images?: Image[];
  releaseDate?: string;
  title?: string;
  /** @format int64 */
  trackNumber?: number;
  type?: string;
}

export interface DeviceBody {
  action?: string;
  contents?: Contents;
  credentials?: Credentials;
  sessionID?: string;
}

export interface DeviceResponse {
  'x.com.samsung.ccv'?: string;
  'x.com.samsung.currentRenderer'?: string;
  'x.com.samsung.renderers'?: Renderer[];
  'x.com.samsung.uid'?: string;
}

export interface ErrorMessage {
  code?: string;
  details?: ErrorMessage[];
  message?: string;
  target?: string;
}

export interface Image {
  /** @format int64 */
  height?: number;
  url?: string;
  /** @format int64 */
  width?: number;
}

export interface Item {
  description?: Description;
  id?: string;
  item?: string;
}

export interface PlaybackInfo {
  device?: Device;
  is_Playing?: boolean;
  playedAt?: string;
}

export interface Player {
  Cp_di?: string;
  Cpid?: string;
  Data?: string;
  Id?: string;
}

export interface PlayingTrack {
  context?: object;
  item?: object;
}

export interface ProviderApplication {
  appURI?: string;
  deviceType?: string;
  fingerprint?: string;
  id?: string;
  installable?: boolean;
  manufacturerName?: string;
  modelName?: string[];
  name?: string;
  os?: string;
  osVersion?: string[];
  packageName?: string;
  platformVersion?: string[];
}

export interface ProviderData {
  Data?: string;
  /** @format date-time */
  UpdateTime?: string;
}

export interface ProviderVO {
  Data?: string;
  Enabled?: string;
  Id?: string;
}

export interface RecentlyPlayingTrack {
  context?: object;
  played_at?: string;
  track?: object;
}

export interface RecentlyPlayingTracks {
  items?: RecentlyPlayingTrack[];
}

export interface Renderer {
  action?: string;
  appURI?: string;
  application?: Application;
  contents?: Contents;
  credentials?: Credentials;
  fingerprint?: string;
  id?: string;
  name?: string;
  packageName?: string;
  /** @format int64 */
  result?: number;
  sessionID?: string;
  state?: string;
  /** @format int64 */
  timestamp?: number;
  type?: string[];
}

export interface ServiceError {
  Details?: ServiceError[];
  Syserror?: string;
  Target?: string;
}

export interface SpotifyTrackInfo {
  album?: {
    artists?: {
      name?: string;
    }[];
    images?: Image[];
    name?: string;
    release_date?: string;
  };
  artists?: {
    name?: string;
  }[];
  /** @format int64 */
  duration_ms?: number;
  id?: string;
  name?: string;
  /** @format int64 */
  track_number?: number;
}

export interface SpotifyUserProfile {
  /**
   * Country     string `json:"country,omitempty"`
   * DisplayName string `json:"display_name,omitempty"`
   * Email       string `json:"email,omitempty"`
   */
  id?: string;
}

export interface Status {
  device?: Device;
  user?: User;
  isPlaying?: boolean;
  playedAt?: string;
}

export interface TrackIndexItem {
  /** @format int64 */
  Index?: number;
  /** @format int64 */
  Total?: number;
}

export interface Tracks {
  MakeContentsBody?: Content;
}

export interface UserDelProvider {
  callback_url?: string;
  gdpr_id?: string;
  service_id?: string;
}

export interface UserEvent {
  result?: {
    events?: string[];
    serviceId?: string;
  };
  subscriptionId?: string;
  userId?: string;
}

export interface UserToken {
  company?: string;
  refreshToken?: string;
}

export interface UserFeedback {
  providerId?: string;
  devices?: DeviceFeedback[];
  action?: string;
  devicePlayed?: DeviceFeedback;
  timestampStart?: string;
  timestampEnd?: string;
}

export interface DeviceFeedback {
  locationId?: string;
  roomId?: string;
  id?: string;
  type?: string;
}

export interface UserBehaviorModel {
  modelPath?: string;
  mappingPath?: string;
  version?: string;
}

export interface GetAPDetailResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Available response data */
  data?: APDetailResponse[];
  /** Response result message */
  message?: string;
}

export interface GetConsentResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  data?: ConsentObject;
  /** Response result message */
  message?: string;
}

export interface GetUserSettingResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  data?: UserSettingObject;
}

export interface PostAPDetailResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Any failure data during request execution */
  data?: APDetailErrorResponse[];
  /** Response result message */
  message?: string;
}

export interface PostDeviceAPErrorResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Any failure data during request execution */
  data?: DeviceAPErrorObject[];
}

export interface GeneralPostResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
}

export interface GeneralPostResponseWithData {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Response related message */
  data?: string;
}

export interface GetAllAPDetailsResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Available response data */
  data?: APDetailResponse[];
  /** Response result message */
  message?: string;
}

export interface GetAllDeviceAPDetailsResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Available response data */
  data?: DeviceAPRequest[];
}

export interface APDetail {
  /** ssid associated with the AP. */
  ssid?: string;
  /** MAC address of the AP. */
  bssid?: string;
  /** SHA512 MAC address of the AP. */
  hashedBssid?: string;
  /** probable location id for AP. */
  locationId?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency?: number;
  /** List of device ids connected to the AP. */
  deviceIds?: string[];
  /** List of DeviceIdWithTimestamp objects having device ids and onboarding timestamp connected to the AP. */
  deviceIdWithTimestampList?: DeviceIdWithTimestamp[];
  /** Capability of the AP separated by space or other separator. */
  capabilities?: string;
  /** Password of the AP. */
  passphrase?: string;
  /**
   * Created time (epoch time in milliseconds) for ap details at client.
   * @format int64
   */
  timestamp?: number;
  /** Hidden AP recognition. */
  hiddenStatus?: boolean;
}

export interface OcfDeviceAPRequest {
  /** List of Device AP objects */
  deviceAPRequests?: DeviceAPRequest[];
}

export interface DeviceAPRequest {
  /** deviceId associated with the AP. It can only be a uuid string. */
  deviceId: string;
  /** ssid associated with the AP. */
  ssid: string;
  /** MAC address of the AP. */
  bssid?: string;
  /** SHA512 MAC address of the AP. */
  hashedBssid?: string;
  /**
   * Integer code of raw security.
   * @format int32
   */
  securityCode: number;
  /** raw security type. */
  security?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency: number;
  /**
   * Last updated timestamp (epoch time in milliseconds) for device ap details at client.
   * @format int64
   */
  timestamp: number;
  /** Password of the AP. */
  passphrase?: string;
  /** Hidden AP recognition. */
  hiddenStatus: boolean;
  /**
   * Number of times the AP has been used by devices.
   * @format int32
   */
  noOfDevices?: number;
}

export type KeyList = string[];

export type DeviceKeyList = string[];

export interface OcfDeviceKeyList {
  deviceIds?: string[];
}

/** ssids for which AP filtering is done for a user in Wifilocker. */
export type APDetailsFilterRequest = string;

export interface ConsentObject {
  /** Wifi Locker enable/disable setting for a user */
  enabled?: boolean;
}

export interface UserSettingObject {
  /** Wifi Locker setting value for a user. Currently, 0 - unknown, 1 - allow, 2 - deny. */
  enabled: number;
}

export interface APDetailResponse {
  /** ssid associated with the AP */
  ssid?: string;
  /** MAC address of the AP */
  bssid?: string;
  /** SHA512 MAC address of the AP */
  hashedBssid?: string;
  /** probable location id for AP */
  locationId?: string;
  /** List of device ids connected to the AP. */
  deviceIds?: string[];
  /** List of DeviceIdWithTimestamp objects having device ids and onboarding timestamp connected to the AP. */
  deviceIdWithTimestampList?: DeviceIdWithTimestamp[];
  /** Capability of the AP separated by space or other separator */
  capabilities?: string;
  /** Password of the AP. */
  passphrase?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency?: number;
  /** Hidden AP recognition. */
  hiddenStatus?: boolean;
  /**
   * Timestamp (epoch time in milliseconds) for ap detail at client when any client is plaaning to make a server data update.
   * @format int64
   */
  timestamp?: number;
  /**
   * Updated time for ap detail. This time indicates that when for the last time (epoch time in milliseconds) AP detail has been updated at server.
   * @format int64
   */
  updateTime?: number;
}

export interface APDetailErrorResponse {
  /** ssid associated with the requested AP. */
  ssid?: string;
  /** SHA512 MAC address of the requested AP. */
  bssid?: string;
  /**
   * Timestamp (epoch time in milliseconds) for ap detail at client when any client is plaaning to make a server data update.
   * @format int64
   */
  timestamp?: number;
  /** Details about the error because of which add/update of AP details didn't work. */
  errorMessage?: string;
}

export interface DeviceAPErrorObject {
  /** ssid associated with the requested AP. */
  ssid: string;
  /** SHA512 MAC address of the requested AP. */
  bssid: string;
  /** device id of the requested AP. */
  deviceId: string;
  /** Details about the error because of which add/update of AP details didn't work. */
  errorMessage: string;
}

export interface DeviceIdWithTimestamp {
  /** device id connected to AP. */
  deviceId?: string;
  /**
   * Onboarding timestamp of device in milliseconds.
   * @format int64
   */
  onboardingTimestamp?: number;
}

export interface ProxyDeviceRequest {
  id?: string;
  type?: string;
}

export interface DeviceIdentityPeripheralInfo {
  modelName?: string;
  sn?: string;
}

export interface PlansResponse {
  code?: Int;
  message?: PlanMessageResponse;
}

export interface KitsMessageResponse {
  id?: Int;
}

export interface TariffResponse {
  country?: string;
  updatedTime?: number;
  devices?: DevicesResponse[];
  services?: object[];
  type?: string;
  expiredTime?: number;
  userCentric?: boolean;
  partner?: PartnerResponse;
  activatedTime?: number;
  kit?: KitResponse;
  name?: string;
  id?: number;
  status?: string;
  purchasedTime?: number;
}

/** @example {"name":"OPEN_GLOBAL_HOME_PLAN","peripherals":[{"sn":"kitSn","type":"HUB","model":"F-CAM-VF-1"}]} */
export interface PlanKit {
  peripherals: PeripheralsModel[];
  name: string;
}

export interface PartnerInfo {
  regions?: string;
  code?: string;
  name?: string;
}

/** @example {"saguid":"docUserGuid","title":"Right to access","region":"us-east-2","gdpr_id":"1234-11b5-4271-8b23-456789","callback_url":"http://gdpr","file_path":"/v1/gdpr/data/accio/docUserGuid/1234-11b5-4271-8b23-456789","file_name":"docUserGuid-c2ad77359b22","bucket_name":"samsung-gdpr"} */
export interface GdprRequest {
  callback_url: string;
  file_path: string;
  saguid: string;
  event_type: string;
  file_name: string;
  bucket_name: string;
  channel: string;
  title: string;
  region: string;
  gdpr_id: string;
}

/** @example {"name":"OPEN_GLOBAL_HOME_PLAN","userId":"docSaguid","country":"US","status":"ACTIVE","activatedTime":1573458043541,"updatedTime":1573458043541,"services":{"HMVS_OPEN":{"status":"ACTIVE","maxNumCamera":1,"maxStorageMB":10240,"maxRetentionDays":30,"maxRecodingSeconds":60,"maxNumPermClip":100},"SHM":{"status":"ACTIVE"}}} */
export interface PlansRequest {
  country: string;
  updatedTime?: number;
  activatedTime?: number;
  devices?: SingleDeviceInfo[];
  name: string;
  services?: object;
  activationUrl?: string;
  type?: string;
  userId?: string;
  expiredTime?: number;
  status?: string;
  purchasedTime?: number;
}

export interface PeripheralsModel {
  model?: string;
  sn: string;
  type: string;
}

/** @example {"status":"ACTIVE"} */
export interface UpdatePlanStatusRequest {
  status: string;
}

export interface GetTariffInfo {
  devices?: string[];
  id?: number;
  services?: object[];
}

export interface GetLocationTariffResponse {
  locationId?: string;
  tariffs?: GetTariffInfo[];
}

export interface AppReference {
  schema?: string;
  method?: string;
  packageName?: string;
  url?: string;
}

export interface PabalReplacement {
  value?: string;
  key?: string;
}

export interface PartnerStatusV2Response {
  deviceList?: STPartnerStatusInfo[];
}

export interface DevicesResponse {
  iccid?: string;
  mnc?: string;
  partnerDeviceId?: string;
  imei?: string;
  id?: string;
  sn?: string;
  partOfTariff?: boolean;
  type?: string;
  mcc?: string;
  parentId?: number;
  manufacturer?: string;
}

/** @example {"type":"ALERT","hubSn":"testHubSn","userId":"testUser","device":{"type":"TAG","id":"testDi"},"messages":[{"es_US":{"title":"Smart Home Monitor+","body":"Smart Home Monitor+"}},{"default":{"title":"Smart Home Monitor+","body":"Smart Home Monitor+"}}]} */
export interface ProxyRequest {
  hubSn?: string;
  imageUrl?: string;
  messages: object[];
  replacements?: PabalReplacement[];
  type: string;
  userId?: string;
  device?: ProxyDeviceRequest;
}

export interface PolicyResponse {
  tariffNeeded?: boolean;
  userCentric?: boolean;
  message?: string;
}

export interface PlanMessageResponse {
  id?: Int;
}

export interface ActivationUrlResponse {
  app?: AppReference;
  appDeepLink?: string;
  requestHeaders?: object;
  web?: WebReference;
  href?: string;
}

export interface ProxyResponse {
  code?: Int;
  message?: string;
}

export interface KitResponse {
  peripherals?: PeripheralsModel[];
  type?: string;
}

export interface RestResponse {
  code?: number;
  data?: any;
  message?: string;
}

export interface DeleteDeviceInfo {
  iccid?: string;
  mnc?: string;
  partnerDeviceId?: string;
  imei?: string;
  id?: string;
  sn?: string;
  type?: string;
  mcc?: string;
  manufacturer?: string;
}

export interface GetSercommDeviceResponse {
  code?: number;
  data?: DeviceIdentityDataField;
  message?: string;
}

export interface DeleteTariffDeviceResponse {
  devices?: DeleteDeviceInfo[];
  href?: string;
}

/** @example {"id":"1234568-4110-268f-a1b4-123456","type":"CAMERA","sn":"testSn"} */
export interface RegisterDeviceRequest {
  deviceType?: string;
  mnc?: string;
  deviceCode?: string;
  type: string;
  mcc?: string;
  parentId?: string;
  manufacturer?: string;
  iccid?: string;
  partnerDeviceId?: string;
  imei?: string;
  model?: string;
  id: string;
  sn?: string;
}

export interface GetNewPlansResponse {
  country?: string;
  activatedTime?: number;
  devices?: SingleDeviceInfo[];
  name?: string;
  id?: number;
  services?: object;
  userId?: string;
  status?: string;
}

export type Int = object;

export interface KitsResponse {
  code?: Int;
  message?: KitsMessageResponse;
}

export interface PartnerResponse {
  regions?: string;
  code?: string;
  name?: string;
}

export interface WebReference {
  clientType?: string;
  method?: string;
  accessibleUrls?: string[];
  requiredPayload?: object;
  url?: string;
}

export interface SearchTariffResponse {
  country?: string;
  updatedTime?: number;
  partner?: PartnerInfo;
  activatedTime?: number;
  name?: string;
  id?: number;
  type?: string;
  expiredTime?: number;
  status?: string;
  purchasedTime?: number;
}

/** @example {"deviceType":"TAG","deviceCode":"1","imei":"testImei","sn":"testSn","os":"android","deviceId":"test-device-id","nickName":"SmartThings Tracker"} */
export interface ActivationUrlRequest {
  deviceType?: string;
  country?: string;
  mnc?: string;
  partnerCode?: string;
  os?: string;
  partnerName?: string;
  nickName?: string;
  deviceCode?: string;
  mcc?: string;
  deviceId?: string;
  deviceStatus?: string;
  iccid?: string;
  imei?: string;
  guid?: string;
  id?: string;
  sn?: string;
}

export interface SingleDeviceInfo {
  partnerDi: string;
  kit?: PlanKit;
  imei?: string;
  sn?: string;
  type?: string;
  manufacturer?: string;
}

/** @example {"diList":["testSn"],"type":"CAMERA"} */
export interface DeleteDeviceRequest {
  diList?: string[];
  type?: string;
}

/** @example {"status":"ACTIVE"} */
export type Map = object;

export interface GetKitsResponse {
  kitId: number;
  peripherals?: PeripheralsModel[];
  name: string;
}

export interface STPartnerStatusInfo {
  update_time?: string;
  service_type?: string[];
  create_time?: string;
  di?: string;
  partner_di?: string;
}

export interface DeviceIdentityDataField {
  partner?: string;
  devices?: DeviceIdentityPeripheralInfo[];
  kitName?: string;
}

/** Region, language codes map for specific coutnry */
export interface Country {
  /**
   * Region code (kr / us / ca / cn, hk / europe / cis / mea / swa / au, id, my, ph, sg / global)
   * @example "mea"
   */
  region: string;
  /**
   * Supported languaged code list, ordered by priority
   * @example ["en","ar"]
   */
  langs: {
    '{languageCode}'?: string;
  }[];
}

/** Plugin information */
export interface Plugin {
  /**
   * Plugin identifier
   * @example "sec_da"
   */
  name: string;
  /**
   * Supported package list
   * @example ["com.samsung.android.plugin.airconditioner","com.samsung.ios.plugin.airconditioner"]
   */
  plugins: {
    packageName?: string;
  }[];
}

/** Version information for specfic service */
export interface ServiceVersion {
  /**
   * Service name (main / sec_da / sec_tv / sec_pet)
   * @example "main"
   */
  name: string;
  /** @example "1.0.2" */
  version: string;
}

/** PP list for specfic device type. */
export interface DevicePP {
  /**
   * Agreement type (Optional or Mandatory)
   * @example false
   */
  isOptional: boolean;
  /**
   * Whether agreement is always required
   * @example false
   */
  needCheckAlways: boolean;
  /**
   * PP identifier
   * @example "ppa_sec_air_conditioner"
   */
  ppId: string;
  /**
   * PP version
   * @example "1.0.2"
   */
  ppVersion: string;
}

/** Onboarding get response */
export interface OnBoardingGetResponse {
  /** false */
  isCancel: string;
  /** [{"ppId":"ppa_sec_refrigerator","ppVersion":"0.0.0","isAgree":true}] */
  ppList: string;
}

export interface EasySetupBlobRes {
  blob?: string;
  cloudPubKey?: string;
  meta?: EasySetupBlobMetadata;
  sn?: string;
  type?: string;
}

export interface EasySetupBlobMetadata {
  mfgr?: string;
  mnId?: string;
  modelName?: string;
  onboardingId?: string;
  partner?: string;
  sku?: string[];
}

export interface RestResponseListEasySetupBlobRes {
  /** @format int32 */
  code?: number;
  data?: EasySetupBlobRes[];
  message?: string;
}

export interface EasySetupProvBlobReq {
  keyid: EasySetupBlobKeyId;
  rand: string;
  modelName?: string;
  mnId: string;
  productId?: string;
  setupId: string;
}

export interface EasySetupBlobKeyId {
  type: 'sn' | 'hashed_sn' | 'hybrid_sn';
  value: string;
}

/** howtouselist response body */
export type ListHowToUseResponse = HowToUse[];

/**
 * HowToUse object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"howtouse example","title":"HowToUse Example","description":"HowToUse description.","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","countryCodeId":"US","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/article/ffffd976ffb727001abc7eed?t=1582196980463","serveIfReqLngNotFound":false,"serviceProviderId":"none","updatedAt":1582196980463,"deepLink":"none","weight":9,"author":"","location":"","howToUseLink":"","howToUseLinkType":""}
 */
export interface HowToUse {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  image: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /**
   * `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc).
   */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  deepLink: 'none' | 'automation' | 'scene' | 'invitation' | 'video' | 'fme' | 'galaxyx';
  /**
   * @min 0
   * @max 100
   */
  weight: number;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  author?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  howToUseLink?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  howToUseLinkType?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  location?: string;
}

/** notificationslist response body */
export type ListNotificationResponse = Notification[];

/**
 * Notification object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"notification example","title":"Notification Example","description":"Notification description.","countryCodeId":"US","date":"2019-07-22","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/notification/ffffd976ffb727001abc7eed?t=1564378172835","serveIfReqLngNotFound":true,"serviceProviderId":"none","updatedAt":1564378172835,"weight":39}
 */
export interface Notification {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  date: string;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  /**
   * @min 0
   * @max 100
   */
  weight: number;
}

/** herobannerlist response body */
export type ListHeroBannerResponse = HeroBanner[];

/**
 * HeroBanner object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"herobanner example","title":"HeroBanner Example","titleColor":"#FFFFFF","subTitle":"HeroBanner Subtitle","subTitleColor":"#FFFFFF","description":"HeroBanner description.","descriptionColor":"#FFFFFF","countryCodeId":"US","languageCodeId":"en","serveIfReqLngNotFound":true,"serviceProviderId":"none","periodToDisplayStartDate":"2018-06-11","periodToDisplayEndDate":"2023-06-11","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","tabletImage":"https://samsung-connect.samsungiotcloud.com/bucket/example/tabletImage.png","weight":10,"updatedAt":1529010550549,"link":"https://librarian-regionals.smartthingsgdev.com/api","linkType":"web"}
 */
export interface HeroBanner {
  document_id: string;
  adminTitle: string;
  title: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  titleColor?: string;
  subTitle?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  subTitleColor?: string;
  description?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  descriptionColor?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayStartDate: string;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayEndDate: string;
  image: string;
  tabletImage?: string;
  /**
   * @min 1
   * @max 100
   */
  weight: number;
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  link: string;
  linkType: 'web' | 'app' | 'deepLink' | 'appIntent' | 'uimeta' | 'email';
}

/**
 * HeroBannerUIMeta object structure
 * @example {"document_id":"5f573c6e43497e6714921116","adminTitle":"herobanner uimeta example","title":"HeroBanner UIMETA Example","titleColor":"#FFFFFF","subTitle":"HeroBanner Subtitle","subTitleColor":"#FFFFFF","description":"HeroBanner description.","descriptionColor":"#FFFFFF","countryCodeId":"US","languageCodeId":"en","serveIfReqLngNotFound":false,"periodToDisplayStartDate":"2018-06-11","periodToDisplayEndDate":"2023-06-11","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","tabletImage":"https://samsung-connect.samsungiotcloud.com/bucket/example/tabletImage.png","updatedAt":1529010550549,"subsections":[{"title":"subsection 1 title","description":"subsection 1 description","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","deepLinks":[{"description":"Update Now","link":"https://www.samsung.com"}]},{"title":"subsection 2 title","description":"subsection 2 description","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","deepLinks":[]},{"title":"","description":"","image":"","deepLinks":[{"description":"Here","link":"https://www.samsung.com"}]}]}
 */
export interface HeroBannerUIMeta {
  document_id: string;
  adminTitle: string;
  title: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  titleColor?: string;
  subTitle?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  subTitleColor?: string;
  description?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  descriptionColor?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  serveIfReqLngNotFound: boolean;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayStartDate: string;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayEndDate: string;
  image: string;
  tabletImage?: string;
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  subsections: ListSubsection[];
}

/**
 * List of Subsection objects
 * @maxItems 10
 * @minItems 0
 */
export type ListSubsection = Subsection[];

/** Subsection object structure */
export interface Subsection {
  title: string;
  description: string;
  image?: string;
  deepLinks: ListDeepLink[];
}

/**
 * List of DeepLink objects
 * @maxItems 3
 * @minItems 0
 */
export type ListDeepLink = DeepLink[];

/** Subsection deepLink */
export interface DeepLink {
  description: string;
  link: string;
}

export interface SetShpDevicesTokenRequest {
  /** SHP device token */
  token?: string;
  /** The setup state of SHP devices */
  setup?: boolean;
}

export interface GetShpDevicesTokenResponse {
  /** SHP device token */
  token?: string;
  /** The setup state of SHP devices */
  setup?: boolean;
}

export interface GetShpDevicesExistenceResponse {
  /** True if the SHP device is owned by the current user, false otherwise */
  owned: boolean;
}

export interface OnboardingInfoRequest {
  /** One-Time password */
  otp: string;
  /** Room ID */
  roomId?: string;
  /** Location ID */
  locationId: string;
  /** Device default name */
  nickname: string;
  /** Indicates user ID corresponding to user account */
  'x.com.samsung.uid': string;
  /** Indicates client id for authenticating from Samsung CI server */
  'x.com.samsung.clientid'?: string;
  /** Indicates authenticate provider’s name issuing an auth code */
  apn: string;
  /** Indicates URL for OCF cloud interface server */
  cis: string;
  /** Indicates access token type for IoT cloud */
  'x.com.samsung.iatt'?: number;
  /** Indicates current deployment environment which IoT Server is operating such as "PRD", "STG" and etc. */
  'x.com.samsung.deployenv'?: string;
  /** Indicates additional authCode provided by Samsung Account Server */
  'x.com.samsung.aac'?: string;
  /** Indicates authentication provider of Samsung Account */
  'x.com.samsung.saauthserver'?: string;
  /** Indicates API verifier server of Samsung Account */
  'x.com.samsung.saapiserver'?: string;
  /** Indicates random code for verifying auth code for Samsung Account */
  'x.com.samsung.sadsc'?: string;
  /** Samsung Account ID information */
  'x.com.samsung.account'?: string;
}

export interface ContinyStatus {
  device?: Device;
  user?: User;
  isPlaying?: boolean;
  playedAt?: string;
}

export interface RestResponseJsonNode {
  /** @format int32 */
  code?: number;
  data?: JsonNode;
  message?: string;
}

export interface RestResponseListJsonNode {
  /** @format int32 */
  code?: number;
  data?: JsonNode[];
  message?: string;
}

export interface RestResponseListString {
  /** @format int32 */
  code?: number;
  data?: string[];
  message?: string;
}

export interface JsonNode {
  array?: boolean;
  bigDecimal?: boolean;
  bigInteger?: boolean;
  binary?: boolean;
  boolean?: boolean;
  containerNode?: boolean;
  double?: boolean;
  float?: boolean;
  floatingPointNumber?: boolean;
  int?: boolean;
  integralNumber?: boolean;
  long?: boolean;
  missingNode?: boolean;
  nodeType?: 'ARRAY' | 'BINARY' | 'BOOLEAN' | 'MISSING' | 'NULL' | 'NUMBER' | 'OBJECT' | 'POJO' | 'STRING';
  null?: boolean;
  number?: boolean;
  object?: boolean;
  pojo?: boolean;
  short?: boolean;
  textual?: boolean;
  valueNode?: boolean;
}

/** tipslist response body */
export type ListTipsResponse = Tips[];

/**
 * PluginTip object structure
 * @example {"id":"62de332c9943e0adc2df8a36","internalName":"pluginTip example troubleshoot","style":"troubleshoot","priority":0,"deviceIntegrationType":"MATTER","deviceManufacturerCode":"0AJK","deviceModel":["001","002"],"isForAllCountries":true,"countries":[],"conditions":{"type":"capability","capability":[{"capabilityId":"alarm","component":"main","value":"alarm.value","operator":"EQUALS","operand":"siren"}]},"title":"Tips title","description":"Tips description","icon":"https://samsung-connect.samsungiotcloud.com/bucket/example/icon.png","action":{"button":{"label":"Button","deeplink":{"android":"samsungconnect://launch?action=example_plugin_tip_android","ios":"samsungconnect://launch?action=example_plugin_tip_ios"}}}}
 */
export interface PluginTip {
  /** ID for tips in database. */
  id: string;
  /** Internal name of the tips. */
  internalName: string;
  /** Type of a tips that affects how it is consist of components. */
  style: 'RECOMMENDATION_WITH_ICON' | 'RECOMMENDATION_WITHOUT_ICON' | 'TROUBLE_SHOOTING_GUIDE';
  /** Indicates how important the content. Used to sort the content (high to low). Default value `3` */
  priority: number;
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Identifier for vendor/manufacturer */
  deviceManufacturerCode: string;
  deviceModel?: DeviceModel[];
  /** Determine whether the tips is registered for all countries. Default value `false` */
  isForAllCountries?: boolean;
  countries?: Countries[];
  excludeCountries?: ExcludeCountries[];
  conditions?: Conditions;
  /** Brand Name of the tips. Default value `""` */
  brandName?: string;
  /** Title of the tips. Default value `""` */
  title?: string;
  /** Description of the Tips. Default value `""` */
  description?: string;
  /** URL of the tips icon. Default value `""` */
  icon?: string;
  action?: Action;
}

/**
 * Tips object structure
 * @example {"id":"62de332c9943e0adc2df8a36","internalName":"tips example troubleshoot","style":"troubleshoot","priority":0,"deviceIntegrationType":"MATTER","deviceManufacturerCode":"0AJK","deviceModel":["001","002"],"isForAllCountries":true,"countries":[],"conditions":{"type":"capability","capability":[{"capabilityId":"alarm","component":"main","value":"alarm.value","operator":"EQUALS","operand":"siren"}]},"title":"Tips title","description":"Tips description","icon":"https://samsung-connect.samsungiotcloud.com/bucket/example/icon.png","action":{"button":{"label":"Button","deeplink":{"android":"samsungconnect://launch?action=example_plugin_tip_android","ios":"samsungconnect://launch?action=example_plugin_tip_ios"}}},"language":[{"locale":"en-US","poCodes":[{"label":"View details","po":"DREAM_SAC_BUTTON_VIEW_DETAILS_20"},{"label":"You can add or edit conditions and actions.","po":"DREAM_SAC_BODY_YOU_CAN_ADD_OR_EDIT_CONDITIONS_AND_ACTIONS"},{"label":"Create automations","po":"DREAM_SAC_TMBODY_CREATE_AUTOMATIONS"}]},{"locale":"ko","poCodes":[{"label":"자세히 보기","po":"DREAM_SAC_BUTTON_VIEW_DETAILS_20"},{"label":"조건과 동작을 추가하거나 편집할 수 있습니다.","po":"DREAM_SAC_BODY_YOU_CAN_ADD_OR_EDIT_CONDITIONS_AND_ACTIONS"},{"label":"자동화 만들기","po":"DREAM_SAC_TMBODY_CREATE_AUTOMATIONS"}]},{"locale":"ja","poCodes":[{"label":"詳細を表示","po":"DREAM_SAC_BUTTON_VIEW_DETAILS_20"},{"label":"条件および実行内容を追加または編集できます。","po":"DREAM_SAC_BODY_YOU_CAN_ADD_OR_EDIT_CONDITIONS_AND_ACTIONS"},{"label":"オートメーションを作成","po":"DREAM_SAC_TMBODY_CREATE_AUTOMATIONS"}]},{"locale":"ms-MY","poCodes":[{"label":"Lihat butiran","po":"DREAM_SAC_BUTTON_VIEW_DETAILS_20"},{"label":"Anda boleh menambahkan atau menyunting syarat dan tindakan.","po":"DREAM_SAC_BODY_YOU_CAN_ADD_OR_EDIT_CONDITIONS_AND_ACTIONS"},{"label":"Cipta automasi","po":"DREAM_SAC_TMBODY_CREATE_AUTOMATIONS"}]}]}
 */
export interface Tips {
  /** ID for tips in database. */
  id: string;
  /** Internal name of the tips. */
  internalName: string;
  /** Type of a tips that affects how it is consist of components. */
  style: 'RECOMMENDATION_WITH_ICON' | 'RECOMMENDATION_WITHOUT_ICON' | 'TROUBLE_SHOOTING_GUIDE';
  /** Indicates how important the content. Used to sort the content (high to low). Default value `3` */
  priority: number;
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Identifier for vendor/manufacturer */
  deviceManufacturerCode: string;
  deviceModel?: DeviceModel[];
  /** Determine whether the tips is registered for all countries. Default value `false` */
  isForAllCountries?: boolean;
  countries?: Countries[];
  excludeCountries?: ExcludeCountries[];
  conditions?: Conditions;
  /** Brand Name of the tips. Default value `""` */
  brandName?: string;
  /** Title of the tips. Default value `""` */
  title?: string;
  /** Description of the Tips. Default value `""` */
  description?: string;
  /** URL of the tips icon. Default value `""` */
  icon?: string;
  action?: Action;
  language?: Language[];
}

/** Identifier for product/device. Default value `[]` */
export type DeviceModel = string[];

/** Registered countries for tips. Array of `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
export type Countries = string[];

/** Excluded countries for tips when isForAllCountries `true`. Array of `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
export type ExcludeCountries = string[];

export interface Conditions {
  type: 'basic' | 'capability' | 'matterMultiFabric';
  capability?: Capability[];
}

/** Capability of the device */
export type Capability = Model1[];

export interface Action {
  button?: ButtonConnect;
  dismissButton?: DismissButton;
}

export interface ButtonConnect {
  /** Label of the Action Button of the tips. */
  label: string;
  /** Default value `false` */
  once?: boolean;
  /** Subsection deepLink */
  deeplink?: DeepLink;
}

export interface DismissButton {
  /** Label of the Dismiss Button of the tips. */
  label: string;
  /** Default value `false` */
  once?: boolean;
}

/** List of po_codes and its translation used in the tips. */
// removed as dup and not used
// export type Language = Model3[];

export type PoCodeList = Model2[];

/** pluginTiplist response body */
export type ListPluginTipResponse = PluginTip[];

/**
 * PluginSupport object structure
 * @example {"id":"62de332c9943e0adc2df8a36","internalName":"pluginSupport","brandName":"Philips Hue","brandImage":"https://iot-gse-preprod-useast1-gse.s3.amazonaws.com/images/pluginSupport/629b4cf2-fa94-4172-af49-319262831a18/philips.png","deviceManufacturerCode":"OAJK","deviceModel":["001"],"deviceIntegrationType":"APP","isForAllCountries":true,"countries":[],"excludeCountries":[],"websiteUrl":"https://www.philips-hue.com","supportWebPage":"https://www.philips-hue.com/en-us/support/faq","email":"contactus@philips-hue.com","androidUrl":"phe://launch?action=faq","iosUrl":"phe://"}
 */
export interface PluginSupport {
  /** ID for tips in database. */
  id: string;
  /** Internal name of the tips. */
  internalName: string;
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Brand Name of the tips */
  brandName: string;
  /** URL of the tips brand image */
  brandImage: string;
  /** Deeplink for android */
  androidUrl?: string;
  /** Deeplink for android */
  iosUrl?: string;
  /** Identifier for vendor/manufacturer */
  deviceManufacturerCode: string;
  deviceModel?: DeviceModel[];
  websiteUrl?: string;
  email?: string;
  supportWebPage?: string;
  androidMinAppVersion?: string;
  androidMaxAppVersion?: string;
  iosMinAppVersion?: string;
  iosMaxAppVersion?: string;
  /** Determine whether the tips is registered for all countries. Default value `false` */
  isForAllCountries?: boolean;
  countries?: Countries[];
  excludeCountries?: ExcludeCountries[];
}

/** pluginSupportlist response body */
export type ListPluginSupportResponse = PluginSupport[];

/** devices response */
export type HintsForDevicesResponse = ApiSuccessResponse & {
  /** response data */
  data?: {
    targets?: HintsForDevices;
  };
};

/** device response */
export type HintsForDeviceResponse = ApiSuccessResponse & {
  data?: HintsForDevice;
};

/** capabilities response */
export type HintsForcapabilitiesResponse = ApiSuccessResponse & {
  /** SmartThings capabilities */
  data?: HintsForCapabilities;
};

/** capabilities include voice intent list response */
export type HintsForcapabilitiesIncludevoiceintentResponse = ApiSuccessResponse & {
  /** SmartThings capabilities with voice intents */
  data?: HintsForCapabilitiesIncludevoiceintent;
};

/** capabilities include voice intent list with hints response */
export type HintsForcapabilitiesIncludehintResponse = ApiSuccessResponse & {
  /** SmartThings capabilities with component */
  data?: HintsForCapabilitiesIncludehint;
};

/** capability response */
export type HintsForCapabilityResponse = ApiSuccessResponse & {
  /** SmartThings capabilities with component */
  data?: HintsForCapability;
};

/** voice intents response */
export type HintsForVoiceIntentsResponse = ApiSuccessResponse & {
  data?: HintsForVoiceIntents;
  _links?: {
    next?: {
      /** @example "https://{url}/hints/voiceintents?page=3" */
      href?: string;
    };
    previous?: {
      /** @example "https://{url}/hints/voiceintents?page=1" */
      href?: string;
    };
  };
};

/** voice intent response */
export type HintsForVoiceIntentResponse = ApiSuccessResponse & {
  data?: HintsForVoiceIntent;
};

/** automation creation response */
export type HintsForAutomationCreationResponse = ApiSuccessResponse & {
  /** automation hints for all target devices */
  data?: HintsForAutomationCreation;
};

/** automation hints for all target devices */
export interface HintsForAutomationCreation {
  targets?: HintsForAutomationCreationTarget[];
}

/** Array of the hints to create automation for each device */
export interface HintsForAutomationCreationTarget {
  /**
   * The Device ID
   * @example "376fe8cb-4556-432e-9187-ac5d35e150f0"
   */
  id: string;
  /**
   * The Device name
   * @example "Ceiling Light"
   */
  name: string;
  /**
   * Recommended name for calling this device
   * @example "Living room light"
   */
  alias?: string;
  /**
   * OCF device type
   * @example "oic.d.light"
   */
  type?: string;
  /**
   * Device type in natural language. It is translated to the selected language
   * @example "light"
   */
  typeName?: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /**
   * The location ID
   * @example "a7973ba6-0743-45ba-b777-aca216cbd780"
   */
  locationId: string;
  /**
   * The room name
   * @example "Living room"
   */
  roomName?: string;
  /**
   * The room Id
   * @example "ac5d35e150f0-4556-432e-9187-376fe8cb"
   */
  roomId?: string;
  /** The duration after device is created */
  deviceDuration?: number;
  /** the automation hints */
  voiceIntents?: HintsForAutomationCreationVoiceIntents[];
}

/** hints for each capability action */
export type HintsForAutomationCreationVoiceIntents = AutomationCreationVoiceIntent & {
  /** Hint array */
  hints?: string[];
};

/** capability action details */
export interface AutomationCreationVoiceIntent {
  /**
   * voice intent id suppoting automation
   * @example "device-turnOn"
   */
  id: string;
  /** Voice capability method type */
  method: 'POST' | 'GET';
  /** voice intent description */
  description: string;
  /** Voice capability type */
  capabilityType: 'VOICE_INTENT' | 'HIDDEN_CAPABILITY';
  /**
   * access level
   * @example "PUBLIC"
   */
  accessLevel: string;
  /**
   * Voice capability parameter information
   * @example null
   */
  parameters: Parameter[];
  /** Voice capability description */
  automationType: 'condition-scheduleAfter' | 'condition-presenceIn' | 'condition-scheduleRepeat';
}

/** locations response */
export type HintsForLocationsResponse = ApiSuccessResponse & {
  /** Locations resonse data */
  data?: HintsForLocations;
};

/** Locations resonse data */
export interface HintsForLocations {
  locations?: HintsForLocation[];
}

/** locations response */
export type HintsForLocationResponse = ApiSuccessResponse & {
  /** app and grouupintents for all locations */
  data?: HintsForLocation;
};

/** app and grouupintents for all locations */
export interface HintsForLocation {
  /**
   * The Location ID
   * @example "b11688ef-54f4-49da-8854-13dd27140b43"
   */
  locationId: string;
  /**
   * The Location name
   * @example "My home"
   */
  locationName: string;
  /** Array of the hints for the ST app related commands */
  apps: HintsForLocationApp[];
  /** Array of the hints for the location or room related commands */
  groupIntents?: HintsForLocationGroupIntent[];
}

/** Array of the hints for the location or room related commands */
export interface HintsForLocationGroupIntent {
  /**
   * The room ID. If these roomID and roomName are null, the hints in this object are for the location
   * @example "2adff38d-d457-433e-ada9-1a0fd49cbc36"
   */
  roomId?: string;
  /**
   * The room name
   * @example "Hall"
   */
  roomName?: string;
  voiceIntents?: HintsForLocationIntent[];
}

/** Array of the hints for the ST app related commands */
export interface HintsForLocationApp {
  /** Goal names for hint */
  id?: 'device-connect' | 'scene-show' | 'device-getList' | 'automation-show';
  /**
   * Voice capability parameter information
   * @example null
   */
  parameters?: Parameter[];
  /** Voice capability description */
  description?: string;
  /** Voice capability type */
  capabilityType: 'DEEP_LINK';
  /** Hint array */
  hints?: string[];
}

/** scenes response */
export type HintsForScenesResponse = ApiSuccessResponse & {
  /** Hints for all scenes */
  data?: HintsForScenes;
};

/** Hints for all scenes */
export interface HintsForScenes {
  targets?: HintsForScenesTarget[];
}

/** scene response */
export type HintsForSceneResponse = ApiSuccessResponse & {
  /** hints for each scene */
  data?: HintsForScenesTarget;
};

/** hints for each scene */
export interface HintsForScenesTarget {
  /**
   * The scene ID
   * @example "22fd3dea-3724-4915-b9ab-d6c3fe275245"
   */
  id: string;
  /**
   * The scene name
   * @example "Good morning"
   */
  name: string;
  /**
   * The location ID
   * @example "3872090a-bf3c-4fad-896a-8b8090f15a7c"
   */
  locationId: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /** Hint array */
  hints?: string[];
}

export type HintsForDevices = HintsForDevice[];

export interface HintsForDevice {
  /**
   * The device ID
   * @example "376fe8cb-4556-432e-9187-ac5d35e150f0"
   */
  id: string;
  /**
   * The device name
   * @example "Ceiling Light"
   */
  name: string;
  /**
   * The device alias name
   * @example "Living room light"
   */
  alias?: string;
  /**
   * The device type
   * @example "oic.d.light"
   */
  type: string;
  /**
   * The device type's representative name
   * @example "light"
   */
  typeName: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /**
   * The location Id
   * @example "aewfe43j-4556-432e-9187-ac5d35e150f0"
   */
  locationId: string;
  /**
   * The room name
   * @example "Living room"
   */
  roomName?: string;
  /**
   * The room Id
   * @example "ac5d35e150f0-4556-432e-9187-376fe8cb"
   */
  roomId?: string;
  /** The duration after device is created */
  deviceDuration: number;
  voiceIntents?: HintsForDeviceVoiceIntent[];
}

/** SmartThings capabilities */
export interface HintsForCapabilities {
  /** all capabilities */
  capabilities: HintsForOnlyCapability[];
}

/** SmartThings capabilities with voice intents */
export interface HintsForCapabilitiesIncludevoiceintent {
  capabilities: HintsForCapabilityIncludevoiceintent[];
}

/** SmartThings capabilities with component */
export interface HintsForCapabilitiesIncludehint {
  capabilities?: HintsForCapabilityIncludehint[];
}

/** SmartThings capabilities with component */
export interface HintsForOnlyCapability {
  /**
   * SmartThings capability
   * @example "colorcontrol"
   */
  capability: string;
  /**
   * Component of the device
   * @example "main"
   */
  component?: string;
}

/** SmartThings capabilities with voice intents */
export interface HintsForCapabilityIncludevoiceintent {
  /**
   * SmartThings capability
   * @example "colorcontrol"
   */
  capability: string;
  /**
   * Component of the device
   * @example "main"
   */
  component?: string;
  voiceIntents: HintsForVoiceIntentWithoutHint[];
}

/** SmartThings capabilities with component */
export interface HintsForCapabilityIncludehint {
  /**
   * SmartThings capability
   * @example "colorcontrol"
   */
  capability: string;
  /**
   * Component of the device
   * @example "main"
   */
  component?: string;
  voiceIntents: HintsForVoiceIntent[];
}

/** SmartThings capabilities with component */
export interface HintsForCapability {
  /**
   * SmartThings capability
   * @example "colorcontrol"
   */
  capability: string;
  /**
   * Component of the device
   * @example "main"
   */
  component?: string;
  voiceIntents: HintsForVoiceIntent[];
}

export interface HintsForVoiceIntents {
  voiceIntents?: HintsForVoiceIntent[];
  /** @example 3 */
  pageIdNext?: number;
  /** @example 2 */
  pageIdCurr?: number;
  /** @example 1 */
  pageIdPrev?: number;
  /** @example 5 */
  totalPages?: number;
}

export type HintsForDeviceVoiceIntent = DeviceVoiceIntentInfo & {
  /** Hint array */
  hints?: string[];
};

export type HintsForVoiceIntentWithoutHint = VoiceIntentInfo;

export type HintsForVoiceIntent = LegacyVoiceIntentInfo & {
  /** Hint array */
  hints?: string[];
};

export type HintsForLocationIntent = VoiceIntentInfo & {
  /** Hint array */
  hints?: string[];
};

/** voice intents and hints for them */
export interface DeviceVoiceIntentInfo {
  /**
   * voice intent id
   * @example "colorControl-setValue"
   */
  id: string;
  /** Voice capability method type */
  method: 'POST' | 'GET';
  /** Voice capability parameter information */
  parameters: Parameter[];
  /** Voice capability description */
  description: string;
  /** Voice capability type */
  capabilityType: 'VOICE_INTENT' | 'HIDDEN_CAPABILITY';
  /**
   * access level
   * @example "PUBLIC"
   */
  accessLevel: string;
  /**
   * The hint weight value
   * @format float
   * @min 0
   * @max 1
   * @example 0.5
   */
  score: number;
}

/** voice intents and hints for them */
export interface LegacyVoiceIntentInfo {
  /**
   * voice capability
   * @example "color control"
   */
  capability: string;
  /**
   * voice action
   * @example "set"
   */
  action: string;
  /**
   * voice enumeration
   * @example null
   */
  enumeration?: string;
  /** Voice capability method type */
  method: 'POST' | 'GET';
  /** Voice capability parameter information */
  parameters: Parameter[];
  /** Voice capability description */
  description: string;
  /** Voice capability type */
  capabilityType: 'VOICE_INTENT' | 'HIDDEN_CAPABILITY';
  /**
   * access level
   * @example "PUBLIC"
   */
  accessLevel?: string;
}

/** voice intents and hints for them */
export interface VoiceIntentInfo {
  /**
   * voice intent ID
   * @example "currentTemperature-getValue"
   */
  id: string;
  /** Voice capability method type */
  method: 'GET' | 'POST';
  /**
   * Voice capability parameter information
   * @example null
   */
  parameters: Parameter[];
  /** Voice capability description */
  description: string;
  /** Voice capability type */
  capabilityType: 'VOICE_INTENT' | 'HIDDEN_CAPABILITY';
  /**
   * access level
   * @example "PUBLIC"
   */
  accessLevel?: string;
}

/** voice capabilitie parameter */
export interface Parameter {
  /**
   * parameter key name
   * @example "predefinedColorName"
   */
  name: string;
  /** parameter value type */
  type: 'string' | 'number' | 'integer';
  /**
   * whether the value is optional or not
   * @example false
   */
  optional: boolean;
  /** @example ["blue","red","yellow"] */
  enumeration?: string[];
}

/** vocab response */
export type VocabsDataResponse = ApiSuccessResponse & {
  /** Bixby vocabulary concepts */
  data?: VocabsTypesResponse;
};

/** Bixby vocabulary concepts */
export interface VocabsTypesResponse {
  /** List of Bixby vocabulary concepts */
  types?: VocabsResponse;
}

/** List of Bixby vocabulary concepts */
export type VocabsResponse = Concept[];

export interface Concept {
  /**
   * Name of Bixby vocabulary concept
   * @example "CapabilityName"
   */
  type: string;
  /** List of Bixby vocabulary symbol */
  vocabs?: {
    /**
     * Name of Bixby vocabulary symbol
     * @example "CP_COLOR"
     */
    value?: string;
    /**
     * Vocabulary
     * @example "color"
     */
    vocab?: string;
  }[];
}

/** @example {"dialogues":{"handsFree":[{"dialogueId":"Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes","origin":"system","mnmn":"Samsung Electronics","mode":"handsFree","goalId":"SamsungIoT_SPK_13","description":null,"voiceintents":null,"templates":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"templatesByLocale":null,"defaultDialogueId":null,"defaultDialogue":null,"parameters":{"Capability":{"type":"any","description":null,"vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}},"Keyword":{"type":"system","description":null,"vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Value":{"type":"any","description":null,"vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}}}}],"handsOn":[{"dialogueId":"Rev_SamsungIoT_13_5_SetValue_GoalSuccessful_YesOrNo_Yes","origin":"system","mnmn":"Samsung Electronics","mode":"handsOn","goalId":"SamsungIoT_13","voiceintents":null,"description":null,"templates":["Okay"],"templatesByLocale":null,"defaultDialogueId":null,"defaultDialogue":null,"parameters":{}}]}} */
export type DialoguesForVoiceIntent = VoiceIntentInfo & {
  /** dialogues for the voice intent */
  dialogues: {
    handsFree: Dialogue[];
    handsOn: Dialogue[];
  };
};

/** dialogue response for voice intent */
export type DialoguesForVoiceIntentResponse = ApiSuccessResponse & {
  data?: DialoguesForVoiceIntent;
};

/**
 * dialogue item
 * @example {"origin":"custom","mnmn":"Samsung Electronics","mode":null,"goalId":null,"voiceintents":["color control-setColor-blue"],"description":"custom dialogue for color control","templates":null,"templatesByLocale":{"en":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"ko-KR":["#{Keyword} #{Capability}(을)를 #{Value}(으)로 설정할게요."]},"defaultDialogueId":"Rev_SamsungIoT_SPK_0_125_CommonCheck_TargetAction_Match_DeviceControl","defaultDialogue":{"de-DE":["Ok, gut."],"en":["Okay."],"es-ES":["¡Hecho!"],"fr-FR":["D’accord, c’est noté."],"it-IT":["Ok, capito."],"ko-KR":["네, 알겠어요."],"pt-BR":["Ok!"],"zh-CN\"":["没问题。"]},"parameters":{"Keyword":{"type":"system","description":"device parameter","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Capability":{"type":"vocab","description":"capability parameter","vocabData":{"supportedTypes":["CapabilityName"]},"systemData":null,"numberData":null,"anyData":null},"Value":{"type":"number","description":"result value parameter","vocabData":null,"systemData":null,"numberData":{"unitType":"UNIT_TEMP_DEGREES"},"anyData":null}}}
 */
export interface DialogueRequest {
  /**
   * origin for dialogue template
   * @example "custom"
   */
  origin: string;
  /**
   * manufacturer name
   * @example "Samsung Electonics"
   */
  mnmn: string;
  /**
   * bixby invoke mode
   * @example "handsFree"
   */
  mode?: 'handsOn' | 'handsFree';
  /**
   * dialogue MWUC goal ID. defined only in system dialogues
   * @example "SamsungIoT_0"
   */
  goalId?: string;
  /** description */
  description?: string;
  /**
   * Voice Intent :(voice capability)-(voice action)-(voice enumeration)
   * @example ["color control-setColor-blue"]
   */
  voiceintents?: string[];
  /** Dialogue for requested language (filled when Accept-Langauge is not null) */
  templates?: string[];
  /** Dialogues for all supported languages (filled when Accept-Language is * or null) */
  templatesByLocale?: {
    /** Dialogue (NLG) defined for used in smartThingsApp capsule by locale */
    '<locale>'?: string[];
  };
  /** Default dialogue ID. Used when language is not supported in the current dialogue ID (filled when Accept-Language is * or null) */
  defaultDialogueId?: string;
  /** Default dialogues for all supported languages (filled when Accept-Language is * or null) */
  defaultDialogue?: {
    /** default dialogue (NLG) defined for used in smartThingsApp capsule by locale */
    '<locale>'?: string[];
  };
  /** The information of parameters used in template string */
  parameters: DialogueParameter;
}

/** The information of parameters used in template string */
export interface DialogueParameter {
  '<paramKey>'?: ParameterObject;
}

export interface ParameterObject {
  /** parameter type */
  type: string;
  /** description */
  description?: string;
  /** additional data for vocab type */
  vocabData?: {
    /** candidated vocabulary types for vocab type */
    supportedTypes?: string[];
    /** specific vocabulary type */
    type?: string;
    /** Name of Bixby symbol */
    value?: string;
    /** vocabulary text */
    vocab?: string;
  };
  /** additional data for system type */
  systemData?: {
    /** specific system vocabulary type */
    type?: string;
  };
  /** additional data for number type */
  numberData?: {
    /** specific number unit vocabulary type */
    unitType?: string;
  };
  /** additional data for any type */
  anyData?: {
    /** candidated vocabulary types for vocab type */
    supportedTypes?: string[];
    /** specific number unit vocabulary type */
    unitType?: string;
  };
}

/** dialogue item */
export type Dialogue = DialogueRequest & {
  /** Dialogue (NLG) ID used for smartThingsApp capsule */
  dialogueId: string;
};

/** dialogue item */
export interface DialogueWithParameterList {
  /** Dialogue (NLG) ID used for smartThingsApp capsule */
  dialogueId: string;
  /** The information of parameters used in template string */
  parameters: {
    '<paramKey>'?: ParameterObject[];
  };
}

/**
 * dialogue list
 * @example {"code":"2000000,","message":"SUCCESS","data":{"dialogueId":"custom_Samsung_Electronics_abcd","origin":"custom","mnmn":"Samsung Electronics","mode":null,"goalId":null,"voiceintents":["color control-setColor-blue"],"description":"custom dialogue for color control","templates":null,"templatesByLocale":{"en":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"ko-KR":["#{Keyword} #{Capability}(을)를 #{Value}(으)로 설정할게요."]},"defaultDialogueId":"Rev_SamsungIoT_SPK_0_125_CommonCheck_TargetAction_Match_DeviceControl","defaultDialogue":{"de-DE":["Ok, gut."],"en":["Okay."],"es-ES":["¡Hecho!"],"fr-FR":["D’accord, c’est noté."],"it-IT":["Ok, capito."],"ko-KR":["네, 알겠어요."],"pt-BR":["Ok!"],"zh-CN\"":["没问题。"]},"parameters":{"Keyword":{"type":"system","description":"device parameter","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Capability":{"type":"any","description":"capability parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}},"Value":{"type":"any","description":"result value parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}}}}}
 */
export type DialogueResponse = ApiSuccessResponse & {
  /** dialogue item */
  data?: Dialogue;
};

/** dialogue list */
export type DialogueListResponse = ApiSuccessResponse & {
  data?: {
    /**
     * response data
     * @example [{"dialogueId":"custom_Samsung_Electronics_abcd","origin":"custom","mnmn":"Samsung Electronics","mode":null,"goalId":null,"voiceintents":["color control-setColor-blue"],"description":"custom dialogue for color control","templates":null,"templatesByLocale":{"en":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"ko-KR":["#{Keyword} #{Capability}(을)를 #{Value}(으)로 설정할게요."]},"defaultDialogueId":"Rev_SamsungIoT_SPK_0_125_CommonCheck_TargetAction_Match_DeviceControl","defaultDialogue":{"de-DE":["Ok, gut."],"en":["Okay."],"es-ES":["¡Hecho!"],"fr-FR":["D’accord, c’est noté."],"it-IT":["Ok, capito."],"ko-KR":["네, 알겠어요."],"pt-BR":["Ok!"],"zh-CN\"":["没问题。"]},"parameters":{"Capability":{"type":"any","description":"capability parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}},"Keyword":{"type":"system","description":"device parameter","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Value":{"type":"any","description":"result value parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}}}}]
     */
    dialogues?: Dialogue[];
  };
};

/**
 * request body to generate NLG
 * @example {"handsFree":[{"dialogueId":"Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes","parameters":{"Keyword":[{"type":"system","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null}],"Capability":[{"type":"vocab","vocabData":{"type":"CapabilityName","value":"CP_TEMPERATURE"},"systemData":null,"numberData":null,"anyData":null}],"Value":[{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"24","unitType":"UNIT_TEMP_DEGREES"},"anyData":null},{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"30","unitType":"UNIT_TEMP_DEGREES"},"anyData":null}]}}],"handsOn":[{"dialogueId":"Rev_SamsungIoT_13_5_SetValue_GoalSuccessful_YesOrNo_Yes","parameters":{}}]}
 */
export interface DialogueNLGRequest {
  handsFree: DialogueWithParameterList[];
  handsOn: DialogueWithParameterList[];
}

/**
 * generated NLG
 * @example {"code":"2000000,","message":"SUCCESS","data":{"handsFree":[{"dialogueId":"Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes","templates":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"parameters":{"Keyword":{"type":"system","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Capability":{"type":"vocab","vocabData":{"value":"temperature"},"systemData":null,"numberData":null,"anyData":null},"Value":{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"24 degrees and 30 degrees"},"anyData":null}}}],"handsOn":[{"dialogueId":"Rev_SamsungIoT_13_5_SetValue_GoalSuccessful_YesOrNo_Yes","templates":["Okay"],"parameters":{}}]}}
 */
export type DialogueNLGResponse = ApiSuccessResponse & {
  data?: {
    handsFree: Dialogue[];
    handsOn: Dialogue[];
  };
};

/** success response */
export interface ApiSuccessResponse {
  /**
   * detailed success code
   * @example 2000000
   */
  code: number;
  /**
   * success title
   * @example "SUCCESS"
   */
  message: string;
}

/** error response */
export interface ApiErrorResponse {
  /** detailed error code */
  code: number;
  /** error title */
  message: string;
  /** detailed error message */
  data?: string;
}

export interface ClientSubscription {
  /** The subscription id of the subscription. */
  subscriptionId?: ClientSubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: ClientSubscriptionFilters;
}

/**
 * The subscription id of the subscription.
 * @format uuid
 */
export type ClientSubscriptionId = string;

/** An array of subscription filters */
export type ClientSubscriptionFilters = ClientSubscriptionFilter[];

export interface ClientSubscriptionFilter {
  /** The type of filter */
  type?: ClientSubscriptionFilterTypes;
  /** An array of subscription filter values. */
  value?: ClientSubscriptionFilterValues;
  eventType?: ClientSubscriptionFilterEventTypes;
  attribute?: ClientSubscriptionFilterAttributes;
  capability?: ClientSubscriptionFilterCapabilities;
  component?: ClientSubscriptionFilterComponents;
}

/** The type of filter */
export enum ClientSubscriptionFilterTypes {
  LOCATIONIDS = 'LOCATIONIDS',
  DEVICEIDS = 'DEVICEIDS',
  INSTALLEDSMARTAPPIDS = 'INSTALLEDSMARTAPPIDS',
  SMARTAPPIDS = 'SMARTAPPIDS',
}

/** An array of subscription filter values. */
export type ClientSubscriptionFilterValues = string[];

export type ClientSubscriptionFilterEventTypes = string[];

export type ClientSubscriptionFilterAttributes = string[];

export type ClientSubscriptionFilterCapabilities = string[];

export type ClientSubscriptionFilterComponents = string[];

export interface ClientSubscriptionTarget {
  /** The address to send events to. */
  subscriptionTarget?: ClientSubscriptionTargetValue;
}

/**
 * The address to send events to.
 * @format uri
 */
export type ClientSubscriptionTargetValue = string;

/**
 * The subscription id of the subscription.
 * @format uuid
 */
export type SubscriptionId = string;

/** An array of subscription filters */
export type SubscriptionFilters = SubscriptionFilter[];

export interface SubscriptionFilter {
  /** The type of filter */
  type?: SubscriptionFilterTypes;
  /** An array of subscription filter values. */
  value?: SubscriptionFilterValues;
  eventType?: SubscriptionFilterEventTypes;
  attribute?: SubscriptionFilterAttributes;
  capability?: SubscriptionFilterCapabilities;
  component?: SubscriptionFilterComponents;
}

/** The type of filter */
export enum SubscriptionFilterTypes {
  LOCATIONIDS = 'LOCATIONIDS',
  DEVICEIDS = 'DEVICEIDS',
  INSTALLEDSMARTAPPIDS = 'INSTALLEDSMARTAPPIDS',
  SMARTAPPIDS = 'SMARTAPPIDS',
}

/** An array of subscription filter values. */
export type SubscriptionFilterValues = string[];

export type SubscriptionFilterEventTypes = string[];

export type SubscriptionFilterAttributes = string[];

export type SubscriptionFilterCapabilities = string[];

export type SubscriptionFilterComponents = string[];

export interface SubscriptionTarget {
  /** The address to send events to. */
  url?: SubscriptionTargetValue;
}

/**
 * The address to send events to.
 * @format uri
 */
export type SubscriptionTargetValue = string;

/** @example {"version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionRequest {
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface GetSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionRequest {
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** An empty object 200 response. */
export type DeleteSubscriptionResponse = object;

export interface RegisterSubscriptionRequest {
  subscriptionTarget?: SubscriptionTarget;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface RegisterSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

export interface Model1 {
  /** ID of the Capability. */
  capabilityId: string;
  /** Component used to include and group Capabilities in a Device Profile. */
  component: string;
  /** Value that is evaluated by `visibleCondition` against. */
  value: string;
  /** The way to compare capabilities. */
  operator:
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'EQUALS'
    | 'DOES_NOT_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_OR_EQUALS'
    | 'LESS_THAN'
    | 'LESS_THAN_OR_EQUALS'
    | 'ONE_OF';
  /** Attribute used to describe the state of a Capability and store its status */
  attribute: string;
}

export interface Model2 {
  label: string;
  po: string;
}

export interface Model3 {
  locale: string;
  poCodes?: PoCodeList[];
}

export interface QueryVersionOnServerParams {
  deviceType: string;
}

export interface ListConnectedServicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface ListDeviceStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** Limit status results to only include capabilities found in the capability query. */
  filterByCapabilities?: boolean;
}

export interface ListDeviceGroupStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * If present, only statuses for capabilties in this list will be returned.
   */
  capability?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface ListDeviceHealthByLocationIdParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface ListDeviceGroupsParams {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetCapabilityAttributeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The capability ID for the icon. */
  capabilityId: string;
  /** The attribute name for the icon. */
  attributeName: string;
}

export interface GetOcfDeviceTypeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The OCF Device Type for the icon. */
  ocfDeviceType: string;
}

export interface GetSceneIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The Scene key for the icon. */
  sceneIcon: string;
}

export interface GetOneuiIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The oneui icon key for the icon. */
  oneuiIcon: string;
  /** The oneui state for the icon. */
  oneuiIconState: string;
}

export interface ListInstalledAppSummariesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** A filter for only fetching apps of some types */
  appType?: ('SMARTAPP' | 'ENDPOINTAPP')[];
  /** If set to true, endpoint apps may include the allow list property */
  allowed?: boolean;
}

export interface UninstallInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface PauseInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface ResumeInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface OtaUpgradePayload {
  /**
   * URL of the OTA version to upgrade to
   * @example "http://version.broadlink.com/firmware/download/12345.bin"
   */
  url?: string;
}

export interface Link1 {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetSwatchesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The time stamp of the last partial response */
  since?: string;
}

export interface GetSwatchStatusesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetLocationSummaryParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetUiMetadataParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
}

export interface GetUiMetadataByDeviceIdParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
  /** The Device ID */
  deviceId: string;
}

export interface GetUiMetadataByMnmnVidParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
  mnmn: string;
  vid: string;
}

export interface GetUiMetadataDeviceVersionParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  mnmn: string;
  vid: string;
}

export interface GetDevicesByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** isaId of the user. */
  isaId: string;
}

export interface PutIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId */
  isaId: string;
}

export interface DeleteIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId of the user. */
  isaId: string;
}

export interface GetPagesParams {
  /** page type */
  type: string;
  /** location id of the user */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** SmartThings Schema App id */
  endpointAppId: string;
}

export type CreateWidgetFavoritesPayload = CreateSceneWidgetFavoriteRepresentation[];

export interface GetVoiceAssistantsParams {
  /**
   * Country code in ISO Alpha-2 format
   * @format [A-Z]{2}
   * @default "US"
   */
  country?: string;
}

export interface GetLocationWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateLocationWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface MigrateWallpapersParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRoomWallpapersParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRoomWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface UpdateRoomWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface GetGeolocationsByDeviceIdsParams {
  /** The device IDs of tracker to filter the results by. */
  deviceId: string[];
}

export interface GetTrackerGeolocationsParams {
  /**
   * Whether to fetch the latest location. Returns the latest location when this flag is `true`,
   * or time series data set based on paging parameters when it's `false`.
   * @default false
   */
  latest?: boolean;
  /**
   * The order to fetch the location based on stored time. It can be `desc` or `asc`.
   * This parameter is ignored if latest is `true`.
   * @default "desc"
   */
  order?: string;
  /**
   * The size of location to fetch. default limit is 100, max limit is 500.
   * This parameter is ignored if latest is `true`.
   * @default 100
   */
  limit?: number;
  /**
   * The key of the item where the operation stopped, inclusive of the previous result.
   * If offset is present in the previous response, you need to paginate the result set.
   * This parameter is ignored if latest is `true`.
   */
  offset?: string;
  /** Start time of the query. (epoch time in milliseconds) */
  startTime?: number;
  /** End time of the query. (epoch time in milliseconds) */
  endTime?: number;
  /**
   * Whether to summarize the geolocations data
   * If `isSummary=true`, each geolocation data has only `longitude`, `latitude`, `lastUpdateTime`.
   * If `isSummary=false`, return all data.
   * @default false
   */
  isSummary?: boolean;
  /**
   * a device ID of a tracker device
   * @format UUID
   */
  deviceId: string;
}

export interface GetLostmessagesByPrivacyIdsParams {
  /**
   * Privacy IDs advertised by tracker devices
   * @format Base64 URL Safe encoded (a string of pids seperated with comma, or a collection of individual pids using duplicate query parameters)
   */
  pid?: string;
  /**
   * service data advertised by tracker devices
   * @format Base64 URL Safe encoded (a string of service data seperated with comma, or a collection of individual service date using duplicate query parameters)
   */
  servicedata: string;
}

export interface GetTrackerLostMessageForQrRequestsParams {
  serialNumber: string;
  modelName: string;
  mnId: string;
  setupId: string;
}

export interface GetFirmwareDownloadUrlParams {
  /** Firmware type */
  type: 'PUBLIC' | 'TEST';
  /** Firmware version */
  version?: string;
  /** Tracker's device ID */
  deviceId: string;
}

export interface GetMontageTrackerImagesParams {
  /** client OS type */
  ostype: 'android' | 'ios';
}

export interface GetUtsConfigParams {
  /** client OS (if null then GALAXY as default) */
  brand?: 'GALAXY' | 'NON_GALAXY_ANDROID' | 'IOS';
}

export interface GetVendorFirmwareMetadataParams {
  mnid: string;
  setupid: string;
  firmwareversion: string;
}

export interface ListHowToUseParams {
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface ListNotificationParams {
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface GetHeroBannerUiMetaNewParams {
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId?: string;
  /** Content Slug Id */
  slug: string;
}

export interface ListHeroBannerParams {
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Type of HeroBanner */
  type?: 'air' | 'energy' | 'carrier' | 'labs';
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface ListPluginTipsParams {
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device?: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
  /**
   * App querying version.
   * Android app version for `other` device.
   * iOS app version for `ios` device.
   * Valid format `1.1.1``1.1.1.1`
   * @pattern /^\d+(?:\.\d+){2,3}$/
   */
  appVersion?: string;
  /** Get contents with certain state, by default will return published state */
  state?: 'draft' | 'requested' | 'published';
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Identifier for a manufacturer */
  deviceManufacturerCode: string;
  /** Identifier for a device */
  deviceModel: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
}

export interface ListPluginTipParams {
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device?: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
  /**
   * App querying version.
   * Android app version for `other` device.
   * iOS app version for `ios` device.
   * Valid format `1.1.1``1.1.1.1`
   * @pattern /^\d+(?:\.\d+){2,3}$/
   */
  appVersion?: string;
  /** Get contents with certain state, by default will return published state */
  state?: 'draft' | 'requested' | 'published';
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Identifier for a manufacturer */
  deviceManufacturerCode: string;
  /** Identifier for a device */
  deviceModel: string;
}

export interface ListPluginSupportParams {
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device?: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
  /**
   * App querying version.
   * Android app version for `other` device.
   * iOS app version for `ios` device.
   * Valid format `1.1.1` `1.1.1.1`
   * @pattern /^\d+(?:\.\d+){2,3}$/
   */
  appVersion?: string;
  /** Get contents with certain state, by default will return published state */
  state?: 'draft' | 'requested' | 'published';
  /** Type of device integration */
  deviceIntegrationType:
    | 'APP'
    | 'BLE'
    | 'BLE_D2D'
    | 'DTH'
    | 'ENDPOINT_APP'
    | 'GROUP'
    | 'HUB'
    | 'IR'
    | 'IR_OCF'
    | 'LAN'
    | 'MATTER'
    | 'MOBILE'
    | 'MQTT'
    | 'OCF'
    | 'PENGYOU'
    | 'SHP'
    | 'VIDEO'
    | 'VIPER'
    | 'VIRTUAL'
    | 'WATCH'
    | 'ZIGBEE'
    | 'ZWAVE'
    | 'EDGE_CLOUD';
  /** Identifier for a manufacturer */
  deviceManufacturerCode: string;
  /** Identifier for a device */
  deviceModel: string;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
}

export interface GetServiceStatusForStv2Params {
  /** @default "1234568-4110-268f-a1b4-123456" */
  di?: string[];
  /** @default "open_us" */
  pid?: string;
}

export interface GetOnboardingPageParams {
  /** Device name (SetupApp’s metadatadisplay name, translated name) */
  deviceName: string;
  /** Device type id (dt_sec_refrigerator, dt_sec_oven, ...) */
  deviceType: string;
  /** User country code (registration country of ST user) */
  countryCode: string;
  /** User language code (language set on the device) Format :{language_code}_{country_code} Example : ko_KR, en_US, pt_PT Language code : ISO 639-1 language code-ISO Country code : 3166 alpha-2 country Code */
  langcode: string;
  /** OS Type (ios, aos) */
  osType: string;
  /** mnId Ex:0AFD */
  mnId?: string;
  /** setup ID Ex:40+ */
  setupId?: string;
  /** PP List Ex:ppList=[{"ppId":"ppa_sec_refrigerator","ppVersion":"0.0.1","isAgree":false}] */
  ppList?: string;
}

export interface GetHintsDevicesParams {
  /** whether all hints are returned or not (by default, it is false) */
  showall?: boolean;
  /** whether device's alias name is included or not (by default, it is false) */
  includealias?: boolean;
}

export interface GetHintsDeviceParams {
  /** whether all hints are returned or not (by default, it is false) */
  showall?: boolean;
  /** whether device's alias name is included or not (by default, it is false) */
  includealias?: boolean;
  /** device ID */
  deviceId: string;
}

export interface GetHintsCapabilitiesParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** true or false. If this parameter value is true, voice intent list will be according to the capability. Default value is false */
  includevoiceintent?: string;
  /** true or false. If this parameter value is true, voice intent list with hints will be according to the capability. Default value is false */
  includehint?: boolean;
}

export interface GetHintsCapabilityParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** SmartThings capability name */
  stCapability: string;
}

export interface GetVoiceIntentListParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** The page number */
  page?: number;
  /** The number of voice intents in a page (by default, the limit size is 50) */
  limit?: string;
}

export interface GetVoiceIntentsParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** Voice Intent:(voice capability)-(voice action)-(voice enumeration) */
  voiceIntent: string;
}

export interface HintsAutomationcreationParams {
  /** location ID */
  locationId?: string;
}

export interface GetScenesParams {
  /** location ID */
  locationId?: string;
}

export interface GetDialoguesParams {
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration). It can be comma separated list. */
  voiceintent: string;
  /** source of dialogue, system or custom */
  origin: string;
  /** manufacturer name */
  mnmn: string;
  /** bixby invoke mode: handsOn or handsFree */
  mode: string;
}

export interface GetDialogueListParams {
  /** bixby invoke mode, handsOn or handsFree */
  mode?: string;
  /** source of dialogue, system or custom */
  origin?: string;
  /** manufacturer name */
  mnmn?: string;
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration) */
  voiceintent: string;
}

export interface GetVocabsParams {
  /** Name of Bixby vocabulary type */
  type?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 2.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV2Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  broadlink = {
    /**
     * No description
     *
     * @tags broadlink
     * @name GetDevType
     * @summary Get device types
     * @request GET:/broadlink/devtype
     */
    getDevType: (params: RequestParams = {}) =>
      this.request<DevTypes, any>({
        path: `/broadlink/devtype`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetBrand
     * @summary Get brands
     * @request GET:/broadlink/devtype/{devTypeId}/brand
     */
    getBrand: (devTypeId: string, params: RequestParams = {}) =>
      this.request<Brands, any>({
        path: `/broadlink/devtype/${devTypeId}/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetIrCode
     * @summary Get ircode info
     * @request GET:/broadlink/devtype/{devTypeId}/brand/{brandId}/ircode
     */
    getIrCode: (devTypeId: string, brandId: string, params: RequestParams = {}) =>
      this.request<IrCodes, any>({
        path: `/broadlink/devtype/${devTypeId}/brand/${brandId}/ircode`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetLocate
     * @summary Get location information
     * @request GET:/broadlink/location/{locationId}
     */
    getLocate: (locationId: string, params: RequestParams = {}) =>
      this.request<SubAreaInfo, any>({
        path: `/broadlink/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProvider
     * @summary Get provider info for a location
     * @request GET:/broadlink/location/{locationId}/provider
     */
    getProvider: (locationId: string, params: RequestParams = {}) =>
      this.request<Providers, any>({
        path: `/broadlink/location/${locationId}/provider`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProviderBrand
     * @summary Get full list of provider brands
     * @request GET:/broadlink/provider/brand
     */
    getProviderBrand: (params: RequestParams = {}) =>
      this.request<ProviderBrands, any>({
        path: `/broadlink/provider/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetChannel
     * @summary Get list of channels for a location and provider
     * @request GET:/broadlink/location/{locationId}/provider/{providerId}/channel
     */
    getChannel: (locationId: string, providerId: string, params: RequestParams = {}) =>
      this.request<Channels, any>({
        path: `/broadlink/location/${locationId}/provider/${providerId}/channel`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name MatchIrCode
     * @summary Match IR Code
     * @request GET:/broadlink/dnacode/{dnaCode}
     */
    matchIrCode: (dnaCode: string, params: RequestParams = {}) =>
      this.request<MatchIRCode, any>({
        path: `/broadlink/dnacode/${dnaCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name QueryVersionOnServer
     * @summary Query the OTA version on server
     * @request GET:/broadlink/ota/version/server
     */
    queryVersionOnServer: (query: QueryVersionOnServerParams, params: RequestParams = {}) =>
      this.request<OTAVersions, any>({
        path: `/broadlink/ota/version/server`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  connectedservices = {
    /**
     * @description Fetch a list of ConnectedServices
     *
     * @tags connectedservices
     * @name ListConnectedServices
     * @summary List Connected Services
     * @request GET:/connectedservices
     * @secure
     */
    listConnectedServices: (query: ListConnectedServicesParams, params: RequestParams = {}) =>
      this.request<ConnectedServiceSummary[], void>({
        path: `/connectedservices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the connected service for the given id. If there are only errored results, and at least one is not HTTP 403, throw an ApiException with the highest error code.
     *
     * @tags connectedservices
     * @name UninstallConnectedService
     * @summary Uninstall
     * @request DELETE:/connectedservices/{id}
     * @secure
     */
    uninstallConnectedService: (id: string, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/connectedservices/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of device statuses. If locationIds are provided, the list of Device statuses will be filtered to only those locations.
     *
     * @tags devices
     * @name ListDeviceStatuses
     * @summary Get a list of device statuses
     * @request GET:/devices/status
     * @secure
     */
    listDeviceStatuses: (query: ListDeviceStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceStatusPagedResult, ErrorResponse>({
        path: `/devices/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a paginated list of all device's health status.
     *
     * @tags devices
     * @name ListDeviceHealthByLocationId
     * @summary Get the health status of all devices
     * @request GET:/devices/health
     * @secure
     */
    listDeviceHealthByLocationId: (query: ListDeviceHealthByLocationIdParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: DeviceHealthResponse[];
          links?: Links;
        },
        ErrorResponse
      >({
        path: `/devices/health`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a list of device group statuses with optional filtering by location, capability and group type
     *
     * @tags devicegroups
     * @name ListDeviceGroupStatuses
     * @summary Get a list of device group statuses
     * @request GET:/devicegroups/status
     * @secure
     */
    listDeviceGroupStatuses: (query: ListDeviceGroupStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceGroupStatusPagedResult, ErrorResponse>({
        path: `/devicegroups/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of device groups
     *
     * @tags devicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/devicegroups
     * @secure
     */
    listDeviceGroups: (query: ListDeviceGroupsParams, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, ErrorResponse>({
        path: `/devicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group Upon group creation, the group type is decided based on the given input and the capabilities of the included devices; the resulting group type may not be what is passed in.
     *
     * @tags devicegroups
     * @name CreateDeviceGroup
     * @summary create a device group
     * @request POST:/devicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  icons = {
    /**
     * @description Fetch a capability icon given a capability and an attribute.
     *
     * @tags icons
     * @name GetCapabilityAttributeIcon
     * @summary Fetch a capability attribute icon
     * @request GET:/icons/capabilities/{capabilityId}/{attributeName}
     */
    getCapabilityAttributeIcon: (
      { capabilityId, attributeName, ...query }: GetCapabilityAttributeIconParams,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/icons/capabilities/${capabilityId}/${attributeName}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch an OCF Device Type Icon.
     *
     * @tags icons
     * @name GetOcfDeviceTypeIcon
     * @summary Fetch an OCF Device Type Icon
     * @request GET:/icons/ocfDeviceType/{ocfDeviceType}
     */
    getOcfDeviceTypeIcon: ({ ocfDeviceType, ...query }: GetOcfDeviceTypeIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/ocfDeviceType/${ocfDeviceType}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Scene Icon.
     *
     * @tags icons
     * @name GetSceneIcon
     * @summary Fetch a Scene Icon
     * @request GET:/icons/scenes/{sceneIcon}
     */
    getSceneIcon: ({ sceneIcon, ...query }: GetSceneIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/scenes/${sceneIcon}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Oneui Icon.
     *
     * @tags icons
     * @name GetOneuiIcon
     * @summary Fetch a Oneui Icon
     * @request GET:/icons/oneui/{oneuiIcon}/{oneuiIconState}
     */
    getOneuiIcon: ({ oneuiIcon, oneuiIconState, ...query }: GetOneuiIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/oneui/${oneuiIcon}/${oneuiIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  installedapps = {
    /**
     * @description Fetch a list of Installed App Summaries. This request combines results from the public API and legacy SmartApps
     *
     * @tags installedapps
     * @name ListInstalledAppSummaries
     * @summary List Installed App Summaries
     * @request GET:/installedapps
     * @secure
     */
    listInstalledAppSummaries: (query: ListInstalledAppSummariesParams, params: RequestParams = {}) =>
      this.request<InstalledAppSummary[], void>({
        path: `/installedapps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name UninstallInstalledApp
     * @summary Uninstall
     * @request DELETE:/installedapps/{installedAppId}
     * @secure
     */
    uninstallInstalledApp: ({ installedAppId, ...query }: UninstallInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Pause the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name PauseInstalledApp
     * @summary Pause
     * @request PUT:/installedapps/{installedAppId}/pause
     * @secure
     */
    pauseInstalledApp: ({ installedAppId, ...query }: PauseInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/pause`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resume the paused installed app for the given installedAppId
     *
     * @tags installedapps
     * @name ResumeInstalledApp
     * @summary Resume
     * @request PUT:/installedapps/{installedAppId}/resume
     * @secure
     */
    resumeInstalledApp: ({ installedAppId, ...query }: ResumeInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/resume`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  irdevices = {
    /**
     * @description List all of the parent and child devices filtered by logged in user
     *
     * @tags irdevices
     * @name ListIrDevices
     * @summary list devices
     * @request GET:/irdevices
     * @secure
     */
    listIrDevices: (params: RequestParams = {}) =>
      this.request<PagedIRDevices, ErrorResponse>({
        path: `/irdevices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new IR Blaster device.
     *
     * @tags irdevices
     * @name CreateIrDevice
     * @summary Create an IR Device
     * @request POST:/irdevices
     * @secure
     */
    createIrDevice: (createDevice: CreateIrDevice, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices`,
        method: 'POST',
        body: createDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the details of the device.
     *
     * @tags irdevices
     * @name GetIrDevice
     * @summary Get device details
     * @request GET:/irdevices/{deviceId}
     * @secure
     */
    getIrDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices/${deviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the device record. Examples include switching device profiles in response to capability changes, syncing and device supplied data.
     *
     * @tags irdevices
     * @name UpdateIrDevice
     * @summary Update an IR device
     * @request PUT:/irdevices/{deviceId}
     * @secure
     */
    updateIrDevice: (deviceId: string, updateDevice: IrUpdateRequest, params: RequestParams = {}) =>
      this.request<IrDevice, any>({
        path: `/irdevices/${deviceId}`,
        method: 'PUT',
        body: updateDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name DeleteIrDevice
     * @request DELETE:/irdevices/{deviceId}
     * @secure
     */
    deleteIrDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/irdevices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get all the children for a given device.
     *
     * @tags irdevices
     * @name GetIrDeviceChildren
     * @summary Get all the children for a given device
     * @request GET:/irdevices/{deviceId}/children
     * @secure
     */
    getIrDeviceChildren: (deviceId: string, params: RequestParams = {}) =>
      this.request<PagedIRChildDevices, ErrorResponse>({
        path: `/irdevices/${deviceId}/children`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name StudyIrCode
     * @summary Put an IR Device into a learning state
     * @request PUT:/irdevices/{parentDeviceId}/learning
     */
    studyIrCode: (parentDeviceId: string, enterLearningState: IrLearningRequest, params: RequestParams = {}) =>
      this.request<DeleteLocationResponse, any>({
        path: `/irdevices/${parentDeviceId}/learning`,
        method: 'PUT',
        body: enterLearningState,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name GetIrCode
     * @summary Get the IR Code that was just learned
     * @request GET:/irdevices/{parentDeviceId}/ircode/{childDevicePid}
     */
    getIrCode: (parentDeviceId: string, childDevicePid: string, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * IR Code
           * @example "260050...000"
           */
          code?: string;
        },
        any
      >({
        path: `/irdevices/${parentDeviceId}/ircode/${childDevicePid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Partial update of the values you want to update. Each value will be added to existing values.
     *
     * @tags irdevices
     * @name PatchDevice
     * @summary Partial update of a device's metadata and commands
     * @request PATCH:/irdevices/{childDeviceId}
     */
    patchDevice: (childDeviceId: string, body: DevicePatch, params: RequestParams = {}) =>
      this.request<DeleteLocationResponse, any>({
        path: `/irdevices/${childDeviceId}`,
        method: 'PATCH',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name ExecuteFunction
     * @summary Execute a function on a device
     * @request POST:/irdevices/{parentDeviceId}/control
     */
    executeFunction: (parentDeviceId: string, body: Function, params: RequestParams = {}) =>
      this.request<DeleteLocationResponse, any>({
        path: `/irdevices/${parentDeviceId}/control`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name QueryVersion
     * @summary Query the OTA version by Device
     * @request GET:/irdevices/{deviceId}/ota/version
     */
    queryVersion: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceOTAVersion, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name OtaUpgrade
     * @summary Upgrade the OTA Version
     * @request PUT:/irdevices/{deviceId}/ota/version
     */
    otaUpgrade: (deviceId: string, body: OtaUpgradePayload, params: RequestParams = {}) =>
      this.request<DeleteLocationResponse, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     *
     * @tags Locations
     * @name GetLocationUsers
     * @summary This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     * @request GET:/locations/{pathLocationId}/users
     * @secure
     */
    getLocationUsers: (pathLocationId: string, params: RequestParams = {}) =>
      this.request<LocationUsersResponse, any>({
        path: `/locations/${pathLocationId}/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description unshare location
     *
     * @tags locations
     * @name UnshareLocation
     * @summary Remove a user from a location
     * @request PUT:/locations/{pathLocationId}/users
     * @secure
     */
    unshareLocation: (pathLocationId: string, userToRemove: UserToRemove, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/locations/${pathLocationId}/users`,
        method: 'PUT',
        body: userToRemove,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  ocfdevicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags ocfdevicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/ocfdevicegroups
     * @secure
     */
    listDeviceGroups: (query: Link1, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group
     *
     * @tags ocfdevicegroups
     * @name CreateDeviceGroup
     * @summary Create a device group
     * @request POST:/ocfdevicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a device group command or get the status of a device group.
     *
     * @tags ocfdevicegroups
     * @name DeviceGroupCommandRequest
     * @summary Take OCF command or status request
     * @request POST:/ocfdevicegroups/request
     * @secure
     */
    deviceGroupCommandRequest: (executeDeviceGroupCommand: OcfDeviceGroupsCommandRequest, params: RequestParams = {}) =>
      this.request<OcfDeviceGroupsCommandResponse, void | Error>({
        path: `/ocfdevicegroups/request`,
        method: 'POST',
        body: executeDeviceGroupCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single device group by Id
     *
     * @tags ocfdevicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags ocfdevicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags ocfdevicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  strongman = {
    /**
     * @description Begin installation or update of an installed app. Returns the installed app and a `STAGED` configuration. The returned configuration has been initialized with either the current `AUTHORIZED` configuration, if available, or the most recent `DONE`/`STAGED` configuration. | The optional installedAppId (request body) will indicate whether to create a new installed app (without installedAppId) or edit an existing installed app (with installedAppId). Additionally, if the app is a singleton and an installed app already exists, a request without an installedAppId will be treated as an edit to the existing installed app.
     *
     * @tags Installedapps
     * @name InitializeInstall
     * @summary Begin installation or update of an installed app.
     * @request PUT:/strongman/installedapps/initialize
     * @secure
     */
    initializeInstall: (initializeRequest: InitializeRequest, params: RequestParams = {}) =>
      this.request<InitializeResponse, ErrorResponse>({
        path: `/strongman/installedapps/initialize`,
        method: 'PUT',
        body: initializeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancel installation or update of an installed app by revoking a `STAGED` configuration for an `AUTHORIZED` installed app, or deleting the installed app if it has not been `AUTHORIZED`.
     *
     * @tags Installedapps
     * @name CancelInstall
     * @summary Cancel installation or update of an installed app.
     * @request PUT:/strongman/installedapps/{installedAppId}/cancel
     * @secure
     */
    cancelInstall: (installedAppId: string, cancelRequest: CancelRequest, params: RequestParams = {}) =>
      this.request<CancelResponse, ErrorResponse>({
        path: `/strongman/installedapps/${installedAppId}/cancel`,
        method: 'PUT',
        body: cancelRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts the process of completing an Endpoint App installation. If the app is preauthorized, the configuration provided in the request will be marked as authorized and an install/update lifecycle event will be sent. The endpoint will respond with a JSON body containing message:"success". No further action is required. If the app is not preauthorized, a JSON response containing a URL to consigliere will be provided. This URL is used to confirm the permissions and will redirect to the strongman install/finalize endpoint to mark the configuration as authorized and send an install/update lifecycle event. The config sent in the request must not be null or empty.
     *
     * @tags strongman
     * @name InstallComplete
     * @summary Start the process of completing an Endpoint App installation.
     * @request POST:/strongman/install/complete
     * @secure
     */
    installComplete: (serviceInstallCompleteRequest: ServiceAppCompleteRequest, params: RequestParams = {}) =>
      this.request<ServiceAppCompleteResponse, Error | void>({
        path: `/strongman/install/complete`,
        method: 'POST',
        body: serviceInstallCompleteRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  swatches = {
    /**
     * @description Get a paginated list of DeviceSwatches that have been added, modified, or deleted since the provided time stamp. If `_links.next` is populated, clients must recursively fetch more results by calling the url exactly as specified until `_links.next` is not specified. Both `updated` and `deleted` are paginated so they must both be processed for all subsequent requests.
     *
     * @tags swatches
     * @name GetSwatches
     * @summary Get a partial list of DeviceSwatches
     * @request GET:/swatches
     * @secure
     */
    getSwatches: (query: GetSwatchesParams, params: RequestParams = {}) =>
      this.request<PartialDeviceSwatchResponse, ErrorResponse>({
        path: `/swatches`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of Swatch Statuses.
     *
     * @tags swatches
     * @name GetSwatchStatuses
     * @summary Get a paginated list of Swatch Statuses
     * @request GET:/swatches/status
     * @secure
     */
    getSwatchStatuses: (query: GetSwatchStatusesParams, params: RequestParams = {}) =>
      this.request<SwatchStatusPagedResult, ErrorResponse>({
        path: `/swatches/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  summary = {
    /**
     * @description Get a list of location summary cards
     *
     * @tags summary
     * @name GetLocationSummary
     * @summary Get a list of location summary cards
     * @request GET:/summary
     * @secure
     */
    getLocationSummary: (query: GetLocationSummaryParams, params: RequestParams = {}) =>
      this.request<WrappedMainCard[], void | ErrorResponse>({
        path: `/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the summary presentation definitions for static/dynamic cards
     *
     * @tags summary
     * @name GetSummaryPresentation
     * @summary Get the summary presentation definitions for static/dynamic cards
     * @request GET:/summary/presentation
     * @secure
     */
    getSummaryPresentation: (params: RequestParams = {}) =>
      this.request<SummaryPresentation, void | ErrorResponse>({
        path: `/summary/presentation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  uimetadata = {
    /**
     * @description Get UiMetadata for all devices in given location
     *
     * @tags uimetadata
     * @name GetUiMetadata
     * @summary Get UiMetadata for all devices in given location
     * @request GET:/uimetadata
     * @secure
     */
    getUiMetadata: (query: GetUiMetadataParams, params: RequestParams = {}) =>
      this.request<UiMetadata[], ErrorResponse>({
        path: `/uimetadata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata for given device id
     *
     * @tags uimetadata
     * @name GetUiMetadataByDeviceId
     * @summary Get UiMetadata for given device id
     * @request GET:/uimetadata/{deviceId}
     * @secure
     */
    getUiMetadataByDeviceId: ({ deviceId, ...query }: GetUiMetadataByDeviceIdParams, params: RequestParams = {}) =>
      this.request<UiMetadata, ErrorResponse>({
        path: `/uimetadata/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata for given mnmn and vid
     *
     * @tags uimetadata
     * @name GetUiMetadataByMnmnVid
     * @summary Get UiMetadata for given mnmn and vid
     * @request GET:/uimetadata/{mnmn}/{vid}
     * @secure
     */
    getUiMetadataByMnmnVid: ({ mnmn, vid, ...query }: GetUiMetadataByMnmnVidParams, params: RequestParams = {}) =>
      this.request<UiMetadata, ErrorResponse>({
        path: `/uimetadata/${mnmn}/${vid}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata device version info for given mnmn/vid
     *
     * @tags uimetadata
     * @name GetUiMetadataDeviceVersion
     * @summary Get UiMetadata device version info
     * @request GET:/uimetadata/{mnmn}/{vid}/version
     * @secure
     */
    getUiMetadataDeviceVersion: (
      { mnmn, vid, ...query }: GetUiMetadataDeviceVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<UiMetadataVersionData[], ErrorResponse>({
        path: `/uimetadata/${mnmn}/${vid}/version`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  viper = {
    /**
     * @description Get devices and app related info for the given isaId. If relogin is not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. If relogin is needed, the pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. Used by mobile
     *
     * @tags viper
     * @name GetDevicesByIsaId
     * @request GET:/viper/isa/{isaId}
     */
    getDevicesByIsaId: ({ isaId, ...query }: GetDevicesByIsaIdParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/isa/${isaId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates specified isaId related information.
     *
     * @tags viper
     * @name PutIsaByIsaId
     * @request PUT:/viper/isa/{isaId}
     */
    putIsaByIsaId: (
      { isaId, ...query }: PutIsaByIsaIdParams,
      PutIsaBody: PutIsaBody,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'PUT',
        query: query,
        body: PutIsaBody,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes specified isaId and associated devices with isaId.
     *
     * @tags viper
     * @name DeleteIsaByIsaId
     * @request DELETE:/viper/isa/{isaId}
     */
    deleteIsaByIsaId: ({ isaId, ...query }: DeleteIsaByIsaIdParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Gets installed SchemaApps for the specified locationId
     *
     * @tags viper
     * @name GetIsaByLocationId
     * @request GET:/viper/isa/location/{locationId}
     */
    getIsaByLocationId: (locationId: string, params: RequestParams = {}) =>
      this.request<LocationIsa, void>({
        path: `/viper/isa/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Requests page to start app install for the user. The pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. If the app is already installed and relogin in not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. Used by mobile app.
     *
     * @tags viper
     * @name GetPages
     * @request GET:/viper/pages/{endpointAppId}
     */
    getPages: ({ endpointAppId, ...query }: GetPagesParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/pages/${endpointAppId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  widget = {
    /**
     * @description Fetch a list of widget favorites to be displayed
     *
     * @tags widget
     * @name ListWidgetFavorites
     * @summary List widgetFavorites
     * @request GET:/widget/favorites
     * @secure
     */
    listWidgetFavorites: (params: RequestParams = {}) =>
      this.request<
        {
          items?: SceneWidgetFavoriteRepresentation[];
          links?: Links;
        },
        any
      >({
        path: `/widget/favorites`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the widget favorites.  Replaces all favorites that may have already been set and stores them in the provided order.
     *
     * @tags widget
     * @name CreateWidgetFavorites
     * @summary Create Widget Favorites
     * @request PUT:/widget/favorites
     * @secure
     */
    createWidgetFavorites: (createWidgetFavorites: CreateWidgetFavoritesPayload, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/widget/favorites`,
        method: 'PUT',
        body: createWidgetFavorites,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  migrate = {
    /**
     * @description Installs and authorizes an app given an appId, locationId, and configuration. If an existing install is found, will return a 409.
     *
     * @tags migrate
     * @name MigrateInstall
     * @summary Install and authorizes an app
     * @request POST:/migrate/install
     * @secure
     */
    migrateInstall: (migrationInstallRequest: MigrationInstallRequest, params: RequestParams = {}) =>
      this.request<InstallSummary, Error | void>({
        path: `/migrate/install`,
        method: 'POST',
        body: migrationInstallRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  preauthorize = {
    /**
     * @description Installs and authorizes a preauthorized app given an appId, locationId, and configuration. If the app is not preauthorized or an existing install is found, it will return a 409.
     *
     * @tags preauthorize
     * @name PreauthorizeInstall
     * @summary Install and authorizes a preauthorized app
     * @request POST:/preauthorize/install
     * @secure
     */
    preauthorizeInstall: (preauthorizeInstallRequest: InstallRequest, params: RequestParams = {}) =>
      this.request<InstallSummary, Error | void>({
        path: `/preauthorize/install`,
        method: 'POST',
        body: preauthorizeInstallRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  voiceassistants = {
    /**
     * @description Get Voice Assitant apps
     *
     * @tags voiceassistants
     * @name GetVoiceAssistants
     * @summary Get Voice Assistant apps
     * @request GET:/voiceassistants
     * @secure
     */
    getVoiceAssistants: (query: GetVoiceAssistantsParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: VoiceAssistantApp[];
          links?: Links;
        },
        any
      >({
        path: `/voiceassistants`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  wallpaper = {
    /**
     * @description Get wallpaper ID for a location
     *
     * @tags wallpaper
     * @name GetLocationWallpaper
     * @summary Get wallpaper ID for a location
     * @request GET:/wallpaper
     * @secure
     */
    getLocationWallpaper: (query: GetLocationWallpaperParams, params: RequestParams = {}) =>
      this.request<LocationWallpaper, void>({
        path: `/wallpaper`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update wallpaper ID for a location
     *
     * @tags wallpaper
     * @name UpdateLocationWallpaper
     * @summary Update wallpaper ID for a location
     * @request PUT:/wallpaper
     * @secure
     */
    updateLocationWallpaper: (
      query: UpdateLocationWallpaperParams,
      jsonBody: UpdateWallpaperBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/wallpaper`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Migrate wallpapers for a location
     *
     * @tags wallpaper
     * @name MigrateWallpapers
     * @summary migrate wallpapers for location and all rooms
     * @request POST:/wallpaper
     * @secure
     */
    migrateWallpapers: (
      query: MigrateWallpapersParams,
      jsonBody: MigrateWallpapersBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/wallpaper`,
        method: 'POST',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get wallpaper IDs for all rooms in a location
     *
     * @tags wallpaper
     * @name GetRoomWallpapers
     * @summary Get wallpaper IDs for all rooms in a location
     * @request GET:/wallpaper/rooms
     * @secure
     */
    getRoomWallpapers: (query: GetRoomWallpapersParams, params: RequestParams = {}) =>
      this.request<RoomWallpaper[], void>({
        path: `/wallpaper/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get wallpaper ID for a room
     *
     * @tags wallpaper
     * @name GetRoomWallpaper
     * @summary Get wallpaper ID for a room
     * @request GET:/wallpaper/rooms/{roomId}
     * @secure
     */
    getRoomWallpaper: ({ roomId, ...query }: GetRoomWallpaperParams, params: RequestParams = {}) =>
      this.request<RoomWallpaper, void>({
        path: `/wallpaper/rooms/${roomId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update wallpaper ID for a room
     *
     * @tags wallpaper
     * @name UpdateRoomWallpaper
     * @summary Update wallpaper ID for a room
     * @request PUT:/wallpaper/rooms/{roomId}
     * @secure
     */
    updateRoomWallpaper: (
      { roomId, ...query }: UpdateRoomWallpaperParams,
      jsonBody: UpdateWallpaperBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/wallpaper/rooms/${roomId}`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),
  };
  wallpapers = {
    /**
     * @description Get Wallpapers for all locations
     *
     * @tags wallpapers
     * @name GetLocationWallpapers
     * @summary Get wallpapers for all locations
     * @request GET:/wallpapers
     * @secure
     */
    getLocationWallpapers: (params: RequestParams = {}) =>
      this.request<LocationWallpaper[], any>({
        path: `/wallpapers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  identity = {
    /**
     * No description
     *
     * @tags identity
     * @name PostEasySetupBlob
     * @summary Generates encrypted blob for a given random value using public key of the device provided
     * @request POST:/identity/easysetup/blob
     * @secure
     */
    postEasySetupBlob: (Payload: EasySetupProvBlobReq, params: RequestParams = {}) =>
      this.request<RestResponseListEasySetupBlobRes, void>({
        path: `/identity/easysetup/blob`,
        method: 'POST',
        body: Payload,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  chaser = {
    /**
     * @description Get geolocation entries of multiple devices up to 20, based on a paramter `devicdId`. This api will return only the latest locations of devices.
     *
     * @tags chaser
     * @name GetGeolocationsByDeviceIds
     * @summary Get geolocations
     * @request GET:/chaser/geolocations
     * @secure
     */
    getGeolocationsByDeviceIds: (query: GetGeolocationsByDeviceIdsParams, params: RequestParams = {}) =>
      this.request<GetGeolocationsResponse, ErrorResponse>({
        path: `/chaser/geolocations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get geolocation entries of a device. If `latest=true`, server will return only the latest geolocation of a device. If `offset` is present in the response, you need to paginate the result set. If `offset` is empty, It means that there is no more data.
     *
     * @tags chaser
     * @name GetTrackerGeolocations
     * @summary Get a tracker's geolocations (History)
     * @request GET:/chaser/trackers/{deviceId}/geolocations
     * @secure
     */
    getTrackerGeolocations: ({ deviceId, ...query }: GetTrackerGeolocationsParams, params: RequestParams = {}) =>
      this.request<GetTrackerGeolocationResponse, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/geolocations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create geolocation entries of a device.
     *
     * @tags chaser
     * @name CreateTrackerGeolocations
     * @summary Create a tracker's geolocations
     * @request POST:/chaser/trackers/{deviceId}/geolocations
     * @secure
     */
    createTrackerGeolocations: (deviceId: string, data: CreateTrackerGeolocationsRequest, params: RequestParams = {}) =>
      this.request<CreateTrackerGeolocationsResponse, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/geolocations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete geolocation entries of a device.
     *
     * @tags chaser
     * @name DeleteTrackerGeolocations
     * @summary Delete a tracker's geolocation
     * @request DELETE:/chaser/trackers/{deviceId}/geolocations
     * @secure
     */
    deleteTrackerGeolocations: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/geolocations`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Inform the tag’s timer is synced with the value in the payload
     *
     * @tags chaser
     * @name UpdateTrackerTimer
     * @summary Update a tracker's synced datetime
     * @request PUT:/chaser/trackers/{deviceId}/timer
     * @secure
     */
    updateTrackerTimer: (deviceId: string, payload: UpdateTrackerTimerRequest, params: RequestParams = {}) =>
      this.request<UpdateTrackerTimerResponse, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/timer`,
        method: 'PUT',
        body: payload,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Searching Status list\r\n\r\n| searchingStatus | description |\r\ \n| --------------- | ----------- |\r\n| stop            | Initial status.\ \ it is updated when Onboarding or User action |\r\n| searching       | It\ \ is updated by User when device is lost                    |\r\n| spotted\ \         | It is updated when spotted by a nearby Galaxy device in searching\ \ status |
     *
     * @tags chaser
     * @name UpdateTrackerStatus
     * @summary Update a tracker's searching status
     * @request PUT:/chaser/trackers/{deviceId}/searchingstatus
     * @secure
     */
    updateTrackerStatus: (deviceId: string, body: TrackerSearchingStatusRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/searchingstatus`,
        method: 'PUT',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update tracker lost message
     *
     * @tags chaser
     * @name UpdateTrackerLostmessage
     * @summary Update tracker lost message
     * @request PUT:/chaser/trackers/{deviceId}/lostmessage
     * @secure
     */
    updateTrackerLostmessage: (deviceId: string, message: TrackerLostmessageInput, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/lostmessage`,
        method: 'PUT',
        body: message,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete tracker lost message
     *
     * @tags chaser
     * @name DeleteTrackerLostmessage
     * @summary Delete tracker lost message
     * @request DELETE:/chaser/trackers/{deviceId}/lostmessage
     * @secure
     */
    deleteTrackerLostmessage: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/lostmessage`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get lost messages of multiple devices up to 20, based on a paramter `privacyIds`. Server will return "Success" (200) unless it fails to process all the items.
     *
     * @tags chaser
     * @name GetLostmessagesByPrivacyIds
     * @summary Get tracker lost messages
     * @request GET:/chaser/lostmessages
     * @secure
     */
    getLostmessagesByPrivacyIds: (query: GetLostmessagesByPrivacyIdsParams, params: RequestParams = {}) =>
      this.request<LostmessageResponseForBatchRequests, ErrorResponse>({
        path: `/chaser/lostmessages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description API for onboarding module to check if the tracker is onboarded
     *
     * @tags chaser
     * @name GetTrackerLostMessageForQrRequests
     * @summary Get a tracker's lost message by serial, model name, mnID, setupID
     * @request GET:/chaser/trackers/lostmessage
     * @deprecated
     * @secure
     */
    getTrackerLostMessageForQrRequests: (query: GetTrackerLostMessageForQrRequestsParams, params: RequestParams = {}) =>
      this.request<LostmessageResponseForQrRequests, ErrorResponse>({
        path: `/chaser/trackers/lostmessage`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update tracker connection option
     *
     * @tags chaser
     * @name UpdateTrackerConnectionOption
     * @summary Update tracker connection option
     * @request PUT:/chaser/trackers/{deviceId}/connectionoption
     * @deprecated
     * @secure
     */
    updateTrackerConnectionOption: (
      deviceId: string,
      connectionOption: TrackerConnectionOption,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/connectionoption`,
        method: 'PUT',
        body: connectionOption,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update tracker firmware information
     *
     * @tags chaser
     * @name UpdateTrackerFirmwareInfo
     * @summary Update tracker firmware information
     * @request PUT:/chaser/trackers/{deviceId}/firmware
     * @secure
     */
    updateTrackerFirmwareInfo: (deviceId: string, firmware: TrackerFirmwareInput, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/firmware`,
        method: 'PUT',
        body: firmware,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get firmware download URL of specific device model & version
     *
     * @tags chaser
     * @name GetFirmwareDownloadUrl
     * @summary Get firmware download URL of specific device model & version
     * @request GET:/chaser/trackers/{deviceId}/firmware/url
     * @secure
     */
    getFirmwareDownloadUrl: ({ deviceId, ...query }: GetFirmwareDownloadUrlParams, params: RequestParams = {}) =>
      this.request<FirmwareUrlResponse, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/firmware/url`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Anonymous Session Key
     *
     * @tags chaser
     * @name CreateSessionKey
     * @summary Create Anonymous Session Key
     * @request POST:/chaser/sessionkey/global
     * @secure
     */
    createSessionKey: (body: CreateSessionKeyRequest, params: RequestParams = {}) =>
      this.request<CreateSessionKeyResponse, ErrorResponse>({
        path: `/chaser/sessionkey/global`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve Tracker Image URLs
     *
     * @tags chaser
     * @name GetMontageTrackerImages
     * @summary Retrieve Tracker Image URLs
     * @request POST:/chaser/images/vendor/retrieves/global
     * @secure
     */
    getMontageTrackerImages: (
      query: GetMontageTrackerImagesParams,
      body: GetTrackerImagesRequest,
      params: RequestParams = {},
    ) =>
      this.request<GetTrackerImagesResponse, ErrorResponse>({
        path: `/chaser/images/vendor/retrieves/global`,
        method: 'POST',
        query: query,
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chaser
     * @name GetUtsConfig
     * @summary Get user's UTS config
     * @request GET:/chaser/utsconfig
     * @secure
     */
    getUtsConfig: (query: GetUtsConfigParams, params: RequestParams = {}) =>
      this.request<UtsConfigResponse, ErrorResponse>({
        path: `/chaser/utsconfig`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a tracker's fmmsearch option
     *
     * @tags chaser
     * @name UpdateTrackerFmmSearch
     * @summary Update a tracker's fmmsearch option
     * @request PUT:/chaser/trackers/{deviceId}/fmmsearch
     * @secure
     */
    updateTrackerFmmSearch: (deviceId: string, body: UpdateFmmSearchRequest, params: RequestParams = {}) =>
      this.request<UpdateFmmSearchResponse, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/fmmsearch`,
        method: 'PUT',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description get vendor firmware metadata
     *
     * @tags chaser
     * @name GetVendorFirmwareMetadata
     * @summary get vendor firmware metadata
     * @request GET:/chaser/vendor/firmware/metadata
     * @secure
     */
    getVendorFirmwareMetadata: (query: GetVendorFirmwareMetadataParams, params: RequestParams = {}) =>
      this.request<GetVendorFirmwareMetadataResponse, ErrorResponse>({
        path: `/chaser/vendor/firmware/metadata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a tracker's metadata values ("firmwareVersion"|"firmwareSpecVersion"|"ooTime"|"tagPidPoolSize"|"timer"|"psm").
     *
     * @tags chaser
     * @name UpdateTrackerMetadata
     * @summary update tracker's metadata
     * @request PATCH:/chaser/trackers/{deviceId}/metadata
     * @secure
     */
    updateTrackerMetadata: (deviceId: string, body: UpdateTrackerMetadataRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/metadata`,
        method: 'PATCH',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  gettingstarted = {
    /**
     * @description List HowToUse contents.
     *
     * @tags HowToUse
     * @name ListHowToUse
     * @summary List HowToUse
     * @request GET:/gettingstarted/howtouselist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listHowToUse: (
      { appVersion, countryId, lngId, device, ...query }: ListHowToUseParams,
      params: RequestParams = {},
    ) =>
      this.request<ListHowToUseResponse, ErrorResponse>({
        path: `/gettingstarted/howtouselist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Notification contents.
     *
     * @tags Notification
     * @name ListNotification
     * @summary List Notifications
     * @request GET:/gettingstarted/notificationslist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listNotification: (
      { appVersion, countryId, lngId, device, ...query }: ListNotificationParams,
      params: RequestParams = {},
    ) =>
      this.request<ListNotificationResponse, ErrorResponse>({
        path: `/gettingstarted/notificationslist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get HeroBanner UI-metadata in JSON.
     *
     * @tags HeroBanner
     * @name GetHeroBannerUiMetaNew
     * @summary New UIMeta HeroBanner
     * @request GET:/gettingstarted/herobanner/uimeta/{slug}
     */
    getHeroBannerUiMetaNew: ({ slug, ...query }: GetHeroBannerUiMetaNewParams, params: RequestParams = {}) =>
      this.request<HeroBannerUIMeta, ErrorResponse>({
        path: `/gettingstarted/herobanner/uimeta/${slug}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List HeroBanner contents.
     *
     * @tags HeroBanner
     * @name ListHeroBanner
     * @summary List HeroBanners
     * @request GET:/gettingstarted/herobannerlist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listHeroBanner: (
      { appVersion, countryId, lngId, device, ...query }: ListHeroBannerParams,
      params: RequestParams = {},
    ) =>
      this.request<ListHeroBannerResponse, ErrorResponse>({
        path: `/gettingstarted/herobannerlist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  nexo = {
    /**
     * @description Update D2D token of shp device
     *
     * @tags shpdevices
     * @name UpdateShpDevicesToken
     * @summary Update D2D token of shp device
     * @request POST:/nexo/shpdevices/{deviceId}/token
     * @secure
     */
    updateShpDevicesToken: (deviceId: string, body: SetShpDevicesTokenRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nexo/shpdevices/${deviceId}/token`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get D2D token of shp device
     *
     * @tags shpdevices
     * @name GetShpDevicesToken
     * @summary Get D2D token of shp device
     * @request GET:/nexo/shpdevices/{deviceId}/token
     * @secure
     */
    getShpDevicesToken: (deviceId: string, params: RequestParams = {}) =>
      this.request<GetShpDevicesTokenResponse, void | ErrorResponse>({
        path: `/nexo/shpdevices/${deviceId}/token`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Ownership transfer
     *
     * @tags shpdevices
     * @name OwnershipTransfer
     * @summary Ownership transfer
     * @request POST:/nexo/shpdevices/{deviceId}/transfer
     * @secure
     */
    ownershipTransfer: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nexo/shpdevices/${deviceId}/transfer`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get SHP device existence
     *
     * @tags shpdevices
     * @name GetShpDevicesExistence
     * @summary Get SHP device existence
     * @request GET:/nexo/shpdevices/{deviceId}
     * @secure
     */
    getShpDevicesExistence: (deviceId: string, params: RequestParams = {}) =>
      this.request<GetShpDevicesExistenceResponse, ErrorResponse>({
        path: `/nexo/shpdevices/${deviceId}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Provisioning onboarding information for easysetup 2.0
     *
     * @tags auth
     * @name AddOnboardingInformation
     * @summary Provisioning onboarding information for easysetup 2.0
     * @request POST:/nexo/auth/provisioning
     * @secure
     */
    addOnboardingInformation: (onboardingInfoRequest: OnboardingInfoRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nexo/auth/provisioning`,
        method: 'POST',
        body: onboardingInfoRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  iot = {
    /**
     * No description
     *
     * @tags key-value-controller
     * @name GetAllKeyValueUsingGet
     * @summary getAllKeyValue
     * @request GET:/iot/locksmith/keyval
     * @secure
     */
    getAllKeyValueUsingGet: (params: RequestParams = {}) =>
      this.request<RestResponseListString, void>({
        path: `/iot/locksmith/keyval`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags key-value-controller
     * @name GetKeyValueUsingGet
     * @summary getKeyValue
     * @request GET:/iot/locksmith/keyval/{key}
     * @secure
     */
    getKeyValueUsingGet: (key: string, params: RequestParams = {}) =>
      this.request<RestResponseJsonNode, void>({
        path: `/iot/locksmith/keyval/${key}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  connect = {
    /**
     * @description List Plugin Tip contents.
     *
     * @tags PluginTips
     * @name ListPluginTips
     * @summary List Plugin Tip
     * @request GET:/connect/plugintip/gettiplist/{deviceIntegrationType}/{deviceManufacturerCode}/{deviceModel}/{countryId}/{lngId}
     */
    listPluginTips: (
      { deviceIntegrationType, deviceManufacturerCode, deviceModel, lngId, countryId, ...query }: ListPluginTipsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPluginTipResponse, ErrorResponse>({
        path: `/connect/plugintip/gettiplist/${deviceIntegrationType}/${deviceManufacturerCode}/${deviceModel}/${countryId}/${lngId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Plugin Tip contents.
     *
     * @tags PluginTips
     * @name ListPluginTip
     * @summary List Plugin Tip
     * @request GET:/connect/plugintip/gettiplist/{deviceIntegrationType}/{deviceManufacturerCode}/{deviceModel}
     */
    listPluginTip: (
      { deviceIntegrationType, deviceManufacturerCode, deviceModel, ...query }: ListPluginTipParams,
      params: RequestParams = {},
    ) =>
      this.request<ListTipsResponse, ErrorResponse>({
        path: `/connect/plugintip/gettiplist/${deviceIntegrationType}/${deviceManufacturerCode}/${deviceModel}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Plugin Support contents.
     *
     * @tags PluginSupport
     * @name ListPluginSupport
     * @summary List Plugin Support
     * @request GET:/connect/pluginsupport/getpluginsupportlist/{deviceIntegrationType}/{deviceManufacturerCode}/{deviceModel}/{countryId}
     */
    listPluginSupport: (
      { deviceIntegrationType, deviceManufacturerCode, deviceModel, countryId, ...query }: ListPluginSupportParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPluginSupportResponse, ErrorResponse>({
        path: `/connect/pluginsupport/getpluginsupportlist/${deviceIntegrationType}/${deviceManufacturerCode}/${deviceModel}/${countryId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  amigo = {
    /**
     * No description
     *
     * @tags PartnerController
     * @name GetV2ActivationUrl
     * @summary getV2ActivationUrl
     * @request POST:/amigo/partners/activationurl
     */
    getV2ActivationUrl: (body: ActivationUrlRequest, params: RequestParams = {}) =>
      this.request<ActivationUrlResponse, RestResponse>({
        path: `/amigo/partners/activationurl`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PartnerController
     * @name GetV2ManagementUrl
     * @summary getV2ManagementUrl
     * @request POST:/amigo/partners/managementurl
     */
    getV2ManagementUrl: (body: ActivationUrlRequest, params: RequestParams = {}) =>
      this.request<ActivationUrlResponse, RestResponse>({
        path: `/amigo/partners/managementurl`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags StRequestController
     * @name GetServiceStatusForStv2
     * @summary getServiceStatusForSTV2
     * @request GET:/amigo/st/request/partnerStatus
     */
    getServiceStatusForStv2: (query: GetServiceStatusForStv2Params, params: RequestParams = {}) =>
      this.request<PartnerStatusV2Response, RestResponse>({
        path: `/amigo/st/request/partnerStatus`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  eula = {
    /**
     * @description Get country - region - language map
     *
     * @tags eula
     * @name GetLanguageMap
     * @request GET:/eula/legal/langs.json
     */
    getLanguageMap: (params: RequestParams = {}) =>
      this.request<
        {
          /** Region, language codes map for specific coutnry */
          '{countryCode}': Country;
        },
        void
      >({
        path: `/eula/legal/langs.json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get plugin information list (It will be deprecated after 2020 R5 release)
     *
     * @tags eula
     * @name GetPluginList
     * @request GET:/eula/legal/plugins.json
     */
    getPluginList: (params: RequestParams = {}) =>
      this.request<
        {
          latest: Plugin[];
        },
        void
      >({
        path: `/eula/legal/plugins.json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get version map of services
     *
     * @tags eula
     * @name GetVersionMap
     * @request GET:/eula/legal/{countryCode}/index.json
     */
    getVersionMap: (countryCode: string, params: RequestParams = {}) =>
      this.request<
        {
          latest: ServiceVersion[];
        },
        void
      >({
        path: `/eula/legal/${countryCode}/index.json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get PP map of device types
     *
     * @tags eula
     * @name GetDevicePpMap
     * @request GET:/eula/legal/{countryCode}/devices.json
     */
    getDevicePpMap: (countryCode: string, params: RequestParams = {}) =>
      this.request<
        {
          /** Device type (dt_sec_air_conditioner / dt_sec_air_purifier) */
          '{devicType}': DevicePP[];
        },
        void
      >({
        path: `/eula/legal/${countryCode}/devices.json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get PP html of region default language. Application should use this, if user use unsupported language.
     *
     * @tags eula
     * @name GetRegionDefaultLanguagePp
     * @request GET:/eula/legal/{region}/default/*.html
     */
    getRegionDefaultLanguagePp: (region: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/eula/legal/${region}/default/*.html`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Get PP html of specific language.
     *
     * @tags eula
     * @name GetRegionLanguagePp
     * @request GET:/eula/legal/{region}/{languageCode}/*.html
     */
    getRegionLanguagePp: (region: string, languageCode: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/eula/legal/${region}/${languageCode}/*.html`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Page when onboard device in ST App.
     *
     * @tags onboarding
     * @name GetOnboardingPage
     * @request GET:/eula/onboarding/
     */
    getOnboardingPage: (query: GetOnboardingPageParams, params: RequestParams = {}) =>
      this.request<OnBoardingGetResponse, void>({
        path: `/eula/onboarding/`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  bixby = {
    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetHintsDevices
     * @summary Retrieve hints for all devices in user account
     * @request GET:/bixby/hints/devices
     */
    getHintsDevices: (query: GetHintsDevicesParams, params: RequestParams = {}) =>
      this.request<HintsForDevicesResponse, void | ApiErrorResponse>({
        path: `/bixby/hints/devices`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetHintsDevice
     * @summary Retreive hints for specific device in user account
     * @request GET:/bixby/hints/devices/{deviceId}
     */
    getHintsDevice: ({ deviceId, ...query }: GetHintsDeviceParams, params: RequestParams = {}) =>
      this.request<HintsForDeviceResponse, ApiErrorResponse>({
        path: `/bixby/hints/devices/${deviceId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetHintsCapabilities
     * @summary Retreive hints which support ST capability
     * @request GET:/bixby/hints/capabilities
     */
    getHintsCapabilities: (query: GetHintsCapabilitiesParams, params: RequestParams = {}) =>
      this.request<HintsForcapabilitiesIncludehintResponse, ApiErrorResponse>({
        path: `/bixby/hints/capabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetHintsCapability
     * @summary Retreive hints for specific SmartThings capability
     * @request GET:/bixby/hints/capabilities/{STCapability}
     */
    getHintsCapability: ({ stCapability, ...query }: GetHintsCapabilityParams, params: RequestParams = {}) =>
      this.request<HintsForCapabilityResponse, ApiErrorResponse>({
        path: `/bixby/hints/capabilities/${stCapability}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetVoiceIntentList
     * @summary Retreive hints for all voice intents
     * @request GET:/bixby/hints/voiceintents
     */
    getVoiceIntentList: (query: GetVoiceIntentListParams, params: RequestParams = {}) =>
      this.request<HintsForVoiceIntentsResponse, ApiErrorResponse>({
        path: `/bixby/hints/voiceintents`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetVoiceIntents
     * @summary Retreive hints for specific voice intent
     * @request GET:/bixby/hints/voiceintents/{voiceIntent}
     */
    getVoiceIntents: ({ voiceIntent, ...query }: GetVoiceIntentsParams, params: RequestParams = {}) =>
      this.request<HintsForVoiceIntentResponse, ApiErrorResponse>({
        path: `/bixby/hints/voiceintents/${voiceIntent}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name HintsAutomationcreation
     * @summary Retreive automation hints for devices
     * @request GET:/bixby/hints/automationcreation
     */
    hintsAutomationcreation: (query: HintsAutomationcreationParams, params: RequestParams = {}) =>
      this.request<HintsForAutomationCreationResponse, ApiErrorResponse>({
        path: `/bixby/hints/automationcreation`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetLocations
     * @summary Retreive hints for ST app related commands and the location or room related commands
     * @request GET:/bixby/hints/locations
     */
    getLocations: (params: RequestParams = {}) =>
      this.request<HintsForLocationsResponse, ApiErrorResponse>({
        path: `/bixby/hints/locations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetLocation
     * @summary Retreive  hints for ST app related commands and the location or room related commands for a specific location
     * @request GET:/bixby/hints/locations/{locationId}
     */
    getLocation: (locationId: string, params: RequestParams = {}) =>
      this.request<HintsForLocationResponse, ApiErrorResponse>({
        path: `/bixby/hints/locations/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetScenes
     * @summary Retreive hints for scenes
     * @request GET:/bixby/hints/scenes
     */
    getScenes: (query: GetScenesParams, params: RequestParams = {}) =>
      this.request<HintsForScenesResponse, ApiErrorResponse>({
        path: `/bixby/hints/scenes`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixbyhints
     * @name GetScene
     * @summary Retreive hints for scene
     * @request GET:/bixby/hints/scenes/{sceneID}
     */
    getScene: (sceneId: string, params: RequestParams = {}) =>
      this.request<HintsForSceneResponse, ApiErrorResponse>({
        path: `/bixby/hints/scenes/${sceneId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogueNlg
     * @summary Make NLG with dialogue template and parameters
     * @request POST:/bixby/nlgs
     */
    getDialogueNlg: (requestBody: DialogueNLGRequest, params: RequestParams = {}) =>
      this.request<DialogueNLGResponse, ApiErrorResponse>({
        path: `/bixby/nlgs`,
        method: 'POST',
        body: requestBody,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogues
     * @summary Retreive dialogue list
     * @request GET:/bixby/dialogues
     */
    getDialogues: (query: GetDialoguesParams, params: RequestParams = {}) =>
      this.request<DialogueListResponse, ApiErrorResponse>({
        path: `/bixby/dialogues`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogueInfo
     * @summary Retreive dialogue
     * @request GET:/bixby/dialogues/{dialogueId}
     */
    getDialogueInfo: (dialogueId: string, params: RequestParams = {}) =>
      this.request<DialogueResponse, ApiErrorResponse>({
        path: `/bixby/dialogues/${dialogueId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogueList
     * @summary Retreive dialogue for the specific voice intent
     * @request GET:/bixby/dialogues/voiceintents/{voiceintent}
     */
    getDialogueList: ({ voiceintent, ...query }: GetDialogueListParams, params: RequestParams = {}) =>
      this.request<DialoguesForVoiceIntentResponse, ApiErrorResponse>({
        path: `/bixby/dialogues/voiceintents/${voiceintent}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags vocabularies
     * @name GetVocabs
     * @summary Retreive human readable words
     * @request GET:/bixby/vocabularies
     */
    getVocabs: (query: GetVocabsParams, params: RequestParams = {}) =>
      this.request<VocabsDataResponse, ApiErrorResponse>({
        path: `/bixby/vocabularies`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
}
